/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Long: any;
};

export type Query = {
  __typename?: 'Query';
  acceptedReferralV2: AcceptedReferralResultV2;
  account?: Maybe<Account>;
  accounts: Array<Account>;
  activationCodeQuery: ActivationCodeValidation;
  activationsReport: ActivationsReportResponse;
  adminActivationCodes: Array<ActivationCode>;
  adminConfigurationNetwork?: Maybe<ConfigurationNetwork>;
  allBoards: Array<Board>;
  apiCredential: ApiCredential;
  apiCredentials: Array<ApiCredential>;
  board: Board;
  boards: Array<Board>;
  boardScheduledMessageV2: ScheduledMessageResultV2;
  boardsReport: BoardsReportOutput;
  boardStyles: Array<BoardStyle>;
  /** @deprecated Use listBoardsV2 instead */
  BoardsV2: ListBoards;
  /** @deprecated Use getBoardV2 instead */
  BoardV2: BoardResultV2;
  cadenceToCronV2: CadenceToCronResultV2;
  characterSets: Array<GqlCharacterSet>;
  colorTemplate: ColorTemplate;
  colorTemplateCategories: Array<ColorTemplateCategory>;
  colorTemplateCategory: ColorTemplateCategory;
  colorTemplates: Array<ColorTemplate>;
  colorTemplatesLength: Scalars['Int'];
  /** @deprecated Use templateCategory instead */
  colorTemplateV2: ColorTemplateResultV2;
  configurationNetwork?: Maybe<ConfigurationNetwork>;
  conflictingSubscriptionsV2: ConflictingSubscriptionsV2;
  contract: Contract;
  countDistinctSearchMessagesV2: SearchDistinctByResultV2;
  countries: Array<Country>;
  countSearchMessagesV2: Scalars['Int'];
  customer: Customer;
  customers: PaginatedCustomerResponse;
  dashboard: DashboardResponse;
  developer: Developer;
  developers: Array<Developer>;
  device: Device;
  deviceByPairingCode: Device;
  deviceModels: Array<GqlDeviceModel>;
  devices: DeviceQueryResponse;
  devicesByGmtOffset: Array<GqlGmtOffsetDevices>;
  devicesByGmtOffsetAndYoctoStatus: Array<Device>;
  featuredMarketplaceChannel?: Maybe<FeaturedMarketplaceItem>;
  featuredMarketplaceListings: Array<FeaturedMarketplaceItem>;
  feedItemV2: FeedItemResultV2;
  feedTagV2: FeedTagResultV2;
  firmwareUpgradeModal: FirmwareUpgradeModalResponse;
  flagshipDeviceV2: FlagshipDeviceResultV2;
  getBlendedV2: BlendedResultV2;
  getBoardV2: BoardResultV2;
  getDisplayGroupV2: DisplayGroupResultV2;
  getMasterPairingV2: MasterPairingResultV2;
  getMessageSetVersionV2: MessageSetVersionResultV2;
  /** Get search term analytics for a specific term */
  getSearchTermV2: SearchTermAnalyticsV2;
  homeScreenBannersV2: Array<HomeScreenBannerV2>;
  homeScreenBannerV2: HomeScreenBannerResultV2;
  installable: Installable;
  installableCategories: Array<InstallableCategory>;
  installables: Array<Installable>;
  installableV2: InstallableResultV2;
  installation: Installation;
  languages: Array<GqlLanguage>;
  listAcceptedReferralsV2: ListAcceptedReferrals;
  listBoardDeviceAssociations: PaginatedBoardDeviceAssociations;
  listBoardMessageAppearancesV2: ListMessageAppearancesV2;
  listBoardsV2: ListBoards;
  /** @deprecated Use listTemplateCategories instead */
  listColorTemplatesV2: ListColorTemplateV2;
  listDealAssociationsV2: ListDealAssociationsV2;
  listDigitalDeviceStyles: ListDigitalDeviceStylesV2;
  listDigitalDevicesV2: ListDigitalDevicesV2;
  listDisplayGroupsV2: ListDisplayGroups;
  listFavoriteSourcesV2: ListFavoriteSourcesV2;
  listFeedItemsV2: ListFeedItemsV2;
  listFeedTagsV2: ListFeedTagsV2;
  listFlaggedFeedItemsByPersonV2: ListFeedItemFlagsV2;
  listFlaggedFeedItemsV2: ListFeedItemFlagsV2;
  listFlaggedMessagesByPersonV2: ListFlagsV2;
  listFlaggedMessagesV2: ListFlagsV2;
  listFlagshipDevicesV2: ListFlagshipDevices;
  listingsReport: ListingReportResponse;
  listInspirationV2: ListInspirationV2;
  listInstallablesV2: ListInstallables;
  listMarketplaceCategoriesV2: ListMarketplaceCategories;
  listMarketplaceFeatureTypesV2: ListMarketplaceFeatureTypes;
  listMarketplaceListings: PaginatedMarketplaceListings;
  listMarketplaceListingsV2: ListMarketplaceListings;
  listMasterPairingsV2: ListMasterPairingsV2;
  listMessageSetsV2: ListMessageSetV2;
  listMessageSetVersionsV2: ListMessageSetVersionV2;
  listMessageSourcesV2: ListMessageSourcesV2;
  listNotificationSegmentsV2: ListNotificationSegments;
  listNotificationSubscribersV2: ListNotificationSubscribers;
  listNotificationsV2: ListNotifications;
  listNotificationTagsV2: ListNotificationTags;
  listPersonDraftsV2: ListDraftsV2;
  listPersonFavoritesV2: ListFavoritesV2;
  listPersonLikesV2: ListLikesV2;
  listPersonsV2: ListPersons;
  listPickCategoriesV2: ListPickCategoriesV2;
  listPlusRenewalErrors: PaginatedPlusRenewalFailures;
  listPurchases: PaginatedPurchases;
  listRolesV2: ListRoles;
  listScheduledNotificationsV2: ListScheduledNotifications;
  listSearchMessagesV2: ListSearchMessagesUnionV2;
  listSubmittedMessageSetsV2: ListSubmittedMessageSets;
  listSystemMessageTemplatesV2: ListSystemMessageTemplatesV2;
  listTemplateCategoriesV2: ListTemplateCategoriesV2;
  listTemplateMessageSuggestionsV2: ListTemplateMessageSuggestionsV2;
  listTemplateMessagesV2: ListTemplateMessagesV2;
  listTodaysPicksV2: ListPicksV2;
  listTopSearchTermsV2: ListSearchTermAnalyticsV2;
  marketplaceCategoryV2: MarketplaceCategoryResultV2;
  marketplaceFeatureTypeV2: MarketplaceFeatureTypeResultV2;
  marketplaceGalleryV2: MarketplaceGalleryResultV2;
  marketplaceListing: MarketplaceListing;
  marketplaceListingFeatureType: MarketplaceListingFeatureType;
  marketplaceListingFeatureTypes: Array<MarketplaceListingFeatureType>;
  /** @deprecated Use searchMarketPlaceListings */
  marketplaceListings: Array<MarketplaceListing>;
  marketplaceListingsCategories: Array<InstallableCategory>;
  marketplaceListingsCategory: InstallableCategory;
  marketplaceListingV2: MarketplaceListingResultV2;
  message: Message;
  messageAnalyticsV2: MessageAnalyticsV2;
  messageAppearance: MessageAppearance;
  messageAppearancesMigrationStateV2: MessageAppearanceMigrateV2;
  messageAppearanceV2: MessageAppearanceResultV2;
  messageSet: MessageSet;
  messageSets: Array<MessageSet>;
  messageSetV2: MessageSetResultV2;
  messageSetVersion: MessageSetVersion;
  messageSetVersionSubmissions: Array<GqlMessageSetVersionSubmission>;
  messageShareToken: GqlMessageShareToken;
  messageV2: MessageResultV2;
  notificationSegmentV2: NotificationSegmentResultV2;
  notificationTagV2: NotificationTagResultV2;
  notificationV2: NotificationResultV2;
  orders: PaginatedOrderResponse;
  osVersion: OsVersion;
  osVersions: Array<OsVersion>;
  osVersionToDeploy?: Maybe<DeployedOsVersion>;
  payments: PaginatedPaymentsResponse;
  people: Array<Person>;
  person: Person;
  personNotificationSettingsV2: NotificationSubscriberResultV2;
  personV2: PersonResultV2;
  pick: Pick;
  pickCategory: PickCategory;
  pickCategoryV2: PickCategoryResultV2;
  picks: Array<Pick>;
  picksCategories: Array<PickCategory>;
  picksLength: Scalars['Int'];
  pickV2: PickResultV2;
  plusRenewalError?: Maybe<PlusRenewalFailure>;
  principal: Principal;
  principals: Array<Principal>;
  product: Product;
  productApplication?: Maybe<ProductApplication>;
  productPricings: Array<ProductPricing>;
  products: Array<Product>;
  publicInstallables: Array<Installable>;
  publicSimulatorTokenV2: SimulatorTokenResultV2;
  purchase?: Maybe<PlusPurchaseSessionPurchase>;
  recommendations: Array<Recommendation>;
  referralCodeV2: ReferralCodeResultV2;
  referralReport: ReferralReportResponse;
  roleV2: RoleResultV2;
  scheduledNotificationV2: ScheduledNotificationResultV2;
  search: Array<MessageSearchResult>;
  searchCustomers: PaginatedCustomerResponse;
  searchMarketPlaceListings: Array<MarketplaceListing>;
  shopifyOrderCustomerV2: ShopifyCustomerResultV2;
  sshDeviceKeypairs: Array<DeviceSshKeyPair>;
  sshKeypair: SshKeyPair;
  submittedMessageSetV2: SubmittedMessageSetResultV2;
  subscription: Subscription;
  subscriptions: Array<Subscription>;
  subscriptionV2: SubscriptionResultV2;
  suggestedSearchTermsV2: SuggestedSearchTerms;
  superadmins: Array<Superadmin>;
  systemMessageTemplateV2: SystemMessageTemplateResultV2;
  templateCategoryV2: TemplateCategoryResultV2;
  templateMessageSuggestionV2: TemplateMessageSuggestionResultV2;
  templateMessageV2: TemplateMessageResultV2;
  tenant: Tenant;
  tenants: Array<Tenant>;
  todaysPicks: Array<Pick>;
  upcomingPicks: Array<Pick>;
  upcomingPicksLength: Scalars['Int'];
  usersReport: UsersReportOutput;
  viewer?: Maybe<Viewer>;
  viewerV2: PersonResultV2;
  visualEditorSession: GqlVisualEditorSession;
  yesterdaysPairedBoardDeviceAssociations: Array<BoardDeviceAssociationModel>;
};


export type QueryAcceptedReferralV2Args = {
  id: Scalars['String'];
};


export type QueryAccountArgs = {
  emailAddress: Scalars['String'];
};


export type QueryActivationCodeQueryArgs = {
  code: Scalars['String'];
};


export type QueryActivationsReportArgs = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};


export type QueryAdminActivationCodesArgs = {
  emailAddress: Scalars['String'];
};


export type QueryAdminConfigurationNetworkArgs = {
  input: AdminConfigurationNetworkQueryInput;
};


export type QueryApiCredentialArgs = {
  id: Scalars['String'];
};


export type QueryBoardArgs = {
  id: Scalars['String'];
};


export type QueryBoardsArgs = {
  tenantId: Scalars['String'];
};


export type QueryBoardScheduledMessageV2Args = {
  boardId: Scalars['String'];
};


export type QueryBoardsReportArgs = {
  input: BoardsReportInput;
};


export type QueryBoardsV2Args = {
  permissionFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryBoardV2Args = {
  id: Scalars['String'];
};


export type QueryCadenceToCronV2Args = {
  input: CadenceToCronInputV2;
};


export type QueryColorTemplateArgs = {
  id: Scalars['String'];
};


export type QueryColorTemplateCategoryArgs = {
  id: Scalars['String'];
};


export type QueryColorTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryColorTemplateV2Args = {
  id: Scalars['String'];
};


export type QueryConfigurationNetworkArgs = {
  input: ConfigurationNetworkQueryInput;
};


export type QueryConflictingSubscriptionsV2Args = {
  input: ConflictingSubscriptionsInputV2;
};


export type QueryContractArgs = {
  id: Scalars['String'];
};


export type QueryCountDistinctSearchMessagesV2Args = {
  input: SearchDistinctMessageInputV2;
};


export type QueryCountSearchMessagesV2Args = {
  input: SearchMessageInputV2;
};


export type QueryCustomerArgs = {
  id: Scalars['String'];
};


export type QueryCustomersArgs = {
  page: Scalars['Int'];
};


export type QueryDeveloperArgs = {
  id: Scalars['String'];
};


export type QueryDevelopersArgs = {
  input?: InputMaybe<ListDevelopersInput>;
};


export type QueryDeviceArgs = {
  id: Scalars['String'];
};


export type QueryDeviceByPairingCodeArgs = {
  code: Scalars['String'];
};


export type QueryDevicesArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  yoctoStatus?: InputMaybe<Scalars['String']>;
};


export type QueryDevicesByGmtOffsetAndYoctoStatusArgs = {
  gmtOffset: Scalars['Int'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  yoctoStatus: Scalars['String'];
};


export type QueryFeedItemV2Args = {
  id: Scalars['String'];
};


export type QueryFeedTagV2Args = {
  id: Scalars['String'];
};


export type QueryFirmwareUpgradeModalArgs = {
  board: Scalars['String'];
};


export type QueryFlagshipDeviceV2Args = {
  boardId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryGetBlendedV2Args = {
  boardId: Scalars['String'];
};


export type QueryGetBoardV2Args = {
  id: Scalars['String'];
};


export type QueryGetDisplayGroupV2Args = {
  id: Scalars['String'];
};


export type QueryGetMasterPairingV2Args = {
  input: GetMasterPairingInputV2;
};


export type QueryGetMessageSetVersionV2Args = {
  input: GetMessageSetVersionInputV2;
};


export type QueryGetSearchTermV2Args = {
  term: Scalars['String'];
};


export type QueryHomeScreenBannersV2Args = {
  input?: InputMaybe<ListHomeScreenBannersInputV2>;
};


export type QueryHomeScreenBannerV2Args = {
  id: Scalars['String'];
};


export type QueryInstallableArgs = {
  id: Scalars['String'];
};


export type QueryInstallablesArgs = {
  tenantId: Scalars['String'];
};


export type QueryInstallableV2Args = {
  id: Scalars['String'];
};


export type QueryInstallationArgs = {
  id: Scalars['String'];
};


export type QueryListAcceptedReferralsV2Args = {
  input: ListAcceptedReferralInputV2;
};


export type QueryListBoardDeviceAssociationsArgs = {
  input: BoardDeviceAssociationInput;
};


export type QueryListBoardMessageAppearancesV2Args = {
  input: ListBoardMessageAppearancesInputV2;
};


export type QueryListBoardsV2Args = {
  permissionFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryListColorTemplatesV2Args = {
  input: ListColorTemplateInputV2;
};


export type QueryListDealAssociationsV2Args = {
  input: ListDealAssociationsInputV2;
};


export type QueryListDigitalDeviceStylesArgs = {
  input: ListDigitalDeviceStylesInputV2;
};


export type QueryListDigitalDevicesV2Args = {
  input: ListDigitalDevicesInputV2;
};


export type QueryListFavoriteSourcesV2Args = {
  input: ListFavoriteSourcesInputV2;
};


export type QueryListFeedItemsV2Args = {
  input: ListFeedItemsInputV2;
};


export type QueryListFeedTagsV2Args = {
  input: ListFeedTagsInputV2;
};


export type QueryListFlaggedFeedItemsByPersonV2Args = {
  input: ListFeedItemFlagsByPersonInputV2;
};


export type QueryListFlaggedFeedItemsV2Args = {
  input: ListFeedItemFlagsInputV2;
};


export type QueryListFlaggedMessagesByPersonV2Args = {
  input: ListFlagsByPersonInputV2;
};


export type QueryListFlaggedMessagesV2Args = {
  input: ListFlagsInputV2;
};


export type QueryListFlagshipDevicesV2Args = {
  input: ListFlagshipDeviceInputV2;
};


export type QueryListInspirationV2Args = {
  input: ListInspirationInputV2;
};


export type QueryListInstallablesV2Args = {
  input?: InputMaybe<ListInstallableInputV2>;
};


export type QueryListMarketplaceCategoriesV2Args = {
  input?: InputMaybe<ListMarketplaceCategoryInputV2>;
};


export type QueryListMarketplaceFeatureTypesV2Args = {
  input?: InputMaybe<ListMarketplaceFeatureTypeInputV2>;
};


export type QueryListMarketplaceListingsArgs = {
  input: MarketplaceListingInput;
};


export type QueryListMarketplaceListingsV2Args = {
  input?: InputMaybe<ListMarketplaceListingSearchInputV2>;
};


export type QueryListMasterPairingsV2Args = {
  input: ListMasterPairingInputV2;
};


export type QueryListMessageSetsV2Args = {
  input: ListMessageSetInputV2;
};


export type QueryListMessageSetVersionsV2Args = {
  input: ListMessageSetVersionInputV2;
};


export type QueryListMessageSourcesV2Args = {
  input: ListMessageSourcesByBoardInputV2;
};


export type QueryListNotificationSegmentsV2Args = {
  input: ListNotificationSegmentInputV2;
};


export type QueryListNotificationSubscribersV2Args = {
  input: ListNotificationSubscribersInputV2;
};


export type QueryListNotificationsV2Args = {
  input: ListNotificationInputV2;
};


export type QueryListNotificationTagsV2Args = {
  input: ListNotificationTagInputV2;
};


export type QueryListPersonDraftsV2Args = {
  input?: InputMaybe<ListPersonDraftsInputV2>;
};


export type QueryListPersonFavoritesV2Args = {
  input?: InputMaybe<ListPersonFavoritesInputV2>;
};


export type QueryListPersonLikesV2Args = {
  input: ListPersonLikesInputV2;
};


export type QueryListPersonsV2Args = {
  input: ListPersonInputV2;
};


export type QueryListPickCategoriesV2Args = {
  input: ListPickCategoriesInputV2;
};


export type QueryListPlusRenewalErrorsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PlusRenewalFailureSortBy>;
  sortOrder?: InputMaybe<PlusRenewalFailureSortOrder>;
  terms?: InputMaybe<Scalars['String']>;
};


export type QueryListPurchasesArgs = {
  activationCodeState?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<PurchaseSortBy>;
  sortOrder?: InputMaybe<PurchaseSortOrder>;
  terms?: InputMaybe<Scalars['String']>;
};


export type QueryListRolesV2Args = {
  input: ListRoleInputV2;
};


export type QueryListScheduledNotificationsV2Args = {
  input: ListScheduledNotificationInputV2;
};


export type QueryListSearchMessagesV2Args = {
  input: SearchMessageInputV2;
};


export type QueryListSubmittedMessageSetsV2Args = {
  input: ListSubmittedMessageSetInputV2;
};


export type QueryListSystemMessageTemplatesV2Args = {
  input: ListSystemMessageTemplatesInputV2;
};


export type QueryListTemplateCategoriesV2Args = {
  input: ListTemplateCategoriesInputV2;
};


export type QueryListTemplateMessageSuggestionsV2Args = {
  input: ListTemplateMessageSuggestionsInputV2;
};


export type QueryListTemplateMessagesV2Args = {
  input: ListTemplateMessagesInputV2;
};


export type QueryListTopSearchTermsV2Args = {
  input: ListSearchTermAnalyticsInputV2;
};


export type QueryMarketplaceCategoryV2Args = {
  id: Scalars['String'];
};


export type QueryMarketplaceFeatureTypeV2Args = {
  id: Scalars['String'];
};


export type QueryMarketplaceListingArgs = {
  id: Scalars['String'];
};


export type QueryMarketplaceListingFeatureTypeArgs = {
  id: Scalars['String'];
};


export type QueryMarketplaceListingFeatureTypesArgs = {
  input: MarketplaceFeatureTypesInput;
};


export type QueryMarketplaceListingsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMarketplaceListingsCategoriesArgs = {
  supportsFlagship?: InputMaybe<Scalars['Boolean']>;
  supportsNote?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMarketplaceListingsCategoryArgs = {
  id: Scalars['String'];
};


export type QueryMarketplaceListingV2Args = {
  id: Scalars['String'];
};


export type QueryMessageArgs = {
  id: Scalars['String'];
};


export type QueryMessageAppearanceArgs = {
  id: Scalars['String'];
};


export type QueryMessageAppearancesMigrationStateV2Args = {
  boardId: Scalars['String'];
};


export type QueryMessageAppearanceV2Args = {
  id: Scalars['String'];
};


export type QueryMessageSetArgs = {
  id: Scalars['String'];
};


export type QueryMessageSetsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMessageSetV2Args = {
  id: Scalars['String'];
};


export type QueryMessageSetVersionArgs = {
  id: Scalars['String'];
};


export type QueryMessageShareTokenArgs = {
  token: Scalars['String'];
};


export type QueryMessageV2Args = {
  id: Scalars['String'];
};


export type QueryNotificationSegmentV2Args = {
  id: Scalars['String'];
};


export type QueryNotificationTagV2Args = {
  id: Scalars['String'];
};


export type QueryNotificationV2Args = {
  id: Scalars['String'];
};


export type QueryOrdersArgs = {
  page: Scalars['Int'];
};


export type QueryOsVersionArgs = {
  id: Scalars['String'];
};


export type QueryOsVersionsArgs = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};


export type QueryPaymentsArgs = {
  page: Scalars['Int'];
};


export type QueryPersonArgs = {
  id: Scalars['String'];
};


export type QueryPersonNotificationSettingsV2Args = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPersonV2Args = {
  id: Scalars['String'];
};


export type QueryPickArgs = {
  id: Scalars['String'];
};


export type QueryPickCategoryArgs = {
  id: Scalars['String'];
};


export type QueryPickCategoryV2Args = {
  id: Scalars['String'];
};


export type QueryPicksArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryPickV2Args = {
  id: Scalars['String'];
};


export type QueryPlusRenewalErrorArgs = {
  id: Scalars['String'];
};


export type QueryPrincipalArgs = {
  id: Scalars['String'];
};


export type QueryProductArgs = {
  id: Scalars['String'];
};


export type QueryProductApplicationArgs = {
  id: Scalars['String'];
};


export type QueryPublicSimulatorTokenV2Args = {
  boardId: Scalars['String'];
};


export type QueryPurchaseArgs = {
  id: Scalars['String'];
};


export type QueryRecommendationsArgs = {
  limit: Scalars['Int'];
};


export type QueryReferralCodeV2Args = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryRoleV2Args = {
  boardId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryScheduledNotificationV2Args = {
  id: Scalars['String'];
};


export type QuerySearchArgs = {
  board: Scalars['String'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  terms: Scalars['String'];
};


export type QuerySearchCustomersArgs = {
  term: Scalars['String'];
};


export type QuerySearchMarketPlaceListingsArgs = {
  input: MarketplaceListingInput;
};


export type QueryShopifyOrderCustomerV2Args = {
  input: ShopifyOrderCustomerInputV2;
};


export type QuerySshDeviceKeypairsArgs = {
  deviceId: Scalars['String'];
};


export type QuerySshKeypairArgs = {
  keypairId: Scalars['String'];
};


export type QuerySubmittedMessageSetV2Args = {
  id: Scalars['String'];
};


export type QuerySubscriptionArgs = {
  id: Scalars['String'];
};


export type QuerySubscriptionV2Args = {
  id: Scalars['String'];
};


export type QuerySystemMessageTemplateV2Args = {
  id: Scalars['String'];
};


export type QueryTemplateCategoryV2Args = {
  id: Scalars['String'];
};


export type QueryTemplateMessageSuggestionV2Args = {
  id: Scalars['String'];
};


export type QueryTemplateMessageV2Args = {
  id: Scalars['String'];
};


export type QueryTenantArgs = {
  id: Scalars['String'];
};


export type QueryTenantsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUpcomingPicksArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersReportArgs = {
  input: UsersReportInput;
};


export type QueryVisualEditorSessionArgs = {
  id: Scalars['String'];
};

export type AcceptedReferralResultV2 = AcceptedReferralErrorV2 | AcceptedReferralV2;

export type AcceptedReferralErrorV2 = {
  __typename?: 'AcceptedReferralErrorV2';
  error?: Maybe<Scalars['String']>;
  type: AcceptedReferralErrorType;
};

export enum AcceptedReferralErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type AcceptedReferralV2 = {
  __typename?: 'AcceptedReferralV2';
  createdAt: Scalars['Float'];
  creditRedeemed?: Maybe<Scalars['Boolean']>;
  creditType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invalidated?: Maybe<Scalars['Float']>;
  notified?: Maybe<Scalars['Float']>;
  orderDeliveredAt?: Maybe<Scalars['Float']>;
  purchaseId: Scalars['String'];
  referralCode: Scalars['String'];
  referrerEmail: Scalars['String'];
  referrerName: Scalars['String'];
  referrerPersonId: Scalars['String'];
  shopifyCustomerEmail: Scalars['String'];
  shopifyCustomerName: Scalars['String'];
  shopifyOrderId: Scalars['Float'];
  shopifyOrderName: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  activationCodes: Array<ActivationCode>;
  created: Scalars['String'];
  deleted?: Maybe<Scalars['Long']>;
  emailAddress: Scalars['String'];
  id: Scalars['String'];
  person: Person;
  purchases: Array<IssuedActivationCode>;
};

export type ActivationCode = {
  __typename?: 'ActivationCode';
  application?: Maybe<ProductApplication>;
  code: Scalars['String'];
  created: Scalars['Long'];
  id: Scalars['String'];
  isInvalidated: Scalars['Boolean'];
  isUsed: Scalars['Boolean'];
  productPricing?: Maybe<ProductPricing>;
};

export type ProductApplication = {
  __typename?: 'ProductApplication';
  activationCode?: Maybe<ActivationCode>;
  billingDates: Array<Scalars['Long']>;
  board?: Maybe<Board>;
  created: Scalars['Long'];
  ends?: Maybe<Scalars['Long']>;
  forcedThreeYearContract: Scalars['Boolean'];
  id: Scalars['String'];
  nextBillingDate?: Maybe<Scalars['Long']>;
  optOutDate?: Maybe<Scalars['Long']>;
  optOutOfAutoRenewal: Scalars['Boolean'];
  optOutReason?: Maybe<Scalars['String']>;
  pricing?: Maybe<ProductPricing>;
  purchaseLineItem?: Maybe<PlusPurchaseSessionPurchaseLineItem>;
  shopifyTransactionId?: Maybe<Scalars['String']>;
  started?: Maybe<Scalars['Long']>;
};


export type ProductApplicationBillingDatesArgs = {
  limit: Scalars['Int'];
};

export type Board = {
  __typename?: 'Board';
  blended?: Maybe<Blended>;
  /** @deprecated No longer in use */
  boardSet?: Maybe<BoardSet>;
  boardStyle: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['Long'];
  createdAgo: Scalars['Long'];
  deleted?: Maybe<Scalars['Long']>;
  devices: Array<Device>;
  friendlyIdentifier: Scalars['String'];
  history: Array<MessageAppearance>;
  historyCount: Scalars['Int'];
  hubspotDealId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalBoard: Scalars['Boolean'];
  isDigital: Scalars['Boolean'];
  isTwentyFourHourTime: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** @deprecated Prefer to use `history` field in the future. */
  messageAppearances: Array<MessageAppearance>;
  messagesAllTimeCount: Scalars['Int'];
  messagesPastDayCount: Scalars['Int'];
  messagesPastSevenDaysCount: Scalars['Int'];
  messagesPastThirtyDaysCount: Scalars['Int'];
  mirrorToken: BoardPublishToken;
  /** @deprecated The pairing code will no longer be exposed via the Board type. */
  pairingCode: Scalars['String'];
  pausedUntil?: Maybe<Scalars['Long']>;
  pinnedMessage?: Maybe<GqlPinnedMessage>;
  productApplications: Array<ProductApplication>;
  publicUrl: Scalars['String'];
  /** @deprecated Deprecated in favor of new quiet hours start / end fields */
  quietHours?: Maybe<Scalars['String']>;
  quietHoursBegin?: Maybe<Scalars['String']>;
  quietHoursEnd?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sendLaterMessage?: Maybe<Message>;
  settings: Array<BoardSetting>;
  subscriptionSet: SubscriptionSet;
  tenant: Tenant;
  timezone?: Maybe<TimezoneCity>;
  title: Scalars['String'];
  type: Scalars['String'];
  weekendQuietHoursBegin?: Maybe<Scalars['String']>;
  weekendQuietHoursEnd?: Maybe<Scalars['String']>;
};


export type BoardDevicesArgs = {
  type?: InputMaybe<Scalars['String']>;
};


export type BoardHistoryArgs = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  sources?: InputMaybe<Scalars['String']>;
};


export type BoardHistoryCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  sources?: InputMaybe<Scalars['String']>;
};


export type BoardMessageAppearancesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type Blended = {
  __typename?: 'Blended';
  id: Scalars['String'];
  messageSetIds: Array<Scalars['String']>;
  subscription?: Maybe<Subscription>;
};

export type Subscription = {
  __typename?: 'Subscription';
  configurationToken: Scalars['String'];
  configurationUrl?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installation?: Maybe<Installation>;
  marketplaceListing?: Maybe<MarketplaceListing>;
  /** @deprecated Use runOfShow object */
  messageCadenceDescription: Scalars['String'];
  messageSet?: Maybe<MessageSet>;
  muted?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Int'];
  requiresConfiguration: Scalars['Boolean'];
  runOfShow: RunOfShow;
  subscriptionSet: SubscriptionSet;
  title?: Maybe<Scalars['String']>;
};

export type Installation = {
  __typename?: 'Installation';
  created: Scalars['String'];
  id: Scalars['String'];
  installable: Installable;
  marketplaceListing?: Maybe<MarketplaceListing>;
  principal: Principal;
  subscriptions: Array<Subscription>;
  tenant: Tenant;
};

export type Installable = {
  __typename?: 'Installable';
  acceptsMessageSets?: Maybe<Scalars['Boolean']>;
  /** @deprecated Get this off of the installations->principle */
  apiCredentials: Array<ApiCredential>;
  /** @deprecated Automations concept will be deprecated in 2021. */
  automations: Array<Maybe<SingleMessageAutomation>>;
  cadenceConfigurationUrl?: Maybe<Scalars['String']>;
  cadenceDisplayTemplate?: Maybe<Scalars['String']>;
  cadenceOnCommand?: Maybe<Scalars['Boolean']>;
  cadenceToken?: Maybe<Scalars['String']>;
  category?: Maybe<InstallableCategory>;
  configurationSchema?: Maybe<Scalars['String']>;
  configurationUrl: Scalars['String'];
  confirmedBody?: Maybe<Scalars['String']>;
  confirmedMessage?: Maybe<Scalars['String']>;
  coverPhoto?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  createdLong: Scalars['Long'];
  description?: Maybe<Scalars['String']>;
  developer?: Maybe<Developer>;
  friendlyIdentifier: Scalars['String'];
  hideFromInstallablesList?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installations: Array<Installation>;
  installationsAreSingleton?: Maybe<Scalars['Boolean']>;
  public?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  recommendations: Array<Recommendation>;
  requiredScopes: Array<InstallableScope>;
  setupBody?: Maybe<Scalars['String']>;
  setupCallToActionLabel?: Maybe<Scalars['String']>;
  setupCallToActionUrl?: Maybe<Scalars['String']>;
  setupMessage?: Maybe<Scalars['String']>;
  shortPromoText?: Maybe<Scalars['String']>;
  subscriptionConfigurationUrl?: Maybe<Scalars['String']>;
  subscriptionsCanBeRenamed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  webhookDestination?: Maybe<WebhookDestination>;
};


export type InstallableApiCredentialsArgs = {
  me: Scalars['Boolean'];
};


export type InstallableConfigurationUrlArgs = {
  subscription: Scalars['String'];
};


export type InstallableInstallationsArgs = {
  me?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type ApiCredential = {
  __typename?: 'ApiCredential';
  created: Scalars['String'];
  id: Scalars['String'];
  key: Scalars['String'];
  lastUsed: Scalars['Long'];
  principal: Principal;
  title?: Maybe<Scalars['String']>;
};

export type Principal = {
  created: Scalars['String'];
  id: Scalars['String'];
};

export type SingleMessageAutomation = Automation & {
  __typename?: 'SingleMessageAutomation';
  created: Scalars['Long'];
  id: Scalars['String'];
  installable?: Maybe<Installable>;
  message: Message;
};

export type Automation = {
  created: Scalars['Long'];
  id: Scalars['String'];
  installable?: Maybe<Installable>;
};

export type Message = {
  __typename?: 'Message';
  author: Principal;
  authorFormatted: Scalars['String'];
  cardSize: Scalars['String'];
  created: Scalars['String'];
  forced?: Maybe<Scalars['Boolean']>;
  formatted?: Maybe<Array<Array<Scalars['Int']>>>;
  id: Scalars['String'];
  isFavorite: Scalars['Boolean'];
  pinnedUntil?: Maybe<Scalars['Long']>;
  returnToPreviousMessageAfterPin?: Maybe<Scalars['Boolean']>;
  sendAt?: Maybe<Scalars['Long']>;
  sendAtCompleted?: Maybe<Scalars['Boolean']>;
  source?: Maybe<MessageSource>;
  subscription?: Maybe<Subscription>;
  text?: Maybe<Scalars['String']>;
};


export type MessageFormattedArgs = {
  boardId?: InputMaybe<Scalars['String']>;
};


export type MessageIsFavoriteArgs = {
  person: Scalars['String'];
};


export type MessageTextArgs = {
  boardId?: InputMaybe<Scalars['String']>;
};

export type MessageSource = {
  __typename?: 'MessageSource';
  created: Scalars['Long'];
  id: Scalars['String'];
  isSelected: Scalars['Boolean'];
  personId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MessageSourceIsSelectedArgs = {
  board: Scalars['String'];
  person: Scalars['String'];
};

export type InstallableCategory = {
  __typename?: 'InstallableCategory';
  created: Scalars['Long'];
  id: Scalars['String'];
  marketplaceListings: Array<MarketplaceListing>;
  title: Scalars['String'];
};

export type MarketplaceListing = {
  __typename?: 'MarketplaceListing';
  adminInstallations: Array<Installation>;
  blending: BlendableConfig;
  carouselMedia1?: Maybe<Scalars['String']>;
  carouselMedia1Ref?: Maybe<Media>;
  carouselMedia2?: Maybe<Scalars['String']>;
  carouselMedia2Ref?: Maybe<Media>;
  carouselMedia3?: Maybe<Scalars['String']>;
  carouselMedia3Ref?: Maybe<Media>;
  categories: Array<InstallableCategory>;
  category?: Maybe<InstallableCategory>;
  configuration?: Maybe<Scalars['String']>;
  created: Scalars['Long'];
  creator?: Maybe<Developer>;
  deleted?: Maybe<Scalars['Long']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Prefer to use creator field in the future. */
  developer?: Maybe<Developer>;
  featureTypes: Array<MarketplaceListingFeatureItem>;
  free?: Maybe<Scalars['Boolean']>;
  hiddenFromProduction?: Maybe<Scalars['Boolean']>;
  icon: Scalars['String'];
  iconMedia?: Maybe<Media>;
  id: Scalars['String'];
  installable: Installable;
  installations: Array<Installation>;
  /** @deprecated Use blending.isBlendable */
  isBlendable: Scalars['Boolean'];
  isFeatured?: Maybe<Scalars['Boolean']>;
  isSingleton?: Maybe<Scalars['Boolean']>;
  language?: Maybe<GqlLanguage>;
  lastUpdated?: Maybe<Scalars['Long']>;
  messageSet?: Maybe<MessageSet>;
  noteCarouselMedia1?: Maybe<Scalars['String']>;
  noteCarouselMedia1Ref?: Maybe<Media>;
  noteCarouselMedia2?: Maybe<Scalars['String']>;
  noteCarouselMedia2Ref?: Maybe<Media>;
  noteCarouselMedia3?: Maybe<Scalars['String']>;
  noteCarouselMedia3Ref?: Maybe<Media>;
  notePreviewMessage?: Maybe<Scalars['String']>;
  previewMessage?: Maybe<Scalars['String']>;
  questionAndAnswerId?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['Long']>;
  shortDescription?: Maybe<Scalars['String']>;
  stagingOnly?: Maybe<Scalars['Boolean']>;
  subscriptionsCount: Scalars['Int'];
  supportsFlagship: Scalars['Boolean'];
  supportsNote: Scalars['Boolean'];
  tags?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  /** @deprecated Not needed */
  voiceControlIntent?: Maybe<Scalars['String']>;
  /** @deprecated Not needed */
  voiceControlOrderPreference?: Maybe<Scalars['String']>;
  /** @deprecated Not needed */
  voiceControlSlotValues?: Maybe<Scalars['String']>;
};


export type MarketplaceListingAdminInstallationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type MarketplaceListingInstallationsArgs = {
  tenant: Scalars['String'];
};

export type BlendableConfig = {
  __typename?: 'BlendableConfig';
  id?: Maybe<Scalars['String']>;
  isBlendable: Scalars['Boolean'];
  type?: Maybe<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  cdnUrl: Scalars['String'];
  created: Scalars['Long'];
  id: Scalars['String'];
};

export type Developer = {
  __typename?: 'Developer';
  created: Scalars['Long'];
  id: Scalars['String'];
  installables: Array<Installable>;
  personAssociations: Array<DeveloperPersonAssociation>;
  title: Scalars['String'];
};

export type DeveloperPersonAssociation = {
  __typename?: 'DeveloperPersonAssociation';
  created: Scalars['Long'];
  developer: Developer;
  id: Scalars['String'];
  person: Person;
  role: Scalars['String'];
};

export type Person = {
  __typename?: 'Person';
  account: Account;
  avatar?: Maybe<Scalars['String']>;
  boardIds: Array<Scalars['String']>;
  developer: DeveloperPersonAssociation;
  drafts: Array<DraftMessage>;
  draftsCount: Scalars['Int'];
  favorites: Array<MessageFavorite>;
  favoritesCount: Scalars['Int'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  messageSourceSelections: Array<GqlMessageSourceSelection>;
  photo?: Maybe<Scalars['String']>;
  referralCode: ReferralCode;
  shares: Array<GqlMessageShareToken>;
  tenantAssociations: Array<PersonTenantAssociation>;
  tenants: Array<PersonTenant>;
};


export type PersonDraftsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type PersonFavoritesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type PersonTenantAssociationsArgs = {
  onlyCurrent?: InputMaybe<Scalars['Boolean']>;
};

export type DraftMessage = {
  __typename?: 'DraftMessage';
  created: Scalars['Long'];
  id: Scalars['String'];
  message: Message;
  person: Person;
};

export type MessageFavorite = {
  __typename?: 'MessageFavorite';
  created: Scalars['String'];
  favorited?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  message: Message;
  person: Person;
};

export type GqlMessageSourceSelection = {
  __typename?: 'GqlMessageSourceSelection';
  messageSource: MessageSource;
};

export type ReferralCode = {
  __typename?: 'ReferralCode';
  code: Scalars['String'];
  created: Scalars['Long'];
  discountForNewCustomer: Scalars['Int'];
  id: Scalars['String'];
  revenueShareForExistingCustomer: Scalars['Int'];
  url: Scalars['String'];
};

export type GqlMessageShareToken = {
  __typename?: 'GqlMessageShareToken';
  created: Scalars['Long'];
  id: Scalars['String'];
  message: Message;
};

export type PersonTenantAssociation = {
  __typename?: 'PersonTenantAssociation';
  created: Scalars['Long'];
  id: Scalars['String'];
  invitationStatus: Scalars['String'];
  isCurrentMember: Scalars['Boolean'];
  permittedRoleChanges: Array<Scalars['String']>;
  person: Person;
  role: Scalars['String'];
  tenant: PersonTenant;
};

export type PersonTenant = Tenant & {
  __typename?: 'PersonTenant';
  boards: Array<Board>;
  created: Scalars['String'];
  id: Scalars['String'];
  installations: Array<Installation>;
  members: Array<PersonTenantAssociation>;
  name: Scalars['String'];
  /** @deprecated Use `members` instead. Legacy PersonTenants may have > 1 member due to the concept of a GroupTenant not yet existing. */
  person: Person;
};


export type PersonTenantBoardsArgs = {
  roles?: InputMaybe<Scalars['String']>;
};

export type Tenant = {
  boards: Array<Board>;
  created: Scalars['String'];
  id: Scalars['String'];
  installations: Array<Installation>;
  members: Array<PersonTenantAssociation>;
  name: Scalars['String'];
};


export type TenantBoardsArgs = {
  roles?: InputMaybe<Scalars['String']>;
};

export type MarketplaceListingFeatureItem = {
  __typename?: 'MarketplaceListingFeatureItem';
  created: Scalars['Long'];
  id: Scalars['String'];
  marketplaceListing: MarketplaceListing;
  marketplaceListingFeatureType?: Maybe<MarketplaceListingFeatureType>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type MarketplaceListingFeatureType = {
  __typename?: 'MarketplaceListingFeatureType';
  created: Scalars['Long'];
  id: Scalars['String'];
  image: Scalars['String'];
  isDynamic: Scalars['Boolean'];
  items: Array<MarketplaceListingFeatureItem>;
  title: Scalars['String'];
};


export type MarketplaceListingFeatureTypeImageArgs = {
  size?: InputMaybe<Scalars['String']>;
};

export type GqlLanguage = {
  __typename?: 'GqlLanguage';
  created: Scalars['Long'];
  id: Scalars['String'];
  language: Scalars['String'];
};

export type MessageSet = {
  __typename?: 'MessageSet';
  count: Scalars['Int'];
  created: Scalars['Long'];
  currentVersion: MessageSetVersion;
  dynamic: Scalars['Boolean'];
  dynamicConfiguration?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  messages: Array<Message>;
  migrated: Scalars['Boolean'];
  public: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  versions: Array<MessageSetVersion>;
};


export type MessageSetMessagesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type MessageSetVersionsArgs = {
  first: Scalars['Int'];
};

export type MessageSetVersion = {
  __typename?: 'MessageSetVersion';
  count: Scalars['Int'];
  created: Scalars['Long'];
  createdBy?: Maybe<Person>;
  id: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  messages: Array<Message>;
  messageSet: MessageSet;
};


export type MessageSetVersionMessagesArgs = {
  first: Scalars['Int'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  automation?: Maybe<SingleMessageAutomation>;
  created: Scalars['Long'];
  id: Scalars['String'];
};

export type InstallableScope = {
  __typename?: 'InstallableScope';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type WebhookDestination = {
  __typename?: 'WebhookDestination';
  created: Scalars['Long'];
  id: Scalars['String'];
  url: Scalars['String'];
};

export type RunOfShow = {
  __typename?: 'RunOfShow';
  description?: Maybe<Scalars['String']>;
  firstAppearance?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated Use firstAppearance */
  nextAppearance?: Maybe<Scalars['String']>;
};

export type SubscriptionSet = {
  __typename?: 'SubscriptionSet';
  boards: Array<Board>;
  channels: Array<Subscription>;
  created: Scalars['String'];
  id: Scalars['String'];
  messageSources: Array<MessageSource>;
  subscriptions: Array<Subscription>;
};


export type SubscriptionSetSubscriptionsArgs = {
  input?: InputMaybe<SubscriptionSetSubscriptionsInput>;
};

export type SubscriptionSetSubscriptionsInput = {
  installableId?: InputMaybe<Scalars['String']>;
};

export type BoardSet = {
  __typename?: 'BoardSet';
  boards: Array<Board>;
  created: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type Device = {
  __typename?: 'Device';
  /** @deprecated The name of this should be plural */
  board: Array<Board>;
  boards: Array<Board>;
  characterSet?: Maybe<GqlCharacterSet>;
  conditions?: Maybe<Scalars['String']>;
  configurationNetwork?: Maybe<ConfigurationNetwork>;
  created: Scalars['String'];
  firmwareVersion: Scalars['String'];
  friendlyIdentifier: Scalars['String'];
  hardware?: Maybe<Hardware>;
  /** @deprecated This field is not needed for upgrades */
  hawkbitSecurityToken?: Maybe<Scalars['String']>;
  /** @deprecated This field is not needed for upgrades */
  hawkitTarget?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  keypair?: Maybe<Keypair>;
  keypairs?: Maybe<Array<Keypair>>;
  keypairToken?: Maybe<Scalars['String']>;
  latestForgetNetworkRequest?: Maybe<DeviceForgetNetworkRequest>;
  latestHeartbeat?: Maybe<DeviceHeartbeat>;
  latestHeartbeatRaw?: Maybe<Scalars['String']>;
  latestLocationCountryCode?: Maybe<Scalars['String']>;
  localApiEnablementToken?: Maybe<Scalars['String']>;
  logsUrl: Scalars['String'];
  macAddresses: Array<Scalars['String']>;
  model?: Maybe<GqlDeviceModel>;
  mustEnableHawkbitUpdates: Scalars['Boolean'];
  pairingCode?: Maybe<Scalars['String']>;
  pairingDate?: Maybe<Scalars['Long']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  /** @deprecated This field is not needed for upgrades */
  yoctoState: YoctoStateResult;
  yoctoStatus?: Maybe<Scalars['String']>;
};


export type DevicePairingDateArgs = {
  board: Scalars['String'];
};

export type GqlCharacterSet = {
  __typename?: 'GqlCharacterSet';
  created: Scalars['Long'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type ConfigurationNetwork = {
  __typename?: 'ConfigurationNetwork';
  created: Scalars['String'];
  device?: Maybe<Device>;
  deviceId: Scalars['String'];
  id: Scalars['String'];
  ssid: Scalars['String'];
  wpa2Key: Scalars['String'];
};

export type Hardware = {
  __typename?: 'Hardware';
  boiSerialNumber?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  id: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Keypair = {
  __typename?: 'Keypair';
  associated?: Maybe<Scalars['Long']>;
  created: Scalars['Long'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type DeviceForgetNetworkRequest = {
  __typename?: 'DeviceForgetNetworkRequest';
  created: Scalars['Long'];
  createdBy: Principal;
  device?: Maybe<Device>;
  id: Scalars['String'];
};

export type DeviceHeartbeat = {
  __typename?: 'DeviceHeartbeat';
  containers?: Maybe<Array<DeviceContainerStatus>>;
  created: Scalars['Long'];
  device?: Maybe<Device>;
  firmwareUpgradeStatus: DeviceFirmwareUpgradeStatus;
  id: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  maskStatus?: Maybe<Scalars['String']>;
  /** @deprecated Use networks instead */
  network?: Maybe<DeviceHeartbeatMessageCurrentNetwork>;
  networks: Array<DeviceNetworkStatus>;
  osVersion: DeviceOsVersion;
  timeago: Scalars['Long'];
};

export type DeviceContainerStatus = {
  __typename?: 'DeviceContainerStatus';
  id: Scalars['String'];
  image: Scalars['String'];
  since: Scalars['Long'];
  version?: Maybe<Scalars['String']>;
};

export type DeviceFirmwareUpgradeStatus = {
  __typename?: 'DeviceFirmwareUpgradeStatus';
  progress?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type DeviceHeartbeatMessageCurrentNetwork = {
  __typename?: 'DeviceHeartbeatMessageCurrentNetwork';
  bssid: Scalars['String'];
  freq: Scalars['Int'];
  ipAddress?: Maybe<Scalars['String']>;
  ssid: Scalars['String'];
};

export type DeviceNetworkStatus = {
  __typename?: 'DeviceNetworkStatus';
  ipAddress: Scalars['String'];
  online: Scalars['String'];
  ssid?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  up: Scalars['Boolean'];
};

export type DeviceOsVersion = {
  __typename?: 'DeviceOsVersion';
  buildId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  versionId?: Maybe<Scalars['String']>;
  versionName?: Maybe<Scalars['String']>;
};

export type GqlDeviceModel = {
  __typename?: 'GqlDeviceModel';
  created: Scalars['Long'];
  devices: Array<Device>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export enum YoctoStateResult {
  Began = 'Began',
  Completed = 'Completed',
  Eligible = 'Eligible',
  Installed = 'Installed',
  Rebooting = 'Rebooting',
  Unknown = 'Unknown'
}

export type MessageAppearance = {
  __typename?: 'MessageAppearance';
  appeared: Scalars['String'];
  board?: Maybe<Board>;
  id: Scalars['String'];
  message?: Maybe<Message>;
};

export type BoardPublishToken = {
  __typename?: 'BoardPublishToken';
  board?: Maybe<Board>;
  created: Scalars['Long'];
  id: Scalars['String'];
  token: Scalars['String'];
};

export type GqlPinnedMessage = {
  __typename?: 'GqlPinnedMessage';
  message: Message;
  pinnedUntil: Scalars['Long'];
};

export type BoardSetting = {
  __typename?: 'BoardSetting';
  cta: Scalars['String'];
  key?: Maybe<Scalars['ID']>;
  link: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type TimezoneCity = {
  __typename?: 'TimezoneCity';
  created: Scalars['Long'];
  id: Scalars['String'];
  timezoneCity: Scalars['String'];
};

export type ProductPricing = {
  __typename?: 'ProductPricing';
  autoRenew: Scalars['Boolean'];
  banner?: Maybe<Scalars['String']>;
  chargeFrequency: Scalars['String'];
  created: Scalars['Long'];
  estimatedPriceInCents: EstimatedPrice;
  id: Scalars['String'];
  priceAfterFirstInCents?: Maybe<Scalars['Int']>;
  priceInCents: Scalars['Int'];
  pricePerMonthInCents?: Maybe<Scalars['Float']>;
  product: Product;
  quantity?: Maybe<Scalars['Int']>;
  shopifySellingPlanId?: Maybe<Scalars['String']>;
  shopifyVariantId?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type EstimatedPrice = {
  __typename?: 'EstimatedPrice';
  cartLink?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  totalPrice: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  /** @deprecated Use listProductApplications */
  applications: Array<ProductApplication>;
  created: Scalars['Long'];
  id: Scalars['String'];
  isPlus: Scalars['Boolean'];
  listProductApplications: PaginatedProductApplications;
  productPricings: Array<ProductPricing>;
  redemptionCodes: Array<ActivationCode>;
  title: Scalars['String'];
};


export type ProductListProductApplicationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<ProductApplicationSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  terms?: InputMaybe<Scalars['String']>;
};


export type ProductProductPricingsArgs = {
  quantity: Scalars['Int'];
};

export enum ProductApplicationSortBy {
  ActivationCode = 'activationCode',
  BoardId = 'boardId',
  Created = 'created',
  EffectiveOnOrAfter = 'effectiveOnOrAfter',
  Email = 'email',
  ExpiresOnOrAfter = 'expiresOnOrAfter',
  Id = 'id',
  OptOutDate = 'optOutDate',
  OptOutOfRenewal = 'optOutOfRenewal',
  OptOutReason = 'optOutReason',
  PersonId = 'personId',
  PricingType = 'pricingType',
  ShopifyOrderId = 'shopifyOrderId',
  ShopifyOrderName = 'shopifyOrderName',
  ShopifyUserId = 'shopifyUserId'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaginatedProductApplications = {
  __typename?: 'PaginatedProductApplications';
  pagination: Pagination;
  productApplications: Array<ProductApplication>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type PlusPurchaseSessionPurchaseLineItem = {
  __typename?: 'PlusPurchaseSessionPurchaseLineItem';
  activationCode?: Maybe<ActivationCode>;
  created: Scalars['Long'];
  id: Scalars['String'];
  productApplication?: Maybe<ProductApplication>;
  purchase?: Maybe<PlusPurchaseSessionPurchase>;
};

export type PlusPurchaseSessionPurchase = {
  __typename?: 'PlusPurchaseSessionPurchase';
  account?: Maybe<Account>;
  created: Scalars['Long'];
  emailAddress: Scalars['String'];
  id: Scalars['String'];
  lineItems: Array<PlusPurchaseSessionPurchaseLineItem>;
  optOutOfRenewal: Scalars['Boolean'];
  purchaseSession?: Maybe<PlusPurchaseSession>;
};

export type PlusPurchaseSession = {
  __typename?: 'PlusPurchaseSession';
  created: Scalars['Long'];
  id: Scalars['String'];
  paymentMethod?: Maybe<ShopifyPaymentMethod>;
  shopifyOrderId?: Maybe<Scalars['String']>;
  shopifyOrderName?: Maybe<Scalars['String']>;
  shopifyOrderToken?: Maybe<Scalars['String']>;
  shopifyUserId?: Maybe<Scalars['String']>;
};

export type ShopifyPaymentMethod = {
  __typename?: 'ShopifyPaymentMethod';
  company?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  shopifyPaymentMethodId?: Maybe<Scalars['String']>;
  shopifySubscriptionContractId?: Maybe<Scalars['String']>;
};

export type IssuedActivationCode = {
  __typename?: 'IssuedActivationCode';
  code: Scalars['String'];
  created: Scalars['Long'];
};

export type ActivationCodeValidation = {
  __typename?: 'ActivationCodeValidation';
  code: Scalars['String'];
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type ActivationsReportResponse = {
  __typename?: 'ActivationsReportResponse';
  activations: Array<MonitoringActivation>;
  count: Scalars['Int'];
};

export type MonitoringActivation = {
  __typename?: 'MonitoringActivation';
  account: Account;
  board: Board;
  device: Device;
  pairingCreated: Scalars['Long'];
};

export type AdminConfigurationNetworkQueryInput = {
  ssid: Scalars['String'];
};

export type ScheduledMessageResultV2 = ScheduledMessageErrorV2 | ScheduledMessageV2;

export type ScheduledMessageErrorV2 = {
  __typename?: 'ScheduledMessageErrorV2';
  error?: Maybe<Scalars['String']>;
  type: ScheduledMessageErrorType;
};

export enum ScheduledMessageErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound',
  QuietHours = 'QuietHours'
}

export type ScheduledMessageV2 = {
  __typename?: 'ScheduledMessageV2';
  attribution: Scalars['String'];
  boardId: Scalars['String'];
  id: Scalars['ID'];
  message: MessageV2;
  messageId: Scalars['String'];
  personId: Scalars['String'];
  sendAt: Scalars['Float'];
};

export type MessageV2 = {
  __typename?: 'MessageV2';
  ascii: Scalars['String'];
  cardSize: Scalars['String'];
  /** The characters in the message. Either characters or text are required */
  characters: Array<Array<Scalars['Int']>>;
  createdAt: Scalars['Float'];
  /** The fingerprint of the message. This is a MD5 hash of the message text or characters */
  fingerprint: Scalars['String'];
  formatted: Array<Array<Scalars['Int']>>;
  id: Scalars['ID'];
  isFavorited: Scalars['Boolean'];
  isFlagged: Scalars['Boolean'];
  listFavorites: ListFavoritesV2;
  listFeedItems: ListFeedItemsV2;
  listFlaggedMessages: ListFlagsV2;
  listMessageAppearances: ListMessageAppearancesV2;
  /** Searchable tags associated with the message */
  tags?: Maybe<Array<Scalars['String']>>;
  /** The text of the message. Either text or characters are required */
  text?: Maybe<Scalars['String']>;
};


export type MessageV2FormattedArgs = {
  boardStyle: MessageBoardStyle;
};


export type MessageV2ListFavoritesArgs = {
  input?: InputMaybe<ListFavoritesInputV2>;
};


export type MessageV2ListFeedItemsArgs = {
  input?: InputMaybe<ListFeedItemsInputV2>;
};


export type MessageV2ListFlaggedMessagesArgs = {
  input: ListFlagsInputV2;
};


export type MessageV2ListMessageAppearancesArgs = {
  input?: InputMaybe<ListMessageAppearancesInputV2>;
};

export enum MessageBoardStyle {
  Black = 'black',
  White = 'white'
}

export type ListFavoritesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFavoritesV2 = {
  __typename?: 'ListFavoritesV2';
  favorites: Array<FavoriteV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FavoriteV2 = {
  __typename?: 'FavoriteV2';
  attribution: Scalars['String'];
  created: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: MessageV2;
  messageId: Scalars['String'];
  personId: Scalars['String'];
  sourceId: Scalars['String'];
  sourceMarketplaceListingId?: Maybe<Scalars['String']>;
  sourcePersonId?: Maybe<Scalars['String']>;
  sourceSubscriptionId?: Maybe<Scalars['String']>;
};


export type FavoriteV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export enum MessageIconSize {
  Medium = 'Medium',
  Small = 'Small'
}

export type ListFeedItemsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFeedItemsV2 = {
  __typename?: 'ListFeedItemsV2';
  feedItems: Array<FeedItemV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FeedItemV2 = {
  __typename?: 'FeedItemV2';
  attribution: Scalars['String'];
  created: Scalars['Float'];
  createdAt: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFlaggedByMe: Scalars['Boolean'];
  isLikedByMe: Scalars['Boolean'];
  isSharedByMe: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  likes?: Maybe<Scalars['Int']>;
  listFlags: ListFeedItemFlagsV2;
  message: MessageV2;
  messageId: Scalars['String'];
  moderated?: Maybe<Scalars['Boolean']>;
  personId?: Maybe<Scalars['String']>;
  sentCount?: Maybe<Scalars['Int']>;
  sourceId: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tags: Array<FeedTagV2>;
};


export type FeedItemV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};


export type FeedItemV2ListFlagsArgs = {
  input?: InputMaybe<ListFeedItemFlagsInputV2>;
};

export type ListFeedItemFlagsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFeedItemFlagsV2 = {
  __typename?: 'ListFeedItemFlagsV2';
  flaggedFeedItems: Array<FlaggedFeedItemV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FlaggedFeedItemV2 = {
  __typename?: 'FlaggedFeedItemV2';
  feedItem: FeedItemV2;
  feedItemId: Scalars['ID'];
  personId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type FeedTagV2 = {
  __typename?: 'FeedTagV2';
  feedItems: Array<FeedItemV2>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ListFlagsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFlagsV2 = {
  __typename?: 'ListFlagsV2';
  flaggedMessages: Array<FlaggedMessageV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FlaggedMessageV2 = {
  __typename?: 'FlaggedMessageV2';
  messageId: Scalars['ID'];
  personId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type ListMessageAppearancesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type ListMessageAppearancesV2 = {
  __typename?: 'ListMessageAppearancesV2';
  messageAppearances: Array<MessageAppearanceV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MessageAppearanceV2 = {
  __typename?: 'MessageAppearanceV2';
  attribution: Scalars['String'];
  boardId: Scalars['String'];
  created: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marketplaceListingId?: Maybe<Scalars['String']>;
  message: MessageV2;
  messageId: Scalars['String'];
  personId?: Maybe<Scalars['String']>;
  queenBoardId?: Maybe<Scalars['String']>;
  sentAt: Scalars['Float'];
  sourceId: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
};


export type MessageAppearanceV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export type BoardsReportInput = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};

export type BoardsReportOutput = {
  __typename?: 'BoardsReportOutput';
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  rows: Array<GqlBoardsReportRow>;
  totalCount: Scalars['Int'];
};

export type GqlBoardsReportRow = {
  __typename?: 'GqlBoardsReportRow';
  created: Scalars['Long'];
  id: Scalars['String'];
  latestHeartbeatCreated?: Maybe<Scalars['Long']>;
  numberOfUsers: Scalars['Int'];
  pairedDevice?: Maybe<Scalars['String']>;
  pairedDeviceCreated?: Maybe<Scalars['Long']>;
  pairingCode?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type BoardStyle = {
  __typename?: 'BoardStyle';
  id: Scalars['String'];
  title: Scalars['String'];
  value: Scalars['String'];
};

export type ListBoards = {
  __typename?: 'ListBoards';
  boards: Array<BoardV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type BoardV2 = {
  __typename?: 'BoardV2';
  blended?: Maybe<BlendedV2>;
  /** Board style. Black/White */
  boardStyle?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  /** Person that created the board */
  creator?: Maybe<Scalars['String']>;
  digitalDevice?: Maybe<DigitalDeviceV2>;
  /** The board's hubspot id. */
  hubspotDealId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Is internal. */
  internalBoard?: Maybe<Scalars['Boolean']>;
  isDigital?: Maybe<Scalars['Boolean']>;
  /** Is quiet hours. */
  isQuietHours?: Maybe<Scalars['Boolean']>;
  isTwentyFourHourTime?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use pairedDevice, relation is 1:1 */
  listFlagshipDevices?: Maybe<ListFlagshipDevices>;
  listMessageAppearances: ListMessageAppearancesV2;
  listMessageSources: ListMessageSourcesV2;
  listMirrors?: Maybe<ListBoards>;
  listRoles?: Maybe<ListRoles>;
  listSubscriptions?: Maybe<ListSubscriptions>;
  /** The board id that it is mirroring */
  mirroring?: Maybe<Scalars['String']>;
  mirroringBoard?: Maybe<BoardV2>;
  mirroringLimit: Scalars['Float'];
  /** The board's mirrors. */
  mirrors?: Maybe<Array<Scalars['String']>>;
  outgoingWebhooks: Array<OutgoingWebhookV2>;
  pairedDevice?: Maybe<FlagshipDeviceV2>;
  pinnedMessage?: Maybe<PinnedMessageV2>;
  /** Pinned message ID. */
  pinnedMessageId?: Maybe<Scalars['Boolean']>;
  /** Quiet hours */
  quietHours?: Maybe<QuietHoursV2>;
  scheduledMessage: ScheduledMessageResultV2;
  /** Timezone. */
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type BoardV2ListMessageAppearancesArgs = {
  input?: InputMaybe<ListMessageAppearancesInputV2>;
};


export type BoardV2ListMessageSourcesArgs = {
  input?: InputMaybe<ListMessageSourcesInputV2>;
};


export type BoardV2ListSubscriptionsArgs = {
  input?: InputMaybe<ListSubscriptionInputV2>;
};

export type BlendedV2 = {
  __typename?: 'BlendedV2';
  cadence?: Maybe<BlendedCadenceV2>;
  channels: Array<BlendedChannelV2>;
  id: Scalars['ID'];
  setupComplete: Scalars['Boolean'];
};

export type BlendedCadenceV2 = {
  __typename?: 'BlendedCadenceV2';
  day?: Maybe<Scalars['Int']>;
  dayOfMonth?: Maybe<Scalars['Int']>;
  daysOfTheWeek?: Maybe<Array<Scalars['String']>>;
  endAtTime?: Maybe<BlendedCadenceTimeV2>;
  interval: Scalars['String'];
  month?: Maybe<Scalars['String']>;
  startAtTime?: Maybe<BlendedCadenceTimeV2>;
  startAtTimes?: Maybe<Array<BlendedCadenceTimeV2>>;
  time?: Maybe<BlendedCadenceTimeV2>;
  timeToDisplay?: Maybe<BlendedCadenceTimeV2>;
};

export type BlendedCadenceTimeV2 = {
  __typename?: 'BlendedCadenceTimeV2';
  amPm?: Maybe<Scalars['String']>;
  hour?: Maybe<Scalars['String']>;
  minutes?: Maybe<Scalars['String']>;
};

export type BlendedChannelV2 = {
  __typename?: 'BlendedChannelV2';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type DigitalDeviceV2 = {
  __typename?: 'DigitalDeviceV2';
  audioEnabled?: Maybe<Scalars['Boolean']>;
  board: BoardV2;
  boardId: Scalars['String'];
  createdAt: Scalars['Float'];
  digitalDeviceStyle: DigitalDeviceStyleV2;
  digitalDeviceStyleId: Scalars['String'];
  id: Scalars['ID'];
  screenSaverEnabled?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<DigitalDeviceType>;
};

export type DigitalDeviceStyleV2 = {
  __typename?: 'DigitalDeviceStyleV2';
  id: Scalars['ID'];
  price: Scalars['Float'];
  thumbnail: Scalars['String'];
  title: Scalars['String'];
};

export enum DigitalDeviceType {
  Roku = 'Roku'
}

export type ListFlagshipDevices = {
  __typename?: 'ListFlagshipDevices';
  flagshipDevices: Array<FlagshipDeviceV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FlagshipDeviceV2 = {
  __typename?: 'FlagshipDeviceV2';
  boardId?: Maybe<Scalars['String']>;
  boiSerialNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  deviceModel: FlagshipDeviceModel;
  deviceModelName: Scalars['String'];
  firmwareVersion?: Maybe<Scalars['String']>;
  heartbeat?: Maybe<FlagshipDeviceHeartbeatV2>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  localApiEnablementToken?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  macAddressesOne?: Maybe<Scalars['String']>;
  macAddressesThree?: Maybe<Scalars['String']>;
  macAddressesTwo?: Maybe<Scalars['String']>;
  pairingCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sshPublicKey?: Maybe<Scalars['String']>;
  sshSecretToken?: Maybe<Scalars['String']>;
  transitionInterval?: Maybe<Scalars['Float']>;
  transitionStepSize?: Maybe<Scalars['Float']>;
  transitionStrategy?: Maybe<Scalars['String']>;
  yoctoStatus?: Maybe<Scalars['String']>;
};

/** Current models of Flagship */
export enum FlagshipDeviceModel {
  FlagshipDvt = 'Flagship_DVT',
  FlagshipEvt = 'Flagship_EVT',
  FlagshipPvt = 'Flagship_PVT',
  FlagshipWhiteDvt = 'Flagship_White_DVT',
  FlagshipWhiteEvt = 'Flagship_White_EVT',
  FlagshipWhitePvt = 'Flagship_White_PVT',
  NoteBlackDvt = 'Note_Black_DVT',
  NoteBlackEvt = 'Note_Black_EVT',
  NoteBlackPvt = 'Note_Black_PVT'
}

export type FlagshipDeviceHeartbeatV2 = {
  __typename?: 'FlagshipDeviceHeartbeatV2';
  containers?: Maybe<Array<FlagshipDeviceHeartbeatContainerV2>>;
  created?: Maybe<Scalars['Float']>;
  deviceId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  ipAddress: Scalars['String'];
  lastSeen: Scalars['Float'];
  location?: Maybe<Scalars['String']>;
  maskStatus: Scalars['String'];
  networks?: Maybe<Array<FlagshipDeviceHeartbeatNetworkV2>>;
  timeago?: Maybe<Scalars['Float']>;
};

export type FlagshipDeviceHeartbeatContainerV2 = {
  __typename?: 'FlagshipDeviceHeartbeatContainerV2';
  id: Scalars['String'];
  image: Scalars['String'];
  since: Scalars['Float'];
  version: Scalars['String'];
};

export type FlagshipDeviceHeartbeatNetworkV2 = {
  __typename?: 'FlagshipDeviceHeartbeatNetworkV2';
  ipAddress: Scalars['String'];
  online: Scalars['String'];
  ssid: Scalars['String'];
  type: Scalars['String'];
  up: Scalars['Boolean'];
};

export type ListMessageSourcesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type ListMessageSourcesV2 = {
  __typename?: 'ListMessageSourcesV2';
  messageSources: Array<MessageSourceV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MessageSourceV2 = {
  __typename?: 'MessageSourceV2';
  boardId: Scalars['String'];
  id: Scalars['ID'];
  personId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ListRoles = {
  __typename?: 'ListRoles';
  nextCursor?: Maybe<Scalars['String']>;
  roles: Array<RoleV2>;
};

export type RoleV2 = {
  __typename?: 'RoleV2';
  board: BoardV2;
  boardId: Scalars['String'];
  createdAt: Scalars['Float'];
  hasIgnoredInvite?: Maybe<Scalars['Boolean']>;
  hasPendingInvite?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  permission: Direction;
  person: PersonV2;
  personId: Scalars['String'];
};

/** The basic directions */
export enum Direction {
  Admin = 'Admin',
  Owner = 'Owner',
  User = 'User'
}

export type PersonV2 = {
  __typename?: 'PersonV2';
  auth0UserId: Scalars['String'];
  createdAt: Scalars['Float'];
  emailAddress: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasCreatedFeedItemToday: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  listDrafts: ListDraftsV2;
  listFavorites: ListFavoritesV2;
  listFlaggedMessages: ListFlagsV2;
  listLikes: ListLikesV2;
  listNotifications: ListNotifications;
  listRoles: ListRoles;
  myRoleForBoard: RoleV2;
  notificationSettings: NotificationSubscriberResultV2;
  profileImageUrl?: Maybe<Scalars['String']>;
  referralCode: ReferralCodeResultV2;
};


export type PersonV2ListDraftsArgs = {
  input?: InputMaybe<ListDraftsInput>;
};


export type PersonV2ListFavoritesArgs = {
  input?: InputMaybe<ListFavoritesInputV2>;
};


export type PersonV2ListFlaggedMessagesArgs = {
  input: ListFlagsInputV2;
};


export type PersonV2ListLikesArgs = {
  input?: InputMaybe<ListLikesInputV2>;
};


export type PersonV2ListNotificationsArgs = {
  input?: InputMaybe<ListNotificationInputV2>;
};


export type PersonV2MyRoleForBoardArgs = {
  boardId: Scalars['String'];
};


export type PersonV2ProfileImageUrlArgs = {
  size?: InputMaybe<ProfileImageSize>;
};

export type ListDraftsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListDraftsV2 = {
  __typename?: 'ListDraftsV2';
  drafts: Array<DraftV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type DraftV2 = {
  __typename?: 'DraftV2';
  attribution: Scalars['String'];
  created: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: MessageV2;
  messageId: Scalars['String'];
  personId: Scalars['String'];
  sourceId: Scalars['String'];
};


export type DraftV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export type ListLikesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListLikesV2 = {
  __typename?: 'ListLikesV2';
  likes: Array<LikeV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type LikeV2 = {
  __typename?: 'LikeV2';
  createdAt: Scalars['String'];
  feedItem?: Maybe<FeedItemV2>;
  feedItemId?: Maybe<Scalars['String']>;
  personId: Scalars['String'];
  pick?: Maybe<PickV2>;
  pickId?: Maybe<Scalars['String']>;
  templateMessage?: Maybe<TemplateMessageV2>;
  templateMessageId?: Maybe<Scalars['String']>;
};

export type PickV2 = {
  __typename?: 'PickV2';
  attribution: Scalars['String'];
  categories?: Maybe<Array<PickCategoryV2>>;
  created: Scalars['Float'];
  date: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isLikedByMe: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  likes?: Maybe<Scalars['Int']>;
  message: MessageV2;
  public: Scalars['Boolean'];
  sentCount?: Maybe<Scalars['Int']>;
  sortOrder: Scalars['Float'];
};


export type PickV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export type PickCategoryV2 = {
  __typename?: 'PickCategoryV2';
  id: Scalars['ID'];
  listPicks: ListPicksV2;
  title: Scalars['String'];
};


export type PickCategoryV2ListPicksArgs = {
  input?: InputMaybe<ListPicksInputV2>;
};

export type ListPicksInputV2 = {
  categoryId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  dateAfter?: InputMaybe<Scalars['String']>;
  dateBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<PickSortBy>;
  sortDirection?: InputMaybe<PickSortDirection>;
};

export enum PickSortBy {
  CategoryTitle = 'categoryTitle',
  Date = 'date',
  MessageText = 'messageText'
}

export enum PickSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListPicksV2 = {
  __typename?: 'ListPicksV2';
  nextCursor?: Maybe<Scalars['String']>;
  picks: Array<PickV2>;
};

export type TemplateMessageV2 = {
  __typename?: 'TemplateMessageV2';
  attribution: Scalars['String'];
  category?: Maybe<TemplateCategoryV2>;
  categoryId: Scalars['String'];
  created: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFeatured?: Maybe<Scalars['Boolean']>;
  isLikedByMe: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  likes?: Maybe<Scalars['Int']>;
  message: MessageV2;
  messageId: Scalars['String'];
};


export type TemplateMessageV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export type TemplateCategoryV2 = {
  __typename?: 'TemplateCategoryV2';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ListNotificationInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<NotificationSortDirection>;
  tagGroupId?: InputMaybe<Scalars['String']>;
  unread?: InputMaybe<Scalars['Boolean']>;
};

export enum NotificationSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListNotifications = {
  __typename?: 'ListNotifications';
  nextCursor?: Maybe<Scalars['String']>;
  notifications: Array<NotificationV2>;
};

export type NotificationV2 = {
  __typename?: 'NotificationV2';
  callToAction?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  deepLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  isSystem?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
  personId: Scalars['String'];
  readAt?: Maybe<Scalars['Float']>;
  scheduledId?: Maybe<Scalars['String']>;
  scheduledNotification?: Maybe<ScheduledNotificationV2>;
  segment?: Maybe<NotificationSegmentV2>;
  segmentId?: Maybe<Scalars['String']>;
  silent?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<NotificationTagV2>;
  tagId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topic?: Maybe<Scalars['String']>;
};

export type ScheduledNotificationV2 = {
  __typename?: 'ScheduledNotificationV2';
  callToAction?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  deepLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listNotifications: ListNotifications;
  message: Scalars['String'];
  numberAttempted: Scalars['Float'];
  numberClicked: Scalars['Float'];
  numberDelivered: Scalars['Float'];
  numberOpened: Scalars['Float'];
  personIds?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use segments */
  segment?: Maybe<NotificationSegmentV2>;
  /** @deprecated Use segmentIds. */
  segmentId?: Maybe<Scalars['String']>;
  segmentIds?: Maybe<Array<Scalars['String']>>;
  segments?: Maybe<Array<NotificationSegmentV2>>;
  sendAt: Scalars['Float'];
  subscribers: Array<NotificationSubscriberV2>;
  tag?: Maybe<NotificationTagV2>;
  tagId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type ScheduledNotificationV2ListNotificationsArgs = {
  input?: InputMaybe<ListNotificationInputV2>;
};

export type NotificationSegmentV2 = {
  __typename?: 'NotificationSegmentV2';
  createdAt: Scalars['Float'];
  /** Only used for dynamic segments */
  dynamicUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDynamic?: Maybe<Scalars['Boolean']>;
  listSubscribers: ListNotificationSubscribers;
  /** Only used for static segments */
  personIds?: Maybe<Array<Scalars['String']>>;
  subscriberIds: Array<Scalars['String']>;
  subscribers: Array<NotificationSubscriberV2>;
  title: Scalars['String'];
};


export type NotificationSegmentV2ListSubscribersArgs = {
  input?: InputMaybe<ListNotificationSubscribersInputV2>;
};

export type ListNotificationSubscribersInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  terms?: InputMaybe<Scalars['String']>;
};

export type ListNotificationSubscribers = {
  __typename?: 'ListNotificationSubscribers';
  nextCursor?: Maybe<Scalars['String']>;
  notificationSubscribers: Array<NotificationSubscriberV2>;
};

export type NotificationSubscriberV2 = {
  __typename?: 'NotificationSubscriberV2';
  createdAt: Scalars['Float'];
  excludedTagIds: Array<Scalars['String']>;
  id: Scalars['ID'];
  listNotifications: ListNotifications;
  personId: Scalars['String'];
  registrationTokens: Array<Scalars['String']>;
  /** @deprecated Notifications are opted in by default now. Use excludedTagIds */
  tagIds: Array<Scalars['String']>;
  tags: Array<NotificationTagV2>;
  title: Scalars['String'];
  /** @deprecated Use unreadNotificationsCount instead. This will be removed in the future. */
  unreadCount: Scalars['Int'];
  unreadNotificationsCount: Scalars['Int'];
};


export type NotificationSubscriberV2ListNotificationsArgs = {
  input?: InputMaybe<ListNotificationInputV2>;
};

export type NotificationTagV2 = {
  __typename?: 'NotificationTagV2';
  createdAt: Scalars['Float'];
  id: Scalars['ID'];
  /** @deprecated Freeing up the index for tagGroup listing */
  listNotifications: ListNotifications;
  listScheduledNotifications: ListScheduledNotifications;
  /** @deprecated Tag subscribers are opted in by default. Just fetch the list and filter out an subscribers that are opted out. */
  personIds?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Tag subscribers are opted in by default. Just fetch the list and filter out an subscribers that are opted out. */
  subscribers?: Maybe<Array<NotificationSubscriberV2>>;
  tagGroup?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type NotificationTagV2ListNotificationsArgs = {
  input?: InputMaybe<ListNotificationInputV2>;
};


export type NotificationTagV2ListScheduledNotificationsArgs = {
  input?: InputMaybe<ListScheduledNotificationInputV2>;
};

export type ListScheduledNotificationInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListScheduledNotifications = {
  __typename?: 'ListScheduledNotifications';
  nextCursor?: Maybe<Scalars['String']>;
  scheduledNotifications: Array<ScheduledNotificationV2>;
};

export type NotificationSubscriberResultV2 = NotificationSubscriberErrorV2 | NotificationSubscriberV2;

export type NotificationSubscriberErrorV2 = {
  __typename?: 'NotificationSubscriberErrorV2';
  error?: Maybe<Scalars['String']>;
  type: NotificationSubscriberErrorType;
};

export enum NotificationSubscriberErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export enum ProfileImageSize {
  ExtraLarge = 'ExtraLarge',
  Large = 'Large',
  Medium = 'Medium',
  Original = 'Original',
  Small = 'Small'
}

export type ReferralCodeResultV2 = ReferralCodeErrorV2 | ReferralCodeV2;

export type ReferralCodeErrorV2 = {
  __typename?: 'ReferralCodeErrorV2';
  error?: Maybe<Scalars['String']>;
  type: ReferralCodeErrorType;
};

export enum ReferralCodeErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ReferralCodeV2 = {
  __typename?: 'ReferralCodeV2';
  code: Scalars['String'];
  createdAt: Scalars['Float'];
  firstName?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['Float']>;
  personEmail?: Maybe<Scalars['String']>;
  personId: Scalars['String'];
  personName?: Maybe<Scalars['String']>;
};

export type ListSubscriptionInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListSubscriptions = {
  __typename?: 'ListSubscriptions';
  nextCursor?: Maybe<Scalars['String']>;
  subscriptions: Array<SubscriptionV2>;
};

export type SubscriptionV2 = {
  __typename?: 'SubscriptionV2';
  boardId: Scalars['String'];
  cadenceCron: Array<Scalars['String']>;
  cadenceDay?: Maybe<Scalars['Int']>;
  cadenceDescription?: Maybe<Scalars['String']>;
  cadenceEnabled?: Maybe<Scalars['Boolean']>;
  cadenceEndTime?: Maybe<Scalars['String']>;
  cadenceFirstAppearance?: Maybe<Scalars['String']>;
  cadenceLastRun?: Maybe<Scalars['Float']>;
  cadenceMonth?: Maybe<Scalars['String']>;
  cadenceSpecificTimes?: Maybe<Scalars['String']>;
  cadenceStartTime?: Maybe<Scalars['String']>;
  cadenceTags?: Maybe<Scalars['String']>;
  cadenceType?: Maybe<Scalars['String']>;
  cadenceWeekDays?: Maybe<Scalars['String']>;
  configurationUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isV2Installable?: Maybe<Scalars['Boolean']>;
  marketplaceListing?: Maybe<MarketplaceListingV2>;
  marketplaceListingId: Scalars['String'];
  muted?: Maybe<Scalars['Boolean']>;
  subscriptionBoardConnection?: Maybe<SubscriptionBoardConnectionV2>;
  /** Some subscriptions allow you to create your own title. If this is null, assume we're using the marketplace listing title */
  title?: Maybe<Scalars['String']>;
};

export type MarketplaceListingV2 = {
  __typename?: 'MarketplaceListingV2';
  blendedCount?: Maybe<Scalars['Float']>;
  blending: BlendableConfigV2;
  carouselImages: Array<Scalars['String']>;
  categories: Array<MarketplaceCategoryV2>;
  categoryIds?: Maybe<Array<Scalars['String']>>;
  configuration?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  developer?: Maybe<Scalars['String']>;
  enabledInstallationsCount?: Maybe<Scalars['Float']>;
  featuredImage?: Maybe<Scalars['String']>;
  featureTypeIds?: Maybe<Array<Scalars['String']>>;
  featureTypes: Array<MarketplaceFeatureTypeV2>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  installable: InstallableV2;
  installableId: Scalars['ID'];
  installationsCount?: Maybe<Scalars['Float']>;
  installationsInPast30DaysCount?: Maybe<Scalars['Float']>;
  installationsInPast7DaysCount?: Maybe<Scalars['Float']>;
  installDeepLink?: Maybe<Scalars['String']>;
  /** @deprecated Use `blending.isBlendable` */
  isBlendable?: Maybe<Scalars['Boolean']>;
  isFree?: Maybe<Scalars['Boolean']>;
  isSingleton?: Maybe<Scalars['Boolean']>;
  messageSetId?: Maybe<Scalars['String']>;
  noteCarouselImages: Array<Scalars['String']>;
  notePreviewMessage?: Maybe<Scalars['String']>;
  previewMessage?: Maybe<Scalars['String']>;
  questionAndAnswerId?: Maybe<Scalars['String']>;
  releaseAt?: Maybe<Scalars['Float']>;
  releaseDate?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  stagingOnly?: Maybe<Scalars['Boolean']>;
  supportsFlagship?: Maybe<Scalars['Boolean']>;
  supportsNote?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
  versionNumber?: Maybe<Scalars['String']>;
};

export type BlendableConfigV2 = {
  __typename?: 'BlendableConfigV2';
  id?: Maybe<Scalars['String']>;
  isBlendable: Scalars['Boolean'];
  type?: Maybe<Scalars['String']>;
};

export type MarketplaceCategoryV2 = {
  __typename?: 'MarketplaceCategoryV2';
  createdAt: Scalars['Float'];
  id: Scalars['ID'];
  listMarketplaceListings?: Maybe<ListMarketplaceListings>;
  marketplaceListingIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};


export type MarketplaceCategoryV2ListMarketplaceListingsArgs = {
  input?: InputMaybe<ListMarketplaceListingSearchInputV2>;
};

export type ListMarketplaceListingSearchInputV2 = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  productionOnly?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<MarketplaceListingSortByV2>;
  sortDirection?: InputMaybe<MarketplaceListingSortDirectionV2>;
  terms?: InputMaybe<Scalars['String']>;
};

export enum MarketplaceListingSortByV2 {
  CategoryTitles = 'categoryTitles',
  DeveloperName = 'developerName',
  EnabledInstallationsCount = 'enabledInstallationsCount',
  FeatureTypeTitles = 'featureTypeTitles',
  Id = 'id',
  InstallableId = 'installableId',
  InstallableTitle = 'installableTitle',
  InstallationsCount = 'installationsCount',
  InstallationsInPast30DaysCount = 'installationsInPast30DaysCount',
  InstallationsInPast7DaysCount = 'installationsInPast7DaysCount',
  MessageSetId = 'messageSetId',
  ReleaseAt = 'releaseAt',
  Title = 'title'
}

export enum MarketplaceListingSortDirectionV2 {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListMarketplaceListings = {
  __typename?: 'ListMarketplaceListings';
  marketplaceListings: Array<MarketplaceListingV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MarketplaceFeatureTypeV2 = {
  __typename?: 'MarketplaceFeatureTypeV2';
  createdAt: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marketplaceListingIds?: Maybe<Array<Scalars['String']>>;
  marketplaceListings: Array<MarketplaceListingV2>;
  title: Scalars['String'];
};

export type InstallableV2 = {
  __typename?: 'InstallableV2';
  cadenceConfigurationUrl?: Maybe<Scalars['String']>;
  cadenceDisplayTemplate?: Maybe<Scalars['String']>;
  cadenceOnCommand?: Maybe<Scalars['Boolean']>;
  cadenceToken?: Maybe<Scalars['String']>;
  canBeRenamed?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isV2Installable?: Maybe<Scalars['Boolean']>;
  listMarketplaceListings: ListMarketplaceListings;
  subscriptionConfigurationUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type InstallableV2ListMarketplaceListingsArgs = {
  input?: InputMaybe<ListMarketplaceListingInputV2>;
};

export type ListMarketplaceListingInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionBoardConnectionV2 = {
  __typename?: 'SubscriptionBoardConnectionV2';
  board?: Maybe<BoardV2>;
  id: Scalars['ID'];
};

export type OutgoingWebhookV2 = {
  __typename?: 'OutgoingWebhookV2';
  id: Scalars['String'];
  installableId?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  url: Scalars['String'];
};

export type PinnedMessageV2 = {
  __typename?: 'PinnedMessageV2';
  boardId: Scalars['String'];
  id: Scalars['ID'];
  message: MessageV2;
  messageId: Scalars['String'];
  pinUntil: Scalars['Float'];
  secondsToPin: Scalars['Int'];
};

export type QuietHoursV2 = {
  __typename?: 'QuietHoursV2';
  /** The end of quiet hours ex 1400. */
  end?: Maybe<Scalars['String']>;
  /** The end of Friday quiet hours ex 1400. */
  fridayEnd?: Maybe<Scalars['String']>;
  /** The start of Friday quiet hours ex 1300. */
  fridayStart?: Maybe<Scalars['String']>;
  /** The end of Monday quiet hours ex 1400. */
  mondayEnd?: Maybe<Scalars['String']>;
  /** The start of Monday quiet hours ex 1300. */
  mondayStart?: Maybe<Scalars['String']>;
  /** The end of Saturday quiet hours ex 1400. */
  saturdayEnd?: Maybe<Scalars['String']>;
  /** The start of Saturday quiet hours ex 1300. */
  saturdayStart?: Maybe<Scalars['String']>;
  /** The start of quiet hours ex 1300. */
  start?: Maybe<Scalars['String']>;
  /** The end of Sunday quiet hours ex 1400. */
  sundayEnd?: Maybe<Scalars['String']>;
  /** The start of Sunday quiet hours ex 1300. */
  sundayStart?: Maybe<Scalars['String']>;
  /** The end of Thursday quiet hours ex 1400. */
  thursdayEnd?: Maybe<Scalars['String']>;
  /** The start of Thursday quiet hours ex 1300. */
  thursdayStart?: Maybe<Scalars['String']>;
  /** The end of Tuesday quiet hours ex 1400. */
  tuesdayEnd?: Maybe<Scalars['String']>;
  /** The start of Tuesday quiet hours ex 1300. */
  tuesdayStart?: Maybe<Scalars['String']>;
  /** The end of Wednesday quiet hours ex 1400. */
  wednesdayEnd?: Maybe<Scalars['String']>;
  /** The start of Wednesday quiet hours ex 1300. */
  wednesdayStart?: Maybe<Scalars['String']>;
  /** The end of weekend quiet hours ex 1400. */
  weekendEnd?: Maybe<Scalars['String']>;
  /** The start of weekend quiet hours ex 1300. */
  weekendStart?: Maybe<Scalars['String']>;
};

export type BoardResultV2 = BoardErrorV2 | BoardV2;

export type BoardErrorV2 = {
  __typename?: 'BoardErrorV2';
  error?: Maybe<Scalars['String']>;
  type: BoardErrorType;
};

export enum BoardErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type CadenceToCronInputV2 = {
  cadenceDay?: InputMaybe<Scalars['Int']>;
  cadenceEndTime?: InputMaybe<Scalars['String']>;
  cadenceFirstAppearance?: InputMaybe<Scalars['String']>;
  cadenceMonth?: InputMaybe<Scalars['String']>;
  cadenceSpecificTimes?: InputMaybe<Scalars['String']>;
  cadenceStartTime?: InputMaybe<Scalars['String']>;
  cadenceTags?: InputMaybe<Scalars['String']>;
  cadenceType?: InputMaybe<Scalars['String']>;
  cadenceWeekDays?: InputMaybe<Scalars['String']>;
};

export type CadenceToCronResultV2 = {
  __typename?: 'CadenceToCronResultV2';
  cronExpressions: Array<Scalars['String']>;
};

export type ColorTemplate = {
  __typename?: 'ColorTemplate';
  category?: Maybe<ColorTemplateCategory>;
  created: Scalars['Long'];
  deleted?: Maybe<Scalars['Long']>;
  disableForBlack: Scalars['Boolean'];
  disableForWhite: Scalars['Boolean'];
  id: Scalars['String'];
  message: Message;
  sortOrder?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Long']>;
};

export type ColorTemplateCategory = {
  __typename?: 'ColorTemplateCategory';
  colorTemplates: Array<ColorTemplate>;
  colorTemplatesLength: Scalars['Int'];
  created: Scalars['Long'];
  deleted?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  title: Scalars['String'];
  updated?: Maybe<Scalars['Long']>;
};


export type ColorTemplateCategoryColorTemplatesArgs = {
  board?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type ColorTemplateResultV2 = ColorTemplateErrorV2 | ColorTemplateV2;

export type ColorTemplateErrorV2 = {
  __typename?: 'ColorTemplateErrorV2';
  error?: Maybe<Scalars['String']>;
  type: ColorTemplateErrorType;
};

export enum ColorTemplateErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ColorTemplateV2 = {
  __typename?: 'ColorTemplateV2';
  createdAt: Scalars['Float'];
  id: Scalars['ID'];
  messages: Array<MessageV2>;
  title: Scalars['String'];
};

export type ConfigurationNetworkQueryInput = {
  pairingCode: Scalars['String'];
  ssids?: InputMaybe<Array<Scalars['String']>>;
};

export type ConflictingSubscriptionsInputV2 = {
  boardId: Scalars['ID'];
  cronExpressions: Array<Scalars['String']>;
};

export type ConflictingSubscriptionsV2 = {
  __typename?: 'ConflictingSubscriptionsV2';
  conflictingSubscription?: Maybe<SubscriptionV2>;
  hasConflicts: Scalars['Boolean'];
};

export type Contract = {
  __typename?: 'Contract';
  created: Scalars['Long'];
  id: Scalars['String'];
  title: Scalars['String'];
  versions: Array<ContractVersion>;
};

export type ContractVersion = {
  __typename?: 'ContractVersion';
  contents: Scalars['String'];
  contract: Contract;
  created: Scalars['Long'];
  execution?: Maybe<ContractExecution>;
  id: Scalars['String'];
};


export type ContractVersionExecutionArgs = {
  person: Scalars['String'];
};

export type ContractExecution = {
  __typename?: 'ContractExecution';
  contractVersion: ContractVersion;
  created: Scalars['Long'];
  id: Scalars['String'];
  person: Person;
};

export type SearchDistinctMessageInputV2 = {
  allUsers?: InputMaybe<Scalars['Boolean']>;
  boardId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Float']>;
  dateAfter?: InputMaybe<Scalars['Float']>;
  dateBefore?: InputMaybe<Scalars['Float']>;
  dateString?: InputMaybe<Scalars['String']>;
  dateStringAfter?: InputMaybe<Scalars['String']>;
  dateStringBefore?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<DisplayType>;
  distinctBy: SearchDistinctBy;
  limit?: InputMaybe<Scalars['Int']>;
  messageId?: InputMaybe<Scalars['String']>;
  messageTypes?: InputMaybe<Array<MessageType>>;
  personId?: InputMaybe<Scalars['String']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SearchMessageSortBy>;
  sortDirection?: InputMaybe<SearchMessageSortDirection>;
  sources?: InputMaybe<Array<Scalars['String']>>;
  sourceType?: InputMaybe<SourceType>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  term?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<SearchMessageType>>;
};

export enum DisplayType {
  Flagship = 'flagship',
  Note = 'note'
}

export enum SearchDistinctBy {
  Board = 'board',
  Minute = 'minute',
  Person = 'person'
}

export enum MessageType {
  Art = 'art',
  Mixed = 'mixed',
  Text = 'text'
}

export enum SearchMessageSortBy {
  Attribution = 'attribution',
  Date = 'date',
  Likes = 'likes',
  MessageText = 'messageText',
  Moderated = 'moderated'
}

export enum SearchMessageSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SourceType {
  Person = 'Person',
  PlusSubscription = 'PlusSubscription',
  Subscription = 'Subscription'
}

export enum SearchMessageType {
  Draft = 'Draft',
  Favorite = 'Favorite',
  FeedItem = 'FeedItem',
  MessageAppearance = 'MessageAppearance',
  MessageSetMessage = 'MessageSetMessage',
  Pick = 'Pick',
  TemplatedMessage = 'TemplatedMessage'
}

export type SearchDistinctByResultV2 = {
  __typename?: 'SearchDistinctByResultV2';
  items: Array<SearchDistinctByResultItemV2>;
};

export type SearchDistinctByResultItemV2 = {
  __typename?: 'SearchDistinctByResultItemV2';
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  country: Scalars['String'];
  created: Scalars['Long'];
  id: Scalars['String'];
  timezones: Array<TimezoneCity>;
};

export type SearchMessageInputV2 = {
  allUsers?: InputMaybe<Scalars['Boolean']>;
  boardId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Float']>;
  dateAfter?: InputMaybe<Scalars['Float']>;
  dateBefore?: InputMaybe<Scalars['Float']>;
  dateString?: InputMaybe<Scalars['String']>;
  dateStringAfter?: InputMaybe<Scalars['String']>;
  dateStringBefore?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<DisplayType>;
  limit?: InputMaybe<Scalars['Int']>;
  messageId?: InputMaybe<Scalars['String']>;
  messageTypes?: InputMaybe<Array<MessageType>>;
  personId?: InputMaybe<Scalars['String']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<SearchMessageSortBy>;
  sortDirection?: InputMaybe<SearchMessageSortDirection>;
  sources?: InputMaybe<Array<Scalars['String']>>;
  sourceType?: InputMaybe<SourceType>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  term?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<SearchMessageType>>;
};

export type Customer = {
  __typename?: 'Customer';
  created: Scalars['Long'];
  emailAddresses: Array<CustomerEmailAddress>;
  firstName?: Maybe<Scalars['String']>;
  hubSpotContactId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  orders: Array<Order>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type CustomerEmailAddress = {
  __typename?: 'CustomerEmailAddress';
  account?: Maybe<Account>;
  created: Scalars['Long'];
  emailAddress: Scalars['String'];
  id: Scalars['Long'];
};

export type Order = {
  __typename?: 'Order';
  created: Scalars['Long'];
  hubSpotDealId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  offer?: Maybe<Offer>;
  priorityNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  shipmentGroup?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingCountry?: Maybe<Scalars['String']>;
  timelineItems?: Maybe<Array<OrderTimelineItem>>;
};

export type Offer = {
  __typename?: 'Offer';
  created: Scalars['Long'];
  currency: Scalars['String'];
  depositPrice?: Maybe<Scalars['Int']>;
  discountedPrice?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  paymentPlanType: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
  retailPrice: Scalars['Int'];
};

export type OrderTimelineItem = {
  created: Scalars['Long'];
  id: Scalars['String'];
};

export type PaginatedCustomerResponse = {
  __typename?: 'PaginatedCustomerResponse';
  customers: Array<Customer>;
  page: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type DashboardResponse = {
  __typename?: 'DashboardResponse';
  accounts: Scalars['Int'];
  boardDevicePairingsForFlagshipDevices: Scalars['Int'];
  boards: Scalars['Int'];
  devices: Scalars['Int'];
  devicesWithHeartbeat: Scalars['Int'];
  forgetNetworkRequests: Scalars['Int'];
  messages: Scalars['Int'];
  metrics: Array<GqlMetric>;
  monitoringActivations: Array<MonitoringActivation>;
  subscriptions: Scalars['Int'];
  tenantSpecificInstallables: Scalars['Int'];
};

export type GqlMetric = {
  __typename?: 'GqlMetric';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  subsets: Array<GqlMetric>;
  unit: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type ListDevelopersInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type DeviceQueryResponse = {
  __typename?: 'DeviceQueryResponse';
  count: Scalars['Int'];
  devices: Array<Device>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type GqlGmtOffsetDevices = {
  __typename?: 'GqlGmtOffsetDevices';
  devices: Array<Device>;
  devicesCount: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  yoctoStatuses: Array<GqlGmtOffsetDevicesYoctoBreakdown>;
};


export type GqlGmtOffsetDevicesDevicesArgs = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};

export type GqlGmtOffsetDevicesYoctoBreakdown = {
  __typename?: 'GqlGmtOffsetDevicesYoctoBreakdown';
  count: Scalars['Int'];
  yoctoStatus: Scalars['String'];
};

export type FeaturedMarketplaceItem = {
  __typename?: 'FeaturedMarketplaceItem';
  description?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  imageMedia?: Maybe<Media>;
  imageVariantMedia?: Maybe<Media>;
  marketplaceListing: MarketplaceListing;
};

export type FeedItemResultV2 = FeedItemErrorV2 | FeedItemV2;

export type FeedItemErrorV2 = {
  __typename?: 'FeedItemErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FeedItemErrorType;
};

export enum FeedItemErrorType {
  Censored = 'Censored',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type FeedTagResultV2 = FeedTagErrorV2 | FeedTagV2;

export type FeedTagErrorV2 = {
  __typename?: 'FeedTagErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FeedTagErrorType;
};

export enum FeedTagErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type FirmwareUpgradeModalResponse = {
  __typename?: 'FirmwareUpgradeModalResponse';
  board: Scalars['String'];
  pairedDevices: Array<FirmwareUpgradeModalPairedDevice>;
};

export type FirmwareUpgradeModalPairedDevice = {
  __typename?: 'FirmwareUpgradeModalPairedDevice';
  device: Scalars['String'];
  latestHeartbeat?: Maybe<FirmwareUpgradeModalLatestHeartbeat>;
  pairingCode: Scalars['String'];
};

export type FirmwareUpgradeModalLatestHeartbeat = {
  __typename?: 'FirmwareUpgradeModalLatestHeartbeat';
  networks: Array<FirmwareUpgradeModalNetwork>;
};

export type FirmwareUpgradeModalNetwork = {
  __typename?: 'FirmwareUpgradeModalNetwork';
  iface: Scalars['String'];
  ipAddress: Scalars['String'];
};

export type FlagshipDeviceResultV2 = FlagshipDeviceErrorV2 | FlagshipDeviceV2;

export type FlagshipDeviceErrorV2 = {
  __typename?: 'FlagshipDeviceErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FlagshipDeviceErrorType;
};

export enum FlagshipDeviceErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type BlendedResultV2 = BlendedErrorV2 | BlendedV2;

export type BlendedErrorV2 = {
  __typename?: 'BlendedErrorV2';
  error?: Maybe<Scalars['String']>;
  type: BlendedErrorType;
};

export enum BlendedErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type DisplayGroupResultV2 = DisplayGroupErrorV2 | DisplayGroupV2;

export type DisplayGroupErrorV2 = {
  __typename?: 'DisplayGroupErrorV2';
  error?: Maybe<Scalars['String']>;
  type: DisplayGroupErrorType;
};

export enum DisplayGroupErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type DisplayGroupV2 = {
  __typename?: 'DisplayGroupV2';
  boards: Array<Array<DisplayGroupBoard>>;
  createdAt: Scalars['Float'];
  id: Scalars['ID'];
  ownerId: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type DisplayGroupBoard = {
  __typename?: 'DisplayGroupBoard';
  boardStyle: Scalars['String'];
  id: Scalars['ID'];
};

export type GetMasterPairingInputV2 = {
  boardId: Scalars['String'];
  deviceId: Scalars['String'];
};

export type MasterPairingResultV2 = MasterPairingErrorV2 | MasterPairingV2;

export type MasterPairingErrorV2 = {
  __typename?: 'MasterPairingErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MasterPairingErrorType;
};

export enum MasterPairingErrorType {
  AlreadyExists = 'AlreadyExists',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MasterPairingV2 = {
  __typename?: 'MasterPairingV2';
  accountEmailAddress?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  boardCreated?: Maybe<Scalars['Float']>;
  boardId: Scalars['String'];
  boardTitle?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  dealId?: Maybe<Scalars['String']>;
  deviceId: Scalars['String'];
  hubspotMessage?: Maybe<Scalars['String']>;
  hubspotUpdated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  manualReviewFlag?: Maybe<Scalars['Boolean']>;
  manualReviewMessage?: Maybe<Scalars['String']>;
  memberEmailAddresses?: Maybe<Array<Scalars['String']>>;
  memberIds?: Maybe<Array<Scalars['String']>>;
  pairingDate?: Maybe<Scalars['Float']>;
  personFirstName?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['String']>;
  personLastName?: Maybe<Scalars['String']>;
  plusApplicationDate?: Maybe<Scalars['Float']>;
  plusRenewalDate?: Maybe<Scalars['Float']>;
  plusRenewalFrequency?: Maybe<Scalars['String']>;
  synced?: Maybe<Scalars['Boolean']>;
};

export type GetMessageSetVersionInputV2 = {
  id: Scalars['ID'];
  messageSetId: Scalars['ID'];
};

export type MessageSetVersionResultV2 = MessageSetVersionErrorV2 | MessageSetVersionV2;

export type MessageSetVersionErrorV2 = {
  __typename?: 'MessageSetVersionErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MessageSetVersionErrorType;
};

export enum MessageSetVersionErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MessageSetVersionV2 = {
  __typename?: 'MessageSetVersionV2';
  createdAt: Scalars['Float'];
  id: Scalars['ID'];
  messageIds: Array<Scalars['String']>;
  messages: Array<MessageV2>;
  messageSetId: Scalars['ID'];
  title: Scalars['String'];
};

export type SearchTermAnalyticsV2 = {
  __typename?: 'SearchTermAnalyticsV2';
  breakdown?: Maybe<Array<SearchTermAnalyticsBreakdownV2>>;
  count: Scalars['Float'];
  term: Scalars['String'];
};


export type SearchTermAnalyticsV2BreakdownArgs = {
  input: ListSearchTermAnalyticsBreakdownInputV2;
};

export type ListSearchTermAnalyticsBreakdownInputV2 = {
  /** date(YYYY, M, D) or date(YYYY, M, D, h, m) */
  end: Scalars['String'];
  period: SearchTermAnalyticsBreakdownPeriod;
  /** date(YYYY, M, D) or date(YYYY, M, D, h, m) */
  start: Scalars['String'];
};

export enum SearchTermAnalyticsBreakdownPeriod {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Week = 'week'
}

export type SearchTermAnalyticsBreakdownV2 = {
  __typename?: 'SearchTermAnalyticsBreakdownV2';
  key?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type ListHomeScreenBannersInputV2 = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type HomeScreenBannerV2 = {
  __typename?: 'HomeScreenBannerV2';
  backgroundColor?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<HomeScreenBannerButtonV2>>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  positionInFeed: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type HomeScreenBannerButtonV2 = {
  __typename?: 'HomeScreenBannerButtonV2';
  deepLinkUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type HomeScreenBannerResultV2 = HomeScreenBannerErrorV2 | HomeScreenBannerV2;

export type HomeScreenBannerErrorV2 = {
  __typename?: 'HomeScreenBannerErrorV2';
  error?: Maybe<Scalars['String']>;
  type: HomeScreenBannerErrorTypeV2;
};

export enum HomeScreenBannerErrorTypeV2 {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound',
  Unknown = 'Unknown'
}

export type InstallableResultV2 = InstallableErrorV2 | InstallableV2;

export type InstallableErrorV2 = {
  __typename?: 'InstallableErrorV2';
  error?: Maybe<Scalars['String']>;
  type: InstallableErrorType;
};

export enum InstallableErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ListAcceptedReferralInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<AcceptedReferralSortBy>;
  sortDirection?: InputMaybe<AcceptedReferralSortDirection>;
};

export enum AcceptedReferralSortBy {
  CreatedAt = 'createdAt',
  CreditRedeemed = 'creditRedeemed',
  Invalidated = 'invalidated',
  Notified = 'notified',
  OrderDeliveredAt = 'orderDeliveredAt',
  PurchaseId = 'purchaseId',
  ReferrerEmail = 'referrerEmail',
  ReferrerName = 'referrerName',
  ReferrerPersonId = 'referrerPersonId',
  ShopifyCustomerEmail = 'shopifyCustomerEmail',
  ShopifyCustomerName = 'shopifyCustomerName',
  ShopifyOrderName = 'shopifyOrderName'
}

export enum AcceptedReferralSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListAcceptedReferrals = {
  __typename?: 'ListAcceptedReferrals';
  acceptedReferrals: Array<AcceptedReferralV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type BoardDeviceAssociationInput = {
  boardCreated?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  boardDeleted?: InputMaybe<Scalars['Boolean']>;
  boardDeviceAssociationCreated?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  channels?: InputMaybe<BoardDeviceAssociationRangeInput>;
  deviceCreated?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  deviceLastSeen?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  deviceModelTitle?: InputMaybe<Scalars['String']>;
  enabledChannels?: InputMaybe<BoardDeviceAssociationRangeInput>;
  firmwareVersion?: InputMaybe<Scalars['String']>;
  friendlyIdentifier?: InputMaybe<Scalars['String']>;
  hubspotDealId?: InputMaybe<Scalars['String']>;
  internalBoard?: InputMaybe<Scalars['Boolean']>;
  isPlus?: InputMaybe<Scalars['Boolean']>;
  lastIndexed?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  lastMessage?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  membersCount?: InputMaybe<Scalars['Int']>;
  messagesAllTime?: InputMaybe<BoardDeviceAssociationRangeInput>;
  messagesInPastDay?: InputMaybe<BoardDeviceAssociationRangeInput>;
  messagesInPastSevenDays?: InputMaybe<BoardDeviceAssociationRangeInput>;
  messagesInPastThirtyDays?: InputMaybe<BoardDeviceAssociationRangeInput>;
  mysteryBoards?: InputMaybe<Scalars['Boolean']>;
  online?: InputMaybe<Scalars['Boolean']>;
  osVersionBuildId?: InputMaybe<Scalars['String']>;
  osVersionId?: InputMaybe<Scalars['String']>;
  osVersionName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  productApplicationCreated?: InputMaybe<BoardDeviceAssociationDateRangeInput>;
  productPricingRecurringFrequency?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<BoardDeviceAssociationSortBy>;
  sortOrder?: InputMaybe<BoardDeviceAssociationSortOrder>;
  terms?: InputMaybe<Scalars['String']>;
  yoctoStatus?: InputMaybe<Scalars['String']>;
};

export type BoardDeviceAssociationDateRangeInput = {
  max: Scalars['Long'];
  min: Scalars['Long'];
};

export type BoardDeviceAssociationRangeInput = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum BoardDeviceAssociationSortBy {
  AccountEmailAddress = 'accountEmailAddress',
  AccountId = 'accountId',
  BoardCreated = 'boardCreated',
  BoardDeleted = 'boardDeleted',
  BoardDeviceAssociationCreated = 'boardDeviceAssociationCreated',
  BoardDeviceAssociationId = 'boardDeviceAssociationId',
  BoardId = 'boardId',
  BoardTitle = 'boardTitle',
  Channels = 'channels',
  DeviceCreated = 'deviceCreated',
  DeviceId = 'deviceId',
  DeviceLastSeen = 'deviceLastSeen',
  DeviceModelId = 'deviceModelId',
  DeviceModelTitle = 'deviceModelTitle',
  EnabledChannels = 'enabledChannels',
  FirmwareVersion = 'firmwareVersion',
  FriendlyIdentifier = 'friendlyIdentifier',
  HubspotDealId = 'hubspotDealId',
  InternalBoard = 'internalBoard',
  LastIndexed = 'lastIndexed',
  LastMessage = 'lastMessage',
  MembersCount = 'membersCount',
  MessagesAllTime = 'messagesAllTime',
  MessagesInPastDay = 'messagesInPastDay',
  MessagesInPastSevenDays = 'messagesInPastSevenDays',
  MessagesInPastThirtyDays = 'messagesInPastThirtyDays',
  Online = 'online',
  OsVersionBuildId = 'osVersionBuildId',
  OsVersionId = 'osVersionId',
  OsVersionName = 'osVersionName',
  PairingCode = 'pairingCode',
  PersonFirstName = 'personFirstName',
  PersonId = 'personId',
  PersonLastName = 'personLastName',
  ProductApplicationCreated = 'productApplicationCreated',
  ProductApplicationId = 'productApplicationId',
  ProductPricingId = 'productPricingId',
  ProductPricingRecurringFrequency = 'productPricingRecurringFrequency',
  Ssid = 'ssid',
  TransitionStrategy = 'transitionStrategy',
  YoctoStatus = 'yoctoStatus'
}

export enum BoardDeviceAssociationSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaginatedBoardDeviceAssociations = {
  __typename?: 'PaginatedBoardDeviceAssociations';
  boardDeviceAssociations: Array<BoardDeviceAssociation>;
  pagination: Pagination;
};

export type BoardDeviceAssociation = {
  __typename?: 'BoardDeviceAssociation';
  accountEmailAddress?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  board?: Maybe<Board>;
  boardCreated?: Maybe<Scalars['Long']>;
  boardDeleted: Scalars['Boolean'];
  boardDeviceAssociationCreated?: Maybe<Scalars['Long']>;
  boardId: Scalars['String'];
  boardTitle: Scalars['String'];
  channels: Scalars['Int'];
  created?: Maybe<Scalars['Long']>;
  device?: Maybe<Device>;
  deviceCreated?: Maybe<Scalars['Long']>;
  deviceId: Scalars['String'];
  deviceLastSeen?: Maybe<Scalars['Long']>;
  deviceModelId?: Maybe<Scalars['String']>;
  deviceModelTitle?: Maybe<Scalars['String']>;
  enabledChannels: Scalars['Int'];
  firmwareVersion?: Maybe<Scalars['String']>;
  hubspotDealId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalBoard: Scalars['Boolean'];
  lastIndexed?: Maybe<Scalars['Long']>;
  lastMessage?: Maybe<Scalars['Long']>;
  memberEmailAddresses: Array<Scalars['String']>;
  memberIds: Array<Scalars['String']>;
  messagesAllTime?: Maybe<Scalars['Int']>;
  messagesInPastDay?: Maybe<Scalars['Int']>;
  messagesInPastSevenDays?: Maybe<Scalars['Int']>;
  messagesInPastThirtyDays?: Maybe<Scalars['Int']>;
  online: Scalars['Boolean'];
  osVersionBuildId: Scalars['String'];
  osVersionId: Scalars['String'];
  osVersionName: Scalars['String'];
  pairingCode?: Maybe<Scalars['String']>;
  personFirstName?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['String']>;
  personLastName?: Maybe<Scalars['String']>;
  productApplicationCreated?: Maybe<Scalars['Long']>;
  productApplicationId?: Maybe<Scalars['String']>;
  productPricingId?: Maybe<Scalars['String']>;
  productPricingRecurringFrequency?: Maybe<Scalars['String']>;
  ssid?: Maybe<Scalars['String']>;
  transitionStepSize?: Maybe<Scalars['Int']>;
  transitionStrategy?: Maybe<Scalars['String']>;
  yoctoStatus?: Maybe<Scalars['String']>;
};

export type ListBoardMessageAppearancesInputV2 = {
  boardId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<MessageAppearanceSortDirection>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export enum MessageAppearanceSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListColorTemplateInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListColorTemplateV2 = {
  __typename?: 'ListColorTemplateV2';
  colorTemplates: Array<ColorTemplateIndexV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ColorTemplateIndexV2 = {
  __typename?: 'ColorTemplateIndexV2';
  id: Scalars['ID'];
  messages: Array<MessageV2>;
  messagesCount: Scalars['Int'];
  title: Scalars['String'];
};

export type ListDealAssociationsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type ListDealAssociationsV2 = {
  __typename?: 'ListDealAssociationsV2';
  dealAssociations: Array<DealAssociationV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type DealAssociationV2 = {
  __typename?: 'DealAssociationV2';
  dealId: Scalars['String'];
  emailAddress: Scalars['String'];
  id: Scalars['ID'];
};

export type ListDigitalDeviceStylesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListDigitalDeviceStylesV2 = {
  __typename?: 'ListDigitalDeviceStylesV2';
  digitalDeviceStyles: Array<DigitalDeviceStyleV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListDigitalDevicesInputV2 = {
  /** For SuperAdmins: list all digital devices and not just the devices for a user */
  all?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type ListDigitalDevicesV2 = {
  __typename?: 'ListDigitalDevicesV2';
  digitalDevices: Array<DigitalDeviceV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListDisplayGroups = {
  __typename?: 'ListDisplayGroups';
  displayGroups: Array<DisplayGroupV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListFavoriteSourcesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFavoriteSourcesV2 = {
  __typename?: 'ListFavoriteSourcesV2';
  favoriteSources: Array<FavoriteSourceV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type FavoriteSourceV2 = {
  __typename?: 'FavoriteSourceV2';
  id: Scalars['ID'];
  personId: Scalars['String'];
  title: Scalars['String'];
};

export type ListFeedTagsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListFeedTagsV2 = {
  __typename?: 'ListFeedTagsV2';
  feedTags: Array<FeedTagV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListFeedItemFlagsByPersonInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId: Scalars['String'];
};

export type ListFlagsByPersonInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId: Scalars['String'];
};

export type ListFlagshipDeviceInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListingReportResponse = {
  __typename?: 'ListingReportResponse';
  rows: Array<ListingReportRow>;
};

export type ListingReportRow = {
  __typename?: 'ListingReportRow';
  channels: Scalars['Int'];
  enabledChannels: Scalars['Int'];
  installable: Installable;
  listing: MarketplaceListing;
};

export type ListInspirationInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<InspirationSortDirection>;
};

export enum InspirationSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListInspirationV2 = {
  __typename?: 'ListInspirationV2';
  items: Array<InspirationV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type InspirationV2 = {
  __typename?: 'InspirationV2';
  feedItem?: Maybe<FeedItemV2>;
  id: Scalars['ID'];
  pick?: Maybe<PickV2>;
};

export type ListInstallableInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListInstallables = {
  __typename?: 'ListInstallables';
  installables: Array<InstallableV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMarketplaceCategoryInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListMarketplaceCategories = {
  __typename?: 'ListMarketplaceCategories';
  marketplaceCategories: Array<MarketplaceCategoryV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMarketplaceFeatureTypeInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<MarketplaceFeatureTypeTypes>>;
};

export enum MarketplaceFeatureTypeTypes {
  Dynamic = 'Dynamic',
  Static = 'Static'
}

export type ListMarketplaceFeatureTypes = {
  __typename?: 'ListMarketplaceFeatureTypes';
  marketplaceFeatureTypes: Array<MarketplaceFeatureTypeV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MarketplaceListingInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  productionOnly?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<MarketplaceListingSortBy>;
  sortOrder?: InputMaybe<MarketplaceListingSortOrder>;
  supportsFlagship?: InputMaybe<Scalars['Boolean']>;
  supportsNote?: InputMaybe<Scalars['Boolean']>;
  terms?: InputMaybe<Scalars['String']>;
};

export enum MarketplaceListingSortBy {
  Categories = 'categories',
  DeveloperId = 'developerId',
  DeveloperName = 'developerName',
  EnabledSubscriptionsCount = 'enabledSubscriptionsCount',
  FeatureTypes = 'featureTypes',
  Id = 'id',
  InstallableId = 'installableId',
  InstallableTitle = 'installableTitle',
  InstallationsCount = 'installationsCount',
  MessageSetId = 'messageSetId',
  MessageSetTitle = 'messageSetTitle',
  ReleaseDate = 'releaseDate',
  SubscriptionsCount = 'subscriptionsCount',
  SubscriptionsInPast30DaysCount = 'subscriptionsInPast30DaysCount',
  SubscriptionsInPast7DaysCount = 'subscriptionsInPast7DaysCount',
  Title = 'title'
}

export enum MarketplaceListingSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaginatedMarketplaceListings = {
  __typename?: 'PaginatedMarketplaceListings';
  marketplaceListings: Array<MarketplaceListingDocument>;
  pagination: Pagination;
};

export type MarketplaceListingDocument = {
  __typename?: 'MarketplaceListingDocument';
  categoryIds: Array<Scalars['String']>;
  created?: Maybe<Scalars['Long']>;
  deleted?: Maybe<Scalars['Long']>;
  description?: Maybe<Scalars['String']>;
  developerId?: Maybe<Scalars['String']>;
  developerName?: Maybe<Scalars['String']>;
  enabledSubscriptionsCount?: Maybe<Scalars['Int']>;
  featureTypes: Array<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installableCreated?: Maybe<Scalars['Long']>;
  installableId?: Maybe<Scalars['String']>;
  installableTitle?: Maybe<Scalars['String']>;
  installationsCount?: Maybe<Scalars['Int']>;
  listing: MarketplaceListing;
  messageSetId?: Maybe<Scalars['String']>;
  messageSetTitle?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['Long']>;
  shortDescription?: Maybe<Scalars['String']>;
  subscriptionsCount?: Maybe<Scalars['Int']>;
  subscriptionsInPast30DaysCount?: Maybe<Scalars['Int']>;
  subscriptionsInPast7DaysCount?: Maybe<Scalars['Int']>;
  supportsFlagship: Scalars['Boolean'];
  supportsNote: Scalars['Boolean'];
  tags?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ListMasterPairingInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<MasterPairingSortBy>;
  sortDirection?: InputMaybe<MasterPairingSortDirection>;
};

export enum MasterPairingSortBy {
  BoardCreated = 'boardCreated',
  CreatedAt = 'createdAt',
  PairingDate = 'pairingDate',
  PlusApplicationDate = 'plusApplicationDate',
  PlusRenewalDate = 'plusRenewalDate'
}

export enum MasterPairingSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListMasterPairingsV2 = {
  __typename?: 'ListMasterPairingsV2';
  masterPairings: Array<MasterPairingV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMessageSetInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  dynamic?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  public?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<MessageSetSortBy>;
  sortDirection?: InputMaybe<MessageSetSortDirection>;
  title?: InputMaybe<Scalars['String']>;
};

export enum MessageSetSortBy {
  Dynamic = 'dynamic',
  MessagesCount = 'messagesCount',
  Public = 'public',
  Title = 'title'
}

export enum MessageSetSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListMessageSetV2 = {
  __typename?: 'ListMessageSetV2';
  messageSets: Array<MessageSetIndexV2>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MessageSetIndexV2 = {
  __typename?: 'MessageSetIndexV2';
  currentVersion?: Maybe<MessageSetVersionV2>;
  currentVersionId?: Maybe<Scalars['String']>;
  dynamic?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  messages: Array<MessageV2>;
  messagesCount: Scalars['Int'];
  public: Scalars['Boolean'];
  rssUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ListMessageSetVersionInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  messageSetId: Scalars['ID'];
};

export type ListMessageSetVersionV2 = {
  __typename?: 'ListMessageSetVersionV2';
  nextCursor?: Maybe<Scalars['String']>;
  versions: Array<MessageSetVersionV2>;
};

export type ListMessageSourcesByBoardInputV2 = {
  boardId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type ListNotificationSegmentInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListNotificationSegments = {
  __typename?: 'ListNotificationSegments';
  nextCursor?: Maybe<Scalars['String']>;
  notificationSegments: Array<NotificationSegmentV2>;
};

export type ListNotificationTagInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListNotificationTags = {
  __typename?: 'ListNotificationTags';
  nextCursor?: Maybe<Scalars['String']>;
  notificationTags: Array<NotificationTagV2>;
};

export type ListPersonDraftsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
};

export type ListPersonFavoritesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<FavoriteSortDirection>;
};

export enum FavoriteSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListPersonLikesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  personId: Scalars['String'];
};

export type ListPersonInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListPersons = {
  __typename?: 'ListPersons';
  nextCursor?: Maybe<Scalars['String']>;
  persons: Array<PersonV2>;
};

export type ListPickCategoriesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListPickCategoriesV2 = {
  __typename?: 'ListPickCategoriesV2';
  nextCursor?: Maybe<Scalars['String']>;
  pickCategories: Array<PickCategoryV2>;
};

export enum PlusRenewalFailureSortBy {
  Created = 'created',
  ErrorCode = 'errorCode',
  ErrorMessage = 'errorMessage',
  Id = 'id',
  ProductApplicationId = 'productApplicationId'
}

export enum PlusRenewalFailureSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaginatedPlusRenewalFailures = {
  __typename?: 'PaginatedPlusRenewalFailures';
  pagination: Pagination;
  plusRenewalFailures: Array<PlusRenewalFailure>;
};

export type PlusRenewalFailure = {
  __typename?: 'PlusRenewalFailure';
  created: Scalars['Long'];
  details?: Maybe<Scalars['String']>;
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
  id: Scalars['String'];
  productApplication?: Maybe<ProductApplication>;
};

export enum PurchaseSortBy {
  Created = 'created',
  Email = 'email',
  Id = 'id',
  PersonId = 'personId',
  ProductApplicationId = 'productApplicationId',
  ShopifyOrderId = 'shopifyOrderId',
  ShopifyOrderName = 'shopifyOrderName'
}

export enum PurchaseSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type PaginatedPurchases = {
  __typename?: 'PaginatedPurchases';
  pagination: Pagination;
  purchases: Array<PlusPurchaseSessionPurchase>;
};

export type ListRoleInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListSearchMessagesUnionV2 = {
  __typename?: 'ListSearchMessagesUnionV2';
  nextCursor?: Maybe<Scalars['String']>;
  searchMessages: Array<SearchMessageUnionV2>;
};

export type SearchMessageUnionV2 = DraftV2 | FavoriteV2 | FeedItemV2 | MessageAppearanceV2 | MessageSetMessageV2 | PickV2 | TemplateMessageV2;

export type MessageSetMessageV2 = {
  __typename?: 'MessageSetMessageV2';
  attribution: Scalars['String'];
  created: Scalars['Float'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: MessageV2;
  messageId: Scalars['String'];
  messageSet: MessageSetIndexV2;
  messageSetId: Scalars['String'];
};


export type MessageSetMessageV2IconArgs = {
  size?: InputMaybe<MessageIconSize>;
};

export type ListSubmittedMessageSetInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListSubmittedMessageSets = {
  __typename?: 'ListSubmittedMessageSets';
  nextCursor?: Maybe<Scalars['String']>;
  submittedMessageSets: Array<SubmittedMessageSetV2>;
};

export type SubmittedMessageSetV2 = {
  __typename?: 'SubmittedMessageSetV2';
  createdAt: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messageIds: Array<Scalars['String']>;
  messages: Array<MessageV2>;
  personId: Scalars['String'];
  personName: Scalars['String'];
  title: Scalars['String'];
};

export type ListSystemMessageTemplatesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type ListSystemMessageTemplatesV2 = {
  __typename?: 'ListSystemMessageTemplatesV2';
  nextCursor?: Maybe<Scalars['String']>;
  systemMessageTemplates: Array<SystemMessageTemplateV2>;
};

export type SystemMessageTemplateV2 = {
  __typename?: 'SystemMessageTemplateV2';
  callToAction?: Maybe<Scalars['String']>;
  deepLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  section?: Maybe<Scalars['String']>;
  template: Scalars['String'];
  title: Scalars['String'];
};

export type ListTemplateCategoriesInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListTemplateCategoriesV2 = {
  __typename?: 'ListTemplateCategoriesV2';
  nextCursor?: Maybe<Scalars['String']>;
  templateCategories: Array<TemplateCategoryV2>;
};

export type ListTemplateMessageSuggestionsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type ListTemplateMessageSuggestionsV2 = {
  __typename?: 'ListTemplateMessageSuggestionsV2';
  nextCursor?: Maybe<Scalars['String']>;
  templateMessageSuggestions: Array<TemplateMessageSuggestionV2>;
};

export type TemplateMessageSuggestionV2 = {
  __typename?: 'TemplateMessageSuggestionV2';
  created: Scalars['Float'];
  id: Scalars['String'];
  message: MessageV2;
  messageId: Scalars['String'];
  personId: Scalars['String'];
};

export type ListTemplateMessagesInputV2 = {
  categoryId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<TemplateDisplayType>;
  limit?: InputMaybe<Scalars['Int']>;
  messageId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<TemplateMessageSortBy>;
  sortDirection?: InputMaybe<TemplateMessageSortDirection>;
};

export enum TemplateDisplayType {
  Flagship = 'flagship',
  Note = 'note'
}

export enum TemplateMessageSortBy {
  Featured = 'featured',
  New = 'new',
  Top = 'top'
}

export enum TemplateMessageSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type ListTemplateMessagesV2 = {
  __typename?: 'ListTemplateMessagesV2';
  nextCursor?: Maybe<Scalars['String']>;
  templateMessages: Array<TemplateMessageV2>;
};

export type ListSearchTermAnalyticsInputV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  terms?: InputMaybe<Scalars['String']>;
};

export type ListSearchTermAnalyticsV2 = {
  __typename?: 'ListSearchTermAnalyticsV2';
  nextCursor?: Maybe<Scalars['String']>;
  searchTermAnalytics: Array<SearchTermAnalyticsV2>;
};

export type MarketplaceCategoryResultV2 = MarketplaceCategoryErrorV2 | MarketplaceCategoryV2;

export type MarketplaceCategoryErrorV2 = {
  __typename?: 'MarketplaceCategoryErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MarketplaceCategoryErrorType;
};

export enum MarketplaceCategoryErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MarketplaceFeatureTypeResultV2 = MarketplaceFeatureTypeErrorV2 | MarketplaceFeatureTypeV2;

export type MarketplaceFeatureTypeErrorV2 = {
  __typename?: 'MarketplaceFeatureTypeErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MarketplaceFeatureTypeErrorType;
};

export enum MarketplaceFeatureTypeErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MarketplaceGalleryResultV2 = MarketplaceGalleryErrorV2 | MarketplaceGalleryV2;

export type MarketplaceGalleryErrorV2 = {
  __typename?: 'MarketplaceGalleryErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MarketplaceGalleryErrorType;
};

export enum MarketplaceGalleryErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MarketplaceGalleryV2 = {
  __typename?: 'MarketplaceGalleryV2';
  id: Scalars['ID'];
  items: Array<MarketplaceGalleryItemV2>;
};

export type MarketplaceGalleryItemV2 = {
  __typename?: 'MarketplaceGalleryItemV2';
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  marketplaceListing: MarketplaceListingV2;
  marketplaceListingId: Scalars['String'];
};

export type MarketplaceFeatureTypesInput = {
  includeDynamic: Scalars['Boolean'];
};

export type MarketplaceListingResultV2 = MarketplaceListingErrorV2 | MarketplaceListingV2;

export type MarketplaceListingErrorV2 = {
  __typename?: 'MarketplaceListingErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MarketplaceListingErrorType;
};

export enum MarketplaceListingErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MessageAnalyticsV2 = {
  __typename?: 'MessageAnalyticsV2';
  allTimeMessageCount: Scalars['Float'];
  messageCount: Scalars['Float'];
  northStar: Scalars['Float'];
};


export type MessageAnalyticsV2MessageCountArgs = {
  input: MessagesCountInputV2;
};


export type MessageAnalyticsV2NorthStarArgs = {
  date: Scalars['String'];
};

export type MessagesCountInputV2 = {
  /** Number of days to look back for messages from the date. Defaults to 1. */
  count?: InputMaybe<Scalars['Float']>;
  /** Date in YYYY-MM-DD format to look back from. Defaults to today's date. */
  date?: InputMaybe<Scalars['String']>;
};

export type MessageAppearanceMigrateV2 = {
  __typename?: 'MessageAppearanceMigrateV2';
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type MessageAppearanceResultV2 = MessageAppearanceErrorV2 | MessageAppearanceV2;

export type MessageAppearanceErrorV2 = {
  __typename?: 'MessageAppearanceErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MessageAppearanceErrorType;
};

export enum MessageAppearanceErrorType {
  FingerprintMatch = 'FingerprintMatch',
  MessagePinned = 'MessagePinned',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound',
  QuietHours = 'QuietHours',
  RateLimited = 'RateLimited',
  ServerError = 'ServerError',
  SubscriptionHold = 'SubscriptionHold'
}

export type MessageSetResultV2 = MessageSetErrorV2 | MessageSetV2;

export type MessageSetErrorV2 = {
  __typename?: 'MessageSetErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MessageSetErrorType;
};

export enum MessageSetErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MessageSetV2 = {
  __typename?: 'MessageSetV2';
  createdAt: Scalars['Float'];
  currentVersionId?: Maybe<Scalars['ID']>;
  dynamic?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  messages: Array<MessageV2>;
  messagesV2: Array<MessageV2>;
  public: Scalars['Boolean'];
  rssUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GqlMessageSetVersionSubmission = {
  __typename?: 'GqlMessageSetVersionSubmission';
  board?: Maybe<Board>;
  created: Scalars['Long'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Media>;
  id: Scalars['String'];
  messageSetVersion: MessageSetVersion;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  title?: Maybe<Scalars['String']>;
};

export type MessageResultV2 = MessageErrorV2 | MessageV2;

export type MessageErrorV2 = {
  __typename?: 'MessageErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MessageErrorType;
};

export enum MessageErrorType {
  CharactersInvalid = 'CharactersInvalid',
  MissingTextOrCharacters = 'MissingTextOrCharacters',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound',
  TextTooLong = 'TextTooLong',
  Unknown = 'Unknown'
}

export type NotificationSegmentResultV2 = NotificationSegmentErrorV2 | NotificationSegmentV2;

export type NotificationSegmentErrorV2 = {
  __typename?: 'NotificationSegmentErrorV2';
  error?: Maybe<Scalars['String']>;
  type: NotificationSegmentErrorType;
};

export enum NotificationSegmentErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type NotificationTagResultV2 = NotificationTagErrorV2 | NotificationTagV2;

export type NotificationTagErrorV2 = {
  __typename?: 'NotificationTagErrorV2';
  error?: Maybe<Scalars['String']>;
  type: NotificationTagErrorType;
};

export enum NotificationTagErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type NotificationResultV2 = NotificationErrorV2 | NotificationV2;

export type NotificationErrorV2 = {
  __typename?: 'NotificationErrorV2';
  error?: Maybe<Scalars['String']>;
  type: NotificationErrorType;
};

export enum NotificationErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type PaginatedOrderResponse = {
  __typename?: 'PaginatedOrderResponse';
  orders: Array<Order>;
  page: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type OsVersion = {
  __typename?: 'OSVersion';
  commitSha: Scalars['String'];
  contents: Array<OsVersionContent>;
  created: Scalars['Long'];
  deploy?: Maybe<Scalars['Boolean']>;
  deployedBy?: Maybe<Person>;
  downloadLink: Scalars['String'];
  hawkbitSoftwareModule?: Maybe<Scalars['String']>;
  hawkbitSoftwareModuleArtifact?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
  production?: Maybe<Scalars['Boolean']>;
  swuDownloadLink: Scalars['String'];
  uploaded?: Maybe<Scalars['Boolean']>;
};

export type OsVersionContent = {
  __typename?: 'OSVersionContent';
  filename: Scalars['String'];
  size: Scalars['Int'];
};

export type DeployedOsVersion = {
  __typename?: 'DeployedOsVersion';
  commitSha: Scalars['String'];
  created: Scalars['Long'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
};

export type PaginatedPaymentsResponse = {
  __typename?: 'PaginatedPaymentsResponse';
  page: Scalars['Int'];
  payments: Array<Payment>;
  totalCount: Scalars['Int'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int'];
  created: Scalars['Long'];
  id: Scalars['String'];
  orders: Array<PaymentOrder>;
  stripeChargeId?: Maybe<Scalars['String']>;
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  amount: Scalars['Int'];
  order: Order;
};

export type PersonResultV2 = PersonErrorV2 | PersonV2;

export type PersonErrorV2 = {
  __typename?: 'PersonErrorV2';
  error?: Maybe<Scalars['String']>;
  type: PersonErrorType;
};

export enum PersonErrorType {
  EmailExists = 'EmailExists',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type Pick = {
  __typename?: 'Pick';
  categories: Array<PickCategory>;
  created: Scalars['Long'];
  deduplicationId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  message: Message;
  recommendAfter: Scalars['Long'];
  recommendation: Recommendation;
  recommendBefore: Scalars['Long'];
  updated?: Maybe<Scalars['Long']>;
};

export type PickCategory = {
  __typename?: 'PickCategory';
  /** @deprecated Use title instead */
  category: Scalars['String'];
  created: Scalars['Long'];
  deleted?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  picks: Array<Pick>;
  picksLength: Scalars['Int'];
  title: Scalars['String'];
  upcomingPicks: Array<Pick>;
  updated?: Maybe<Scalars['Long']>;
};


export type PickCategoryPicksArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type PickCategoryUpcomingPicksArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type PickCategoryResultV2 = PickCategoryErrorV2 | PickCategoryV2;

export type PickCategoryErrorV2 = {
  __typename?: 'PickCategoryErrorV2';
  error?: Maybe<Scalars['String']>;
  type: PickCategoryErrorType;
};

export enum PickCategoryErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type PickResultV2 = PickErrorV2 | PickV2;

export type PickErrorV2 = {
  __typename?: 'PickErrorV2';
  error?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SimulatorTokenResultV2 = SimulatorTokenErrorV2 | SimulatorTokenV2;

export type SimulatorTokenErrorV2 = {
  __typename?: 'SimulatorTokenErrorV2';
  error?: Maybe<Scalars['String']>;
  type: SimulatorTokenErrorType;
};

export enum SimulatorTokenErrorType {
  AlreadyExists = 'AlreadyExists',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type SimulatorTokenV2 = {
  __typename?: 'SimulatorTokenV2';
  boardId: Scalars['String'];
  expiresAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isPublic?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  url: Scalars['String'];
};

export type ReferralReportResponse = {
  __typename?: 'ReferralReportResponse';
  rows: Array<ReferralReportRow>;
};

export type ReferralReportRow = {
  __typename?: 'ReferralReportRow';
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  invalid: Scalars['Boolean'];
  lastName: Scalars['String'];
  notified?: Maybe<Scalars['Long']>;
  personId: Scalars['String'];
  quantity: Scalars['Int'];
  shopifyCustomerName: Scalars['String'];
  transactionDate: Scalars['Long'];
};

export type RoleResultV2 = RoleErrorV2 | RoleV2;

export type RoleErrorV2 = {
  __typename?: 'RoleErrorV2';
  error?: Maybe<Scalars['String']>;
  type: RoleErrorType;
};

export enum RoleErrorType {
  AlreadyExists = 'AlreadyExists',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ScheduledNotificationResultV2 = ScheduledNotificationErrorV2 | ScheduledNotificationV2;

export type ScheduledNotificationErrorV2 = {
  __typename?: 'ScheduledNotificationErrorV2';
  error?: Maybe<Scalars['String']>;
  type: ScheduledNotificationErrorType;
};

export enum ScheduledNotificationErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MessageSearchResult = {
  created: Scalars['Long'];
  message: Message;
};

export type ShopifyOrderCustomerInputV2 = {
  orderId: Scalars['String'];
};

export type ShopifyCustomerResultV2 = ShopifyCustomerErrorV2 | ShopifyCustomerV2;

export type ShopifyCustomerErrorV2 = {
  __typename?: 'ShopifyCustomerErrorV2';
  error?: Maybe<Scalars['String']>;
  type: ShopifyCustomerErrorType;
};

export enum ShopifyCustomerErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ShopifyCustomerV2 = {
  __typename?: 'ShopifyCustomerV2';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

export type DeviceSshKeyPair = {
  __typename?: 'DeviceSSHKeyPair';
  created: Scalars['String'];
  deviceId: Scalars['String'];
  id: Scalars['String'];
  publickey: Scalars['String'];
  sshKeyPair: Scalars['String'];
};

export type SshKeyPair = {
  __typename?: 'SSHKeyPair';
  created: Scalars['String'];
  id: Scalars['String'];
  privatekey: Scalars['String'];
  publickey: Scalars['String'];
};

export type SubmittedMessageSetResultV2 = SubmittedMessageSetErrorV2 | SubmittedMessageSetV2;

export type SubmittedMessageSetErrorV2 = {
  __typename?: 'SubmittedMessageSetErrorV2';
  error?: Maybe<Scalars['String']>;
  type: SubmittedMessageSetErrorType;
};

export enum SubmittedMessageSetErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type SubscriptionResultV2 = SubscriptionErrorV2 | SubscriptionV2;

export type SubscriptionErrorV2 = {
  __typename?: 'SubscriptionErrorV2';
  error?: Maybe<Scalars['String']>;
  type: SubscriptionErrorType;
};

export enum SubscriptionErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type SuggestedSearchTerms = {
  __typename?: 'SuggestedSearchTerms';
  id: Scalars['ID'];
  searchTerms: Array<Scalars['String']>;
};

export type Superadmin = {
  __typename?: 'Superadmin';
  account: Account;
  created: Scalars['Long'];
  id: Scalars['String'];
};

export type SystemMessageTemplateResultV2 = SystemMessageTemplateErrorV2 | SystemMessageTemplateV2;

export type SystemMessageTemplateErrorV2 = {
  __typename?: 'SystemMessageTemplateErrorV2';
  error?: Maybe<Scalars['String']>;
  type: SystemMessageTemplateErrorType;
};

export enum SystemMessageTemplateErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type TemplateCategoryResultV2 = TemplateCategoryErrorV2 | TemplateCategoryV2;

export type TemplateCategoryErrorV2 = {
  __typename?: 'TemplateCategoryErrorV2';
  error?: Maybe<Scalars['String']>;
  type: TemplateCategoryErrorType;
};

export enum TemplateCategoryErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type TemplateMessageSuggestionResultV2 = TemplateMessageSuggestionErrorV2 | TemplateMessageSuggestionV2;

export type TemplateMessageSuggestionErrorV2 = {
  __typename?: 'TemplateMessageSuggestionErrorV2';
  error?: Maybe<Scalars['String']>;
  type: TemplateMessageSuggestionErrorType;
};

export enum TemplateMessageSuggestionErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type TemplateMessageResultV2 = TemplateMessageErrorV2 | TemplateMessageV2;

export type TemplateMessageErrorV2 = {
  __typename?: 'TemplateMessageErrorV2';
  error?: Maybe<Scalars['String']>;
  type: TemplateMessageErrorType;
};

export enum TemplateMessageErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type UsersReportInput = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};

export type UsersReportOutput = {
  __typename?: 'UsersReportOutput';
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  results: Array<GqlUserReportRow>;
  totalCount: Scalars['Int'];
};

export type GqlUserReportRow = {
  __typename?: 'GqlUserReportRow';
  created: Scalars['Long'];
  emailAddress: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  numberOfBoards: Scalars['Int'];
  person: Scalars['String'];
};

export type Viewer = {
  __typename?: 'Viewer';
  account?: Maybe<Account>;
  adminInstallableMonorepoToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  principal: Principal;
  registrationToken?: Maybe<Scalars['String']>;
  superadmin?: Maybe<Superadmin>;
};

export type GqlVisualEditorSession = {
  __typename?: 'GqlVisualEditorSession';
  created: Scalars['Long'];
  id: Scalars['String'];
  prefilledLayout?: Maybe<Scalars['String']>;
};

export type BoardDeviceAssociationModel = {
  __typename?: 'BoardDeviceAssociationModel';
  board?: Maybe<Board>;
  created: Scalars['Long'];
  device?: Maybe<Device>;
  id: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPersonTenantInvitation: AcceptInvitationForPersonAndTenantSuccessResponse;
  addBoardDeviceAssociationByBoard: Scalars['Boolean'];
  addChannelToBlendedV2: BlendedResultV2;
  addMarketplaceListingFeature: MarketplaceListingFeatureItem;
  addMessageSetCreatorMessage: AddMessageSetCreatorMessageResponse;
  addMessageSetToBlended: Blended;
  addMessageToMessageSetCreatorV2: MessageSetCreatorMessageV2;
  addNotificationRegistrationTokenV2: NotificationSubscriberResultV2;
  addNotificationTagV2: NotificationSubscriberResultV2;
  adminDeleteMessageSetVersionSubmission: GqlMessageSetVersionSubmission;
  adminInvalidateMessageSet: MessageSet;
  adminUpdateBoard: Board;
  adminUpdateDevice: Device;
  adminUpdateDeviceCountryCode: Device;
  adminUpdateMessage: Message;
  adminUpdateRenewalDate: ProductApplication;
  applyRedemptionCode: AppliedRedemptionCode;
  approveMessageSetVersionSubmission: ApproveMessageSetVersionSubmissionResponse;
  broadcastMessage: BroadcastMessageResponse;
  broadcastToDisplayGroupV2: DisplayGroupMessageAppearanceResultV2;
  buildCart: PlusCartUrl;
  createApiCredential: CreateApiCredentialSuccess;
  createAutomation: CreateAutomationMutationSuccessResponse;
  createBoard: CreateBoardResponseSuccessful;
  createBoardV2: BoardResultV2;
  createColorTemplate: CreateColorTemplateSuccessful;
  createColorTemplateCategory: CreateColorTemplateCategorySuccessful;
  /** @deprecated Use createTemplateCategory instead */
  createColorTemplateV2: ColorTemplateResultV2;
  createCustomerPortalSessionToken: CreateCustomerPortalSessionTokenResponse;
  createDealAssociationV2: DealAssociationResultV2;
  createDeveloper: Developer;
  createDisplayGroupMessageAppearanceV2: DisplayGroupMessageAppearanceResultV2;
  createDisplayGroupV2: DisplayGroupResultV2;
  createDraftV2: DraftResultV2;
  createFavoriteV2: FavoriteResultV2;
  createFeedItemV2: FeedItemResultV2;
  createFeedTagV2: FeedTagResultV2;
  createFlagshipDeviceV2: FlagshipDeviceResultV2;
  createHomeScreenBannerV2: HomeScreenBannerResultV2;
  createInstallable: CreateInstallableSuccessResponse;
  createInstallableV2: InstallableResultV2;
  createLikeV2: LikeResultV2;
  createMarketplaceCategoryV2: MarketplaceCategoryResultV2;
  createMarketplaceFeatureTypeV2: MarketplaceFeatureTypeResultV2;
  createMarketplaceListing: MarketplaceListing;
  createMarketplaceListingV2: MarketplaceListingResultV2;
  createMasterPairingV2: MasterPairingResultV2;
  createMedia: CreatedMedia;
  createMessage: CreateMessageSuccessful;
  createMessage2: CreateMessage2Successful;
  createMessageAppearanceV2: MessageAppearanceResultV2;
  createMessageSet: MessageSetCreated;
  createMessageSetSuggestionV2: MessageSetSuggestionResultV2;
  createMessageSetV2: MessageSetResultV2;
  createMessageSetVersion: MessageSetVersion;
  createMessageSetVersionV2: MessageSetVersionResultV2;
  createMessageShareToken: CreatedMessageShareToken;
  createMessageV2: MessageResultV2;
  createNotificationSegmentV2: NotificationSegmentResultV2;
  createNotificationTagV2: NotificationTagResultV2;
  createOutgoingWebhookV2: OutgoingWebhookResultV2;
  createPerson: CreatePersonSuccessful;
  createPersonBoardInvitations: AddPersonToExistingTenantSuccessful;
  createPersonTenantInvitation: AddPersonToExistingTenantSuccessful;
  createPersonV2: PersonResultV2;
  createPick: CreatePickSuccessful;
  createPickCategory: CreatePickCategorySuccessful;
  createPickCategoryV2: PickCategoryResultV2;
  createPickV2: PickResultV2;
  createProductApplication: AppliedRedemptionCode;
  createRecommendation: CreateRecommendationMutationSuccessResponse;
  createReferralCodeV2: ReferralCodeResultV2;
  createRoleV2: RoleResultV2;
  createScheduledMessageV2: ScheduledMessageResultV2;
  createScheduledNotificationV2: ScheduledNotificationResultV2;
  createSimulatorTokenV2: SimulatorTokenResultV2;
  createSubscription: CreateSubscriptionSuccessful;
  createSubscriptionSet: CreateSubscriptionSetSuccessful;
  createSubscriptionV2: SubscriptionResultV2;
  createTemplateCategoryV2: TemplateCategoryResultV2;
  createTemplateMessageSuggestionV2: TemplateMessageSuggestionResultV2;
  createTemplateMessageV2: TemplateMessageResultV2;
  createTenant: CreateTenantSuccessful;
  createWebhookDestination: WebhookDestination;
  deleteAcceptedReferralV2: AcceptedReferralResultV2;
  deleteAccount: DeleteAccountResult;
  deleteApiCredential: DeleteApiCredentialSuccessful;
  deleteBoard: DeleteBoardResponseSuccessful;
  deleteBoardV2: BoardResultV2;
  deleteColorTemplate: DeleteColorTemplateSuccessful;
  deleteColorTemplateCategory: DeleteColorTemplateCategorySuccessful;
  /** @deprecated Use deleteTemplateCategory instead */
  deleteColorTemplateV2: ColorTemplateResultV2;
  deleteDealAssociationV2: DealAssociationResultV2;
  deleteDigitalDeviceV2: DigitalDeviceResultV2;
  deleteDisplayGroupV2: DisplayGroupResultV2;
  deleteDraft: DeleteDraftResponse;
  deleteFeedItemV2: FeedItemResultV2;
  deleteFeedTagV2: FeedTagResultV2;
  deleteFlagshipDeviceV2: FlagshipDeviceResultV2;
  deleteHomeScreenBannerImageV2: HomeScreenBannerResultV2;
  deleteHomeScreenBannerV2: HomeScreenBannerResultV2;
  deleteInstallable: DeleteInstallableSuccessful;
  deleteInstallableV2: InstallableResultV2;
  deleteInstallation: DeleteInstallationSuccessful;
  deleteMarketplaceCategoryV2: MarketplaceCategoryResultV2;
  deleteMarketplaceFeatureTypeV2: MarketplaceFeatureTypeResultV2;
  deleteMarketplaceListing?: Maybe<MarketplaceListing>;
  deleteMarketplaceListingCarouselImageV2: MarketplaceListingResultV2;
  deleteMarketplaceListingFeatureImageV2: MarketplaceGalleryResultV2;
  deleteMarketplaceListingLogoV2: MarketplaceListingResultV2;
  deleteMarketplaceListingV2: MarketplaceListingResultV2;
  deleteMasterPairingV2: MasterPairingResultV2;
  deleteMessageAppearanceV2: MessageAppearanceResultV2;
  deleteMessageSet: MessageSetDeleted;
  deleteMessageSetV2: MessageSetResultV2;
  deleteMessageSetVersionV2: MessageSetVersionResultV2;
  deleteNotificationSegmentV2: NotificationSegmentResultV2;
  deleteNotificationTagV2: NotificationTagResultV2;
  deleteNotificationV2: NotificationResultV2;
  deletePersonTenantAssociation: PersonTenantAssociation;
  deletePersonV2: PersonResultV2;
  deletePick: DeletePickSuccessful;
  deletePickCategory: DeletePickCategorySuccessful;
  deletePickCategoryV2: PickCategoryResultV2;
  deletePickV2: PickResultV2;
  deleteRecommendation: DeleteRecommendationSuccessful;
  deleteRoleV2: RoleResultV2;
  deleteScheduledMessageV2: ScheduledMessageResultV2;
  deleteScheduledNotificationV2: ScheduledNotificationResultV2;
  deleteSimulatorTokenV2: SimulatorTokenResultV2;
  deleteSubscription: DeleteSubscriptionSuccessful;
  deleteSubscriptionSet: DeleteSubscriptionSetSuccessful;
  deleteSubscriptionV2: SubscriptionResultV2;
  deleteTemplateCategoryV2: TemplateCategoryResultV2;
  deleteTemplateMessageSuggestionV2: TemplateMessageSuggestionResultV2;
  deleteTemplateMessageV2: TemplateMessageResultV2;
  deleteTenant: DeleteTenantSuccessful;
  deployOSVersion: SetDeployedOsVersionSuccess;
  disableDeployOsVersion: DisableOsVersionDeploySuccess;
  dropMirrorV2: BoardResultV2;
  editDraft: DraftMessage;
  /** Exchange a subscription config token for a JWT that can be used on the API */
  exchangeSubscriptionConfigTokenForJWTV2: SubscriptionConfigTokenResponseV2;
  executeContract: ExecuteContractMutationResponse;
  expirePlusSubscriptionForBoard: Board;
  factoryReset: FactoryResetResult;
  flagFeedItemV2: FlaggedFeedItemResultV2;
  flagMessageV2: FlaggedMessageResultV2;
  forceThreeYearContract: ProductApplication;
  forgetDeviceNetwork: DeviceForgetNetworkRequestCreated;
  generateActivationCodes: Array<ActivationCode>;
  generateBoardReadOnlyTokenV2: Scalars['String'];
  generateUnpairedFlagshipDevicesV2: BulkCreateFlagshipDevices;
  getHomeScreenBannerImageUploadUrlV2: HomeScreenBannerImageResponseResultV2;
  hideHistoryMessage: HideHistoryMessageSuccessful;
  ignorePersonTenantInvitation: IgnoreInvitationForPersonAndTenantSuccessResponse;
  indexBoardDeviceAssociationByBoard: Scalars['Boolean'];
  invalidateActivationCode: ActivationCode;
  invalidateBoardDeviceAssociations: Scalars['Boolean'];
  invalidateDevice: InvalidateDeviceSuccess;
  invalidateFlagshipBoard: Scalars['Boolean'];
  invalidateInstallableCache: InstallableCacheKeyInvalidated;
  invalidatePeopleCache: InvalidatePeopleResponse;
  inviteV2: RoleResultV2;
  leaveBoardV2: BoardResultV2;
  markAllNotificationsAsReadV2: ListNotifications;
  markNotificationAsClickedV2: NotificationResultV2;
  markNotificationAsReadV2: NotificationResultV2;
  markNotificationAsUnReadV2: NotificationResultV2;
  /** @deprecated Use migrateMessageAppearances instead */
  migrateBoardMessagesV1: MigrationResultV2;
  /** @deprecated We are no longer using this method */
  migrateBoardMessagesV2: MigrationResultV2;
  /** @deprecated Migrations are moved to the event bus */
  migrateBoardToV1V2: MigrationResultV2;
  migrateBoardV2: BoardMigrateV2;
  /** @deprecated Moved to event bus */
  migrateColorTemplatesV2: MigrationResultV2;
  migrateDraftsV2: MessageMigrateV2;
  migrateFavoritesV2: MessageMigrateV2;
  migrateFlagshipDeviceV2: BoardMigrateV2;
  migrateInstallablesV2: MarketplaceListingMigrateV2;
  migrateMarketplaceListing: MarketplaceMigrationResultV2;
  migrateMarketplaceListingsV2: MarketplaceListingMigrateV2;
  migrateMessageAppearancesV2: MessageMigrateV2;
  /** @deprecated Moved to the event bus */
  migrateMessageSetsV2: MigrationResultV2;
  /** @deprecated This mutation is deprecated and will be removed in the future. */
  migrateMessageSourcesV2: MigrateMessageSourcesResultV2;
  migratePersonV2: BoardMigrateV2;
  /** @deprecated Moved to event bus */
  migratePicksV2: MigrationResultV2;
  /** @deprecated Migrations are moved to the event bus */
  migrateSubscriptions: MarketplaceMigrationResultV2;
  migrateSubscriptionsV2: MarketplaceListingMigrateV2;
  mirrorBoardV2: BoardResultV2;
  moderateFeedItemV2: FeedItemResultV2;
  optIntoRenewal: ProductApplication;
  optOutOfRenewal: ProductApplication;
  optOutOfUnactivatedRenewal?: Maybe<PlusPurchaseSessionPurchase>;
  pairDeviceWithBoard: PairDeviceWithBoardSuccessful;
  pairFlagshipDeviceV2: FlagshipDeviceResultV2;
  pauseInstallables: PauseInstallablesResponse;
  pinMessageToBoardV2: PinnedMessageResultV2;
  publishInstallable: Installable;
  publishMessageSetVersion: MessageSetVersion;
  publishMessageSetVersionV2: MessageSetVersionResultV2;
  refreshDeviceKeys: DeviceRefreshKeysMutationOutput;
  refreshSubscriptionCadenceV2: SubscriptionResultV2;
  removeChannelFromBlendedV2: BlendedResultV2;
  removeDraftV2: DraftResultV2;
  removeFavoriteV2: FavoriteResultV2;
  removeLikeV2: LikeResultV2;
  removeMarketplaceListingFeature: MarketplaceListingFeatureItem;
  removeMessageSetFromBlended: Blended;
  removeNotificationRegistrationTokenV2: NotificationSubscriberResultV2;
  removeNotificationTagV2: NotificationSubscriberResultV2;
  removeOutgoingWebhookV2: OutgoingWebhookResultV2;
  renewProductApplication: ProductApplication;
  requestDeviceHeartbeat: DeviceHeartbeatStatusMutationOutput;
  requestDeviceLogs: DeviceLogsMutationOutput;
  reservePairingCode: ReservePairingCodesResult;
  revokePersonTenantInvitation: RevokeInvitationForPersonAndTenantSuccessResponse;
  rotateFlagshipDeviceSSHKeyV2: FlagshipDeviceResultV2;
  saveDigitalDeviceV2: DigitalDeviceResultV2;
  saveDraft: SaveDraftResponse;
  saveSystemMessageTemplateV2: SystemMessageTemplateResultV2;
  sendOwnerLocalApiEnablementToken: SendOwnerLocalApiEnablementTokenResponse;
  setColorTemplateSortOrders: ColorTemplateCategory;
  setFlagshipDeviceTransitionV2: FlagshipDeviceResultV2;
  setMessageFavorite: SetMessageFavoriteResponse;
  setPersonAppToken: SetPersonAppTokenResponse;
  setSuggestedSearchTermsV2: SuggestedSearchTerms;
  shareMessageV2: ShareResultV2;
  softDeleteOsVersion: SoftDeleteOsVersionSuccess;
  submitMessageSetV2: SubmittedMessageSetResultV2;
  syncReservedPairingCode: ReservePairingCodesResult;
  tagFeedItemV2: FeedItemResultV2;
  tagMessagesV2: Array<MessageResultV2>;
  tagMessageV2: MessageResultV2;
  transferOwnership: TransferOwnershipSuccessful;
  unCacheBoard: UnCacheBoardInputResult;
  undeleteBoard: Board;
  unFlagFeedItemV2: FlaggedFeedItemResultV2;
  unFlagMessageV2: FlaggedMessageResultV2;
  unInvalidateActivationCode: ActivationCode;
  unleaveBoard: PersonTenantAssociation;
  unModerateFeedItemV2: FeedItemResultV2;
  unpairDeviceWithBoard: UnpairDeviceWithBoardSuccessfulResponse;
  unpairFlagshipDeviceV2: FlagshipDeviceResultV2;
  unpauseInstallables: UnpauseInstallablesResponse;
  unpinMessageFromBoardV2: PinnedMessageResultV2;
  unscheduleMessage: UnscheduleMessageResponse;
  unSubmitMessageSetV2: SubmittedMessageSetResultV2;
  updateAcceptedReferralV2: AcceptedReferralResultV2;
  updateBoard: UpdateBoardResponseSuccessful;
  updateBoardV2: BoardResultV2;
  updateColorTemplate: UpdateColorTemplateSuccessful;
  updateColorTemplateCategory: UpdateColorTemplateCategorySuccessful;
  /** @deprecated Use updateTemplateCategory instead */
  updateColorTemplateV2: ColorTemplateResultV2;
  updateDeveloper: Developer;
  updateDeviceFirmwareVersion: Device;
  updateDeviceYoctoStatus: Device;
  updateDeviceYoctoStatusByTimezone: Array<Device>;
  updateDisplayGroupV2: DisplayGroupResultV2;
  updateDraftV2: DraftResultV2;
  updateEmailAddress: Account;
  updateFeedTagV2: FeedTagResultV2;
  updateFlagshipDeviceHeartbeatV2: FlagshipDeviceResultV2;
  updateFlagshipDeviceV2: FlagshipDeviceResultV2;
  updateHomeScreenBannerV2: HomeScreenBannerResultV2;
  updateInstallable: Installable;
  updateInstallableV2: InstallableResultV2;
  updateMarketplaceCategoryV2: MarketplaceCategoryResultV2;
  updateMarketplaceConfiguration: UpdateMarketplaceConfigurationSuccessResponse;
  updateMarketplaceFeatureTypeV2: MarketplaceFeatureTypeResultV2;
  updateMarketplaceGalleryV2: MarketplaceGalleryResultV2;
  updateMarketplaceListing: MarketplaceListing;
  updateMarketplaceListingFeatureType?: Maybe<MarketplaceListingFeatureType>;
  updateMarketplaceListingV2: MarketplaceListingResultV2;
  updateMasterPairingV2: MasterPairingResultV2;
  updateMessageSet: MessageSet;
  updateMessageSetV2: MessageSetResultV2;
  updateMessageSetVersionV2: MessageSetVersionResultV2;
  updateNotificationSegmentV2: NotificationSegmentResultV2;
  updateNotificationTagV2: NotificationTagResultV2;
  updatePerson: UpdatePersonSuccessful;
  updatePersonTenantAssociationMutation: PersonTenantAssociation;
  updatePersonV2: PersonResultV2;
  updatePick: UpdatePickSuccessful;
  updatePickCategory: UpdatePickCategorySuccessful;
  updatePickCategoryV2: PickCategoryResultV2;
  updatePickV2: PickResultV2;
  updateProductApplication: ProductApplication;
  updateReferral: UpdateReferralSuccess;
  updateRoleV2: RoleResultV2;
  updateScheduledNotificationV2: ScheduledNotificationResultV2;
  updateShopifyPaymentMethod: ShopifyUpdatePaymentMethodResult;
  updateSubscription: UpdateSubscriptionSuccessful;
  updateSubscriptionSet: UpdateSubscriptionSetSuccessful;
  updateSubscriptionV2: SubscriptionResultV2;
  updateTemplateCategoryV2: TemplateCategoryResultV2;
  updateTemplateMessageV2: TemplateMessageResultV2;
  updateTenant: UpdateTenantSuccessful;
  upgradeFirmware: DeviceUpgradeFirmwareMutationOutput;
  uploadMarketplaceFeatureImageV2: MarketplaceGalleryUploadResultV2;
  uploadMarketplaceListingCarouselImageV2: MarketplaceListingUploadResultV2;
  uploadMarketplaceListingLogoV2: MarketplaceListingUploadResultV2;
  uploadMarketplaceListingNoteCarouselImageV2: MarketplaceListingUploadResultV2;
  uploadPersonProfileImageV2: PersonProfileImageUploadResultV2;
  upsertSingletonChannelForListing: UpsertSingletonChannelForListingResponse;
};


export type MutationAcceptPersonTenantInvitationArgs = {
  input: AcceptInvitationForPersonAndTenantInput;
};


export type MutationAddBoardDeviceAssociationByBoardArgs = {
  boardDeviceAssociation: Scalars['String'];
  boardId: Scalars['String'];
};


export type MutationAddChannelToBlendedV2Args = {
  input: AddBlendedChannelInputV2;
};


export type MutationAddMarketplaceListingFeatureArgs = {
  input: AddMarketplaceListingFeatureInput;
};


export type MutationAddMessageSetCreatorMessageArgs = {
  input: AddMessageSetCreatorMessageInput;
};


export type MutationAddMessageSetToBlendedArgs = {
  input: AddMessageSetToBlendedInput;
};


export type MutationAddMessageToMessageSetCreatorV2Args = {
  input: CreateMessageSetCreatorMessageInputV2;
};


export type MutationAddNotificationRegistrationTokenV2Args = {
  input: AddNotificationRegistrationTokenInputV2;
};


export type MutationAddNotificationTagV2Args = {
  input: AddNotificationTagInputV2;
};


export type MutationAdminDeleteMessageSetVersionSubmissionArgs = {
  input: DeleteMessageSetVersionSubmissionInput;
};


export type MutationAdminInvalidateMessageSetArgs = {
  input: AdminInvalidateMessageSetInput;
};


export type MutationAdminUpdateBoardArgs = {
  input: AdminUpdateBoardInput;
};


export type MutationAdminUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


export type MutationAdminUpdateDeviceCountryCodeArgs = {
  input: UpdateDeviceCountryCodeInput;
};


export type MutationAdminUpdateMessageArgs = {
  input: AdminUpdateMessageInput;
};


export type MutationAdminUpdateRenewalDateArgs = {
  input: UpdateRenewalDateInput;
};


export type MutationApplyRedemptionCodeArgs = {
  input: ApplyRedemptionCodeInput;
};


export type MutationApproveMessageSetVersionSubmissionArgs = {
  input: ApproveMessageSetVersionSubmissionInput;
};


export type MutationBroadcastMessageArgs = {
  input: BroadcastMessageInput;
};


export type MutationBroadcastToDisplayGroupV2Args = {
  input: BroadcastToDisplayGroupInputV2;
};


export type MutationBuildCartArgs = {
  input: BuildPlusCartInput;
};


export type MutationCreateApiCredentialArgs = {
  input: CreateApiCredentialInput;
};


export type MutationCreateAutomationArgs = {
  input: CreateAutomationMutationInput;
};


export type MutationCreateBoardArgs = {
  input: CreateBoardInput;
};


export type MutationCreateBoardV2Args = {
  input: CreateBoardInputV2;
};


export type MutationCreateColorTemplateArgs = {
  input: CreateColorTemplateInput;
};


export type MutationCreateColorTemplateCategoryArgs = {
  input: CreateColorTemplateCategoryInput;
};


export type MutationCreateColorTemplateV2Args = {
  input: CreateColorTemplateInputV2;
};


export type MutationCreateCustomerPortalSessionTokenArgs = {
  emailAddress: Scalars['String'];
};


export type MutationCreateDealAssociationV2Args = {
  input: DealAssociationInputV2;
};


export type MutationCreateDeveloperArgs = {
  input: CreateDeveloperInput;
};


export type MutationCreateDisplayGroupMessageAppearanceV2Args = {
  input: CreateDisplayGroupMessageAppearanceInputV2;
};


export type MutationCreateDisplayGroupV2Args = {
  input: CreateDisplayGroupInputV2;
};


export type MutationCreateDraftV2Args = {
  input: CreateDraftInputV2;
};


export type MutationCreateFavoriteV2Args = {
  input: CreateFavoriteInputV2;
};


export type MutationCreateFeedItemV2Args = {
  input: CreateFeedItemInputV2;
};


export type MutationCreateFeedTagV2Args = {
  input: CreateFeedTagInputV2;
};


export type MutationCreateFlagshipDeviceV2Args = {
  input: CreateFlagshipDeviceInputV2;
};


export type MutationCreateHomeScreenBannerV2Args = {
  input: CreateHomeScreenBannerInputV2;
};


export type MutationCreateInstallableArgs = {
  input: CreateInstallableInput;
};


export type MutationCreateInstallableV2Args = {
  input: CreateInstallableInputV2;
};


export type MutationCreateLikeV2Args = {
  input: CreateLikeInputV2;
};


export type MutationCreateMarketplaceCategoryV2Args = {
  input: CreateMarketplaceCategoryInputV2;
};


export type MutationCreateMarketplaceFeatureTypeV2Args = {
  input: CreateMarketplaceFeatureTypeInputV2;
};


export type MutationCreateMarketplaceListingArgs = {
  input: CreateMarketplaceListingInput;
};


export type MutationCreateMarketplaceListingV2Args = {
  input: CreateMarketplaceListingInputV2;
};


export type MutationCreateMasterPairingV2Args = {
  input: MasterPairingInputV2;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateMessage2Args = {
  input: CreateMessage2Input;
};


export type MutationCreateMessageAppearanceV2Args = {
  input: CreateMessageAppearanceInputV2;
};


export type MutationCreateMessageSetArgs = {
  input: CreateMessageSetInput;
};


export type MutationCreateMessageSetSuggestionV2Args = {
  input: MessageSetSuggestionInputV2;
};


export type MutationCreateMessageSetV2Args = {
  input: CreateMessageSetInputV2;
};


export type MutationCreateMessageSetVersionArgs = {
  input: CreateMessageSetVersionInput;
};


export type MutationCreateMessageSetVersionV2Args = {
  input: CreateMessageSetVersionInputV2;
};


export type MutationCreateMessageShareTokenArgs = {
  input: CreateMessageShareTokenInput;
};


export type MutationCreateMessageV2Args = {
  input: CreateMessageInputV2;
};


export type MutationCreateNotificationSegmentV2Args = {
  input: CreateNotificationSegmentInputV2;
};


export type MutationCreateNotificationTagV2Args = {
  input: CreateNotificationTagInputV2;
};


export type MutationCreateOutgoingWebhookV2Args = {
  input: CreateOutgoingWebhookInputV2;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePersonBoardInvitationsArgs = {
  input: AddPersonToExistingBoardsInput;
};


export type MutationCreatePersonTenantInvitationArgs = {
  input: AddPersonToExistingTenantInput;
};


export type MutationCreatePersonV2Args = {
  input: CreatePersonInputV2;
};


export type MutationCreatePickArgs = {
  input: CreatePickInput;
};


export type MutationCreatePickCategoryArgs = {
  input: CreatePickCategoryInput;
};


export type MutationCreatePickCategoryV2Args = {
  input: CreatePickCategoryInputV2;
};


export type MutationCreatePickV2Args = {
  input: CreatePickInputV2;
};


export type MutationCreateProductApplicationArgs = {
  input: CreateProductApplicationInput;
};


export type MutationCreateRecommendationArgs = {
  input: CreateRecommendationInput;
};


export type MutationCreateReferralCodeV2Args = {
  input?: InputMaybe<CreateReferralCodeInputV2>;
};


export type MutationCreateRoleV2Args = {
  input: CreateRoleInputV2;
};


export type MutationCreateScheduledMessageV2Args = {
  input: CreateScheduledMessageInputV2;
};


export type MutationCreateScheduledNotificationV2Args = {
  input: CreateScheduledNotificationInputV2;
};


export type MutationCreateSimulatorTokenV2Args = {
  input: CreateSimulatorTokenInputV2;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionSetArgs = {
  input: CreateSubscriptionSetInput;
};


export type MutationCreateSubscriptionV2Args = {
  input: CreateSubscriptionInputV2;
};


export type MutationCreateTemplateCategoryV2Args = {
  input: CreateTemplateCategoryInputV2;
};


export type MutationCreateTemplateMessageSuggestionV2Args = {
  input: CreateTemplateMessageSuggestionInputV2;
};


export type MutationCreateTemplateMessageV2Args = {
  input: CreateTemplateMessageInputV2;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateWebhookDestinationArgs = {
  input: CreateWebhookDestinationInput;
};


export type MutationDeleteAcceptedReferralV2Args = {
  input: DeleteAcceptedReferralInputV2;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteApiCredentialArgs = {
  input: DeleteApiCredentialInput;
};


export type MutationDeleteBoardArgs = {
  input: DeleteBoardInput;
};


export type MutationDeleteBoardV2Args = {
  input: DeleteBoardInputV2;
};


export type MutationDeleteColorTemplateArgs = {
  input: DeleteColorTemplateInput;
};


export type MutationDeleteColorTemplateCategoryArgs = {
  input: DeleteColorTemplateCategoryInput;
};


export type MutationDeleteColorTemplateV2Args = {
  input: DeleteColorTemplateInputV2;
};


export type MutationDeleteDealAssociationV2Args = {
  input: DealAssociationInputV2;
};


export type MutationDeleteDigitalDeviceV2Args = {
  id: Scalars['String'];
};


export type MutationDeleteDisplayGroupV2Args = {
  input: DeleteDisplayGroupInputV2;
};


export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};


export type MutationDeleteFeedItemV2Args = {
  input: DeleteFeedItemInputV2;
};


export type MutationDeleteFeedTagV2Args = {
  input: DeleteFeedTagInputV2;
};


export type MutationDeleteFlagshipDeviceV2Args = {
  input: DeleteFlagshipDeviceInputV2;
};


export type MutationDeleteHomeScreenBannerImageV2Args = {
  id: Scalars['String'];
};


export type MutationDeleteHomeScreenBannerV2Args = {
  id: Scalars['String'];
};


export type MutationDeleteInstallableArgs = {
  input: DeleteInstallableInput;
};


export type MutationDeleteInstallableV2Args = {
  input: DeleteInstallableInputV2;
};


export type MutationDeleteInstallationArgs = {
  input: DeleteInstallationInput;
};


export type MutationDeleteMarketplaceCategoryV2Args = {
  input: DeleteMarketplaceCategoryInputV2;
};


export type MutationDeleteMarketplaceFeatureTypeV2Args = {
  input: DeleteMarketplaceFeatureTypeInputV2;
};


export type MutationDeleteMarketplaceListingArgs = {
  input: DeleteMarketplaceListingInput;
};


export type MutationDeleteMarketplaceListingCarouselImageV2Args = {
  input: MarketplaceListingCarouselInputV2;
};


export type MutationDeleteMarketplaceListingFeatureImageV2Args = {
  input: MarketplaceFeatureImageInputV2;
};


export type MutationDeleteMarketplaceListingLogoV2Args = {
  input: MarketplaceListingIconInputV2;
};


export type MutationDeleteMarketplaceListingV2Args = {
  input: DeleteMarketplaceListingInputV2;
};


export type MutationDeleteMasterPairingV2Args = {
  input: DeleteMasterPairingInputV2;
};


export type MutationDeleteMessageAppearanceV2Args = {
  input: DeleteMessageAppearanceInputV2;
};


export type MutationDeleteMessageSetArgs = {
  input: DeleteMessageSetInput;
};


export type MutationDeleteMessageSetV2Args = {
  input: DeleteMessageSetInputV2;
};


export type MutationDeleteMessageSetVersionV2Args = {
  input: DeleteMessageSetVersionInputV2;
};


export type MutationDeleteNotificationSegmentV2Args = {
  input: DeleteNotificationSegmentInputV2;
};


export type MutationDeleteNotificationTagV2Args = {
  input: DeleteNotificationTagInputV2;
};


export type MutationDeleteNotificationV2Args = {
  input: DeleteNotificationInputV2;
};


export type MutationDeletePersonTenantAssociationArgs = {
  input: DeletePersonTenantAssociationInput;
};


export type MutationDeletePersonV2Args = {
  input: DeletePersonInputV2;
};


export type MutationDeletePickArgs = {
  input: DeletePickInput;
};


export type MutationDeletePickCategoryArgs = {
  input: DeletePickCategoryInput;
};


export type MutationDeletePickCategoryV2Args = {
  input: DeletePickCategoryInputV2;
};


export type MutationDeletePickV2Args = {
  input: DeletePickInputV2;
};


export type MutationDeleteRecommendationArgs = {
  input: DeleteRecommendationMutationInput;
};


export type MutationDeleteRoleV2Args = {
  input: DeleteRoleInputV2;
};


export type MutationDeleteScheduledMessageV2Args = {
  input: DeleteScheduledMessageInputV2;
};


export type MutationDeleteScheduledNotificationV2Args = {
  input: DeleteScheduledNotificationInputV2;
};


export type MutationDeleteSimulatorTokenV2Args = {
  token: Scalars['String'];
};


export type MutationDeleteSubscriptionArgs = {
  input: DeleteSubscriptionInput;
};


export type MutationDeleteSubscriptionSetArgs = {
  input: DeleteSubscriptionSetInput;
};


export type MutationDeleteSubscriptionV2Args = {
  input: DeleteSubscriptionInputV2;
};


export type MutationDeleteTemplateCategoryV2Args = {
  input: DeleteTemplateCategoryInputV2;
};


export type MutationDeleteTemplateMessageSuggestionV2Args = {
  id: Scalars['String'];
};


export type MutationDeleteTemplateMessageV2Args = {
  input: DeleteTemplateMessageInputV2;
};


export type MutationDeleteTenantArgs = {
  input: DeleteTenantInput;
};


export type MutationDeployOsVersionArgs = {
  input: SetProductionOsVersionInput;
};


export type MutationDropMirrorV2Args = {
  input: DropMirrorInputV2;
};


export type MutationEditDraftArgs = {
  input: EditDraftInput;
};


export type MutationExchangeSubscriptionConfigTokenForJwtv2Args = {
  subscriptionConfigToken: Scalars['String'];
};


export type MutationExecuteContractArgs = {
  input: ExecuteContractInput;
};


export type MutationExpirePlusSubscriptionForBoardArgs = {
  input: ExpirePlusSubscriptionForBoardInput;
};


export type MutationFactoryResetArgs = {
  input: FactoryResetMutationInput;
};


export type MutationFlagFeedItemV2Args = {
  input: FlaggedFeedItemInputV2;
};


export type MutationFlagMessageV2Args = {
  input: FlaggedMessageInputV2;
};


export type MutationForceThreeYearContractArgs = {
  input: ForceThreeYearContractInput;
};


export type MutationForgetDeviceNetworkArgs = {
  input: ForgetDeviceNetworkMutationInput;
};


export type MutationGenerateActivationCodesArgs = {
  input: GenerateActivationCodesInput;
};


export type MutationGenerateBoardReadOnlyTokenV2Args = {
  boardId: Scalars['String'];
  platform?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateUnpairedFlagshipDevicesV2Args = {
  input: GenerateFlagshipDeviceInputV2;
};


export type MutationGetHomeScreenBannerImageUploadUrlV2Args = {
  id: Scalars['String'];
};


export type MutationHideHistoryMessageArgs = {
  input: HideHistoryMessageMutationInput;
};


export type MutationIgnorePersonTenantInvitationArgs = {
  input: IgnoreInvitationForPersonAndTenantInput;
};


export type MutationIndexBoardDeviceAssociationByBoardArgs = {
  boardId: Scalars['String'];
};


export type MutationInvalidateActivationCodeArgs = {
  input: InvalidateActivationCodeInput;
};


export type MutationInvalidateBoardDeviceAssociationsArgs = {
  input: InvalidateBoardDeviceAssociationsInput;
};


export type MutationInvalidateDeviceArgs = {
  id: Scalars['String'];
};


export type MutationInvalidateFlagshipBoardArgs = {
  board: Scalars['String'];
};


export type MutationInvalidateInstallableCacheArgs = {
  id: Scalars['String'];
};


export type MutationInvalidatePeopleCacheArgs = {
  input: InvalidatePeopleInput;
};


export type MutationInviteV2Args = {
  input: InviteInputV2;
};


export type MutationLeaveBoardV2Args = {
  input: LeaveBoardInputV2;
};


export type MutationMarkNotificationAsClickedV2Args = {
  input: NotificationClickedInputV2;
};


export type MutationMarkNotificationAsReadV2Args = {
  input: MarkNotificationAsReadInputV2;
};


export type MutationMarkNotificationAsUnReadV2Args = {
  input: MarkNotificationAsUnReadInputV2;
};


export type MutationMigrateBoardMessagesV1Args = {
  boardId: Scalars['String'];
};


export type MutationMigrateBoardMessagesV2Args = {
  boardId: Scalars['String'];
};


export type MutationMigrateBoardToV1V2Args = {
  boardId: Scalars['String'];
};


export type MutationMigrateBoardV2Args = {
  boardId: Scalars['String'];
};


export type MutationMigrateDraftsV2Args = {
  personId?: InputMaybe<Scalars['String']>;
};


export type MutationMigrateFavoritesV2Args = {
  personId?: InputMaybe<Scalars['String']>;
};


export type MutationMigrateFlagshipDeviceV2Args = {
  deviceId: Scalars['String'];
};


export type MutationMigrateInstallablesV2Args = {
  boardId: Scalars['String'];
};


export type MutationMigrateMarketplaceListingArgs = {
  id: Scalars['String'];
};


export type MutationMigrateMessageAppearancesV2Args = {
  boardId?: InputMaybe<Scalars['String']>;
};


export type MutationMigrateMessageSetsV2Args = {
  messageSetId?: InputMaybe<Scalars['String']>;
};


export type MutationMigrateMessageSourcesV2Args = {
  input: MigrateMessageSourcesInputV2;
};


export type MutationMigratePersonV2Args = {
  personId: Scalars['String'];
};


export type MutationMigratePicksV2Args = {
  pickCategoryId?: InputMaybe<Scalars['String']>;
  pickId?: InputMaybe<Scalars['String']>;
};


export type MutationMigrateSubscriptionsArgs = {
  id: Scalars['String'];
};


export type MutationMigrateSubscriptionsV2Args = {
  boardId: Scalars['String'];
};


export type MutationMirrorBoardV2Args = {
  input: MirrorBoardInputV2;
};


export type MutationModerateFeedItemV2Args = {
  input: ModerateFeedItemInputV2;
};


export type MutationOptIntoRenewalArgs = {
  input: OptIntoRenewalInput;
};


export type MutationOptOutOfRenewalArgs = {
  input: OptOutOfRenewalInput;
};


export type MutationOptOutOfUnactivatedRenewalArgs = {
  input: OptOutOfUnactivatedRenewalInput;
};


export type MutationPairDeviceWithBoardArgs = {
  input: PairDeviceWithBoardMutationInput;
};


export type MutationPairFlagshipDeviceV2Args = {
  input: PairFlagshipDeviceInputV2;
};


export type MutationPauseInstallablesArgs = {
  input: PauseInstallablesInput;
};


export type MutationPinMessageToBoardV2Args = {
  input: CreatePinnedMessageInputV2;
};


export type MutationPublishInstallableArgs = {
  input: PublishInstallableInput;
};


export type MutationPublishMessageSetVersionArgs = {
  input: PublishMessageSetVersionInput;
};


export type MutationPublishMessageSetVersionV2Args = {
  input: PublishMessageSetVersionInputV2;
};


export type MutationRefreshDeviceKeysArgs = {
  input: DeviceRefreshKeysMutationInput;
};


export type MutationRefreshSubscriptionCadenceV2Args = {
  id: Scalars['String'];
};


export type MutationRemoveChannelFromBlendedV2Args = {
  input: AddBlendedChannelInputV2;
};


export type MutationRemoveDraftV2Args = {
  input: RemoveDraftInputV2;
};


export type MutationRemoveFavoriteV2Args = {
  input: RemoveFavoriteInputV2;
};


export type MutationRemoveLikeV2Args = {
  input: RemoveLikeInputV2;
};


export type MutationRemoveMarketplaceListingFeatureArgs = {
  input: RemoveMarketplaceListingFeatureInput;
};


export type MutationRemoveMessageSetFromBlendedArgs = {
  input: RemoveMessageSetFromBlendedInput;
};


export type MutationRemoveNotificationRegistrationTokenV2Args = {
  input: RemoveNotificationRegistrationTokenInputV2;
};


export type MutationRemoveNotificationTagV2Args = {
  input: RemoveNotificationTagInputV2;
};


export type MutationRemoveOutgoingWebhookV2Args = {
  input: RemoveOutgoingWebhookInputV2;
};


export type MutationRenewProductApplicationArgs = {
  input: RenewProductApplicationInput;
};


export type MutationRequestDeviceHeartbeatArgs = {
  input: DeviceHeartbeatStatusMutationInput;
};


export type MutationRequestDeviceLogsArgs = {
  input: DeviceLogsMutationInput;
};


export type MutationReservePairingCodeArgs = {
  input?: InputMaybe<ReserverPairingCodeInput>;
};


export type MutationRevokePersonTenantInvitationArgs = {
  input: RevokeInvitationForPersonAndTenantInput;
};


export type MutationRotateFlagshipDeviceSshKeyV2Args = {
  boardId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSaveDigitalDeviceV2Args = {
  input: SaveDigitalDeviceInputV2;
};


export type MutationSaveDraftArgs = {
  input: SaveDraftInput;
};


export type MutationSaveSystemMessageTemplateV2Args = {
  input: SaveSystemMessageTemplateInputV2;
};


export type MutationSendOwnerLocalApiEnablementTokenArgs = {
  input: SendOwnerLocalApiEnablementTokenInput;
};


export type MutationSetColorTemplateSortOrdersArgs = {
  input: SetColorTemplateSortOrdersInput;
};


export type MutationSetFlagshipDeviceTransitionV2Args = {
  input: FlagshipDeviceTransitionInputV2;
};


export type MutationSetMessageFavoriteArgs = {
  input: SetMessageFavoriteInput;
};


export type MutationSetPersonAppTokenArgs = {
  input: SetPersonAppTokenInput;
};


export type MutationSetSuggestedSearchTermsV2Args = {
  input: SuggestedSearchTermsInput;
};


export type MutationShareMessageV2Args = {
  input: ShareInputV2;
};


export type MutationSoftDeleteOsVersionArgs = {
  input: SoftDeleteOsVersionInput;
};


export type MutationSubmitMessageSetV2Args = {
  input: SubmitMessageSetInputV2;
};


export type MutationSyncReservedPairingCodeArgs = {
  input: SyncReservedPairingCodeInput;
};


export type MutationTagFeedItemV2Args = {
  input: TagFeedItemInputV2;
};


export type MutationTagMessagesV2Args = {
  messageIds: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};


export type MutationTagMessageV2Args = {
  id: Scalars['String'];
  tags: Array<Scalars['String']>;
};


export type MutationTransferOwnershipArgs = {
  input: TransferOwnershipMutationInput;
};


export type MutationUnCacheBoardArgs = {
  input: UnCacheBoardInput;
};


export type MutationUndeleteBoardArgs = {
  input: UndeleteBoardInput;
};


export type MutationUnFlagFeedItemV2Args = {
  feedItemId: Scalars['String'];
};


export type MutationUnFlagMessageV2Args = {
  messageId: Scalars['String'];
};


export type MutationUnInvalidateActivationCodeArgs = {
  input: UnInvalidateActivationCodeInput;
};


export type MutationUnleaveBoardArgs = {
  input: UnleaveBoardInput;
};


export type MutationUnModerateFeedItemV2Args = {
  input: UnModerateFeedItemInputV2;
};


export type MutationUnpairDeviceWithBoardArgs = {
  input: UnpairDeviceWithBoardInput;
};


export type MutationUnpairFlagshipDeviceV2Args = {
  input: DeleteFlagshipDeviceInputV2;
};


export type MutationUnpauseInstallablesArgs = {
  input: UnpauseInstallablesInput;
};


export type MutationUnpinMessageFromBoardV2Args = {
  input: RemovePinnedMessageInputV2;
};


export type MutationUnscheduleMessageArgs = {
  input: UnscheduleMessageInput;
};


export type MutationUnSubmitMessageSetV2Args = {
  input: UnSubmitMessageSetInputV2;
};


export type MutationUpdateAcceptedReferralV2Args = {
  input: UpdateAcceptedReferralInputV2;
};


export type MutationUpdateBoardArgs = {
  input: UpdateBoardInput;
};


export type MutationUpdateBoardV2Args = {
  input: UpdateBoardInputV2;
};


export type MutationUpdateColorTemplateArgs = {
  input: UpdateColorTemplateInput;
};


export type MutationUpdateColorTemplateCategoryArgs = {
  input: UpdateColorTemplateCategoryInput;
};


export type MutationUpdateColorTemplateV2Args = {
  input: UpdateColorTemplateInputV2;
};


export type MutationUpdateDeveloperArgs = {
  input: UpdateDeveloperInput;
};


export type MutationUpdateDeviceFirmwareVersionArgs = {
  input: UpdateDeviceFirmwareVersionInput;
};


export type MutationUpdateDeviceYoctoStatusArgs = {
  input: UpdateDeviceYoctoStatusMutationInput;
};


export type MutationUpdateDeviceYoctoStatusByTimezoneArgs = {
  input: UpdateDeviceYoctoStatusByTimezoneMutationInput;
};


export type MutationUpdateDisplayGroupV2Args = {
  input: UpdateDisplayGroupInputV2;
};


export type MutationUpdateDraftV2Args = {
  input: UpdateDraftInputV2;
};


export type MutationUpdateEmailAddressArgs = {
  input: UpdateEmailAddressInput;
};


export type MutationUpdateFeedTagV2Args = {
  input: UpdateFeedTagInputV2;
};


export type MutationUpdateFlagshipDeviceHeartbeatV2Args = {
  input: FlagshipDeviceHeartbeatInputV2;
};


export type MutationUpdateFlagshipDeviceV2Args = {
  input: UpdateFlagshipDeviceInputV2;
};


export type MutationUpdateHomeScreenBannerV2Args = {
  input: UpdateHomeScreenBannerInputV2;
};


export type MutationUpdateInstallableArgs = {
  input: UpdateInstallableInput;
};


export type MutationUpdateInstallableV2Args = {
  input: UpdateInstallableInputV2;
};


export type MutationUpdateMarketplaceCategoryV2Args = {
  input: UpdateMarketplaceCategoryInputV2;
};


export type MutationUpdateMarketplaceConfigurationArgs = {
  input: UpdateMarketplaceConfigurationInput;
};


export type MutationUpdateMarketplaceFeatureTypeV2Args = {
  input: UpdateMarketplaceFeatureTypeInputV2;
};


export type MutationUpdateMarketplaceGalleryV2Args = {
  input: SaveMarketplaceGalleryInputV2;
};


export type MutationUpdateMarketplaceListingArgs = {
  input: UpdateMarketplaceListingInput;
};


export type MutationUpdateMarketplaceListingFeatureTypeArgs = {
  input: UpdateMarketplaceListingFeatureInput;
};


export type MutationUpdateMarketplaceListingV2Args = {
  input: UpdateMarketplaceListingInputV2;
};


export type MutationUpdateMasterPairingV2Args = {
  input: MasterPairingInputV2;
};


export type MutationUpdateMessageSetArgs = {
  input: UpdateMessageSetInput;
};


export type MutationUpdateMessageSetV2Args = {
  input: UpdateMessageSetInputV2;
};


export type MutationUpdateMessageSetVersionV2Args = {
  input: UpdateMessageSetVersionInputV2;
};


export type MutationUpdateNotificationSegmentV2Args = {
  input: UpdateNotificationSegmentInputV2;
};


export type MutationUpdateNotificationTagV2Args = {
  input: UpdateNotificationTagInputV2;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePersonTenantAssociationMutationArgs = {
  input: UpdatePersonTenantAssociationInput;
};


export type MutationUpdatePersonV2Args = {
  input: UpdatePersonInputV2;
};


export type MutationUpdatePickArgs = {
  input: UpdatePickInput;
};


export type MutationUpdatePickCategoryArgs = {
  input: UpdatePickCategoryInput;
};


export type MutationUpdatePickCategoryV2Args = {
  input: UpdatePickCategoryInputV2;
};


export type MutationUpdatePickV2Args = {
  input: UpdatePickInputV2;
};


export type MutationUpdateProductApplicationArgs = {
  input: UpdateProductApplicationInput;
};


export type MutationUpdateReferralArgs = {
  input: UpdateReferralInput;
};


export type MutationUpdateRoleV2Args = {
  input: UpdateRoleInputV2;
};


export type MutationUpdateScheduledNotificationV2Args = {
  input: UpdateScheduledNotificationInputV2;
};


export type MutationUpdateShopifyPaymentMethodArgs = {
  input: UpdateShopifyPaymentMethodMutationInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateSubscriptionSetArgs = {
  input: UpdateSubscriptionSetInput;
};


export type MutationUpdateSubscriptionV2Args = {
  input: UpdateSubscriptionInputV2;
};


export type MutationUpdateTemplateCategoryV2Args = {
  input: UpdateTemplateCategoryInputV2;
};


export type MutationUpdateTemplateMessageV2Args = {
  input: UpdateTemplateMessageInputV2;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


export type MutationUpgradeFirmwareArgs = {
  input: DeviceUpgradeFirmwareMutationInput;
};


export type MutationUploadMarketplaceFeatureImageV2Args = {
  input: MarketplaceFeatureImageInputV2;
};


export type MutationUploadMarketplaceListingCarouselImageV2Args = {
  input: MarketplaceListingCarouselInputV2;
};


export type MutationUploadMarketplaceListingLogoV2Args = {
  input: MarketplaceListingIconInputV2;
};


export type MutationUploadMarketplaceListingNoteCarouselImageV2Args = {
  input: MarketplaceListingCarouselInputV2;
};


export type MutationUpsertSingletonChannelForListingArgs = {
  input: UpsertSingletonChannelForListingInput;
};

export type AcceptInvitationForPersonAndTenantInput = {
  personTenantAssociationId: Scalars['String'];
};

export type AcceptInvitationForPersonAndTenantSuccessResponse = {
  __typename?: 'AcceptInvitationForPersonAndTenantSuccessResponse';
  accepted: Scalars['Boolean'];
  personTenantAssociation: PersonTenantAssociation;
};

export type AddBlendedChannelInputV2 = {
  boardId: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type AddMarketplaceListingFeatureInput = {
  marketplaceListingFeatureType: Scalars['String'];
  marketplaceListingId: Scalars['String'];
};

export type AddMessageSetCreatorMessageInput = {
  messageId: Scalars['String'];
  subscriptionIds: Array<Scalars['String']>;
};

export type AddMessageSetCreatorMessageResponse = {
  __typename?: 'AddMessageSetCreatorMessageResponse';
  success: Scalars['Boolean'];
};

export type AddMessageSetToBlendedInput = {
  boardId: Scalars['String'];
  messageSetId: Scalars['String'];
};

export type CreateMessageSetCreatorMessageInputV2 = {
  /** The message ID */
  id: Scalars['ID'];
  subscriptionIds: Array<Scalars['String']>;
};

export type MessageSetCreatorMessageV2 = {
  __typename?: 'MessageSetCreatorMessageV2';
  id: Scalars['ID'];
  subscriptionIds: Array<Scalars['String']>;
};

export type AddNotificationRegistrationTokenInputV2 = {
  personId?: InputMaybe<Scalars['String']>;
  registrationToken: Scalars['String'];
};

export type AddNotificationTagInputV2 = {
  personId?: InputMaybe<Scalars['String']>;
  tagId: Scalars['String'];
};

export type DeleteMessageSetVersionSubmissionInput = {
  messageSetVersionSubmissionId: Scalars['String'];
};

export type AdminInvalidateMessageSetInput = {
  messageSet: Scalars['String'];
};

export type AdminUpdateBoardInput = {
  boardId: Scalars['String'];
  hubspotDealId?: InputMaybe<Scalars['String']>;
  internalBoard?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDeviceInput = {
  characterSet?: InputMaybe<Scalars['String']>;
  deviceModel?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateDeviceCountryCodeInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type AdminUpdateMessageInput = {
  characters: Array<Array<Scalars['Int']>>;
  id: Scalars['String'];
};

export type UpdateRenewalDateInput = {
  expiresOnOrAfter: Scalars['String'];
  productApplicationId: Scalars['String'];
};

export type ApplyRedemptionCodeInput = {
  board: Scalars['String'];
  code: Scalars['String'];
};

export type AppliedRedemptionCode = {
  __typename?: 'AppliedRedemptionCode';
  productApplication: ProductApplication;
};

export type ApproveMessageSetVersionSubmissionInput = {
  moderationResult: Scalars['String'];
  submissionId: Scalars['String'];
};

export type ApproveMessageSetVersionSubmissionResponse = {
  __typename?: 'ApproveMessageSetVersionSubmissionResponse';
  success: Scalars['Boolean'];
};

export type BroadcastMessageInput = {
  boardIds: Scalars['String'];
  characters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type BroadcastMessageResponse = {
  __typename?: 'BroadcastMessageResponse';
  messages: Array<CreateMessage2Successful>;
};

export type CreateMessage2Successful = {
  __typename?: 'CreateMessage2Successful';
  created: Scalars['Boolean'];
  existingPinnedMessage?: Maybe<GqlPinnedMessage>;
  message?: Maybe<Message>;
  withinQuietHours: Scalars['Boolean'];
};

export type BroadcastToDisplayGroupInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  characters: Array<Array<Scalars['Float']>>;
  displayGroupId: Scalars['String'];
};

export type DisplayGroupMessageAppearanceResultV2 = DisplayGroupMessageAppearanceErrorV2 | DisplayGroupMessageAppearanceSuccessV2;

export type DisplayGroupMessageAppearanceErrorV2 = {
  __typename?: 'DisplayGroupMessageAppearanceErrorV2';
  error?: Maybe<Scalars['String']>;
  type: DisplayGroupMessageAppearanceErrorType;
};

export enum DisplayGroupMessageAppearanceErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type DisplayGroupMessageAppearanceSuccessV2 = {
  __typename?: 'DisplayGroupMessageAppearanceSuccessV2';
  id: Scalars['String'];
  messageAppearances?: Maybe<Array<MessageAppearanceV2>>;
  success: Scalars['Boolean'];
};

export type BuildPlusCartInput = {
  productPricingId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type PlusCartUrl = {
  __typename?: 'PlusCartUrl';
  url: Scalars['String'];
};

export type CreateApiCredentialInput = {
  boardId: Scalars['String'];
  installableId: Scalars['String'];
};

export type CreateApiCredentialSuccess = {
  __typename?: 'CreateApiCredentialSuccess';
  apiCredential: ApiCredential;
  created: Scalars['Boolean'];
  secret: Scalars['String'];
};

export type CreateAutomationMutationInput = {
  singleMessageAutomation?: InputMaybe<CreateSingleMessageAutomationInput>;
};

export type CreateSingleMessageAutomationInput = {
  installable: Scalars['String'];
  message: AssociateMessageMutationInput;
};

export type AssociateMessageMutationInput = {
  create?: InputMaybe<CreateMessageInput>;
};

export type CreateMessageInput = {
  boardId?: InputMaybe<Scalars['String']>;
  characters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  forced?: InputMaybe<Scalars['Boolean']>;
  forcePinnedMessageOverride?: InputMaybe<Scalars['Boolean']>;
  messageId?: InputMaybe<Scalars['String']>;
  pinFor?: InputMaybe<Scalars['Long']>;
  revertToPreviousMessageAfterPin?: InputMaybe<Scalars['Boolean']>;
  sendAt?: InputMaybe<Scalars['Long']>;
  text?: InputMaybe<Scalars['String']>;
  visualEditorSessionId?: InputMaybe<Scalars['String']>;
};

export type CreateAutomationMutationSuccessResponse = {
  __typename?: 'CreateAutomationMutationSuccessResponse';
  created: Automation;
};

export type CreateBoardInput = {
  boardStyle?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDigital?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateBoardResponseSuccessful = {
  __typename?: 'CreateBoardResponseSuccessful';
  board: Board;
  created: Scalars['Boolean'];
};

export type CreateBoardInputV2 = {
  /** Board style. Black/White */
  boardStyle?: InputMaybe<Scalars['String']>;
  /** Person that own's the board */
  creator?: InputMaybe<Scalars['String']>;
  /** The board's hubspot id. */
  hubspotDealId?: InputMaybe<Scalars['String']>;
  /** Is internal. */
  internalBoard?: InputMaybe<Scalars['Boolean']>;
  isDigital?: InputMaybe<Scalars['Boolean']>;
  isTwentyFourHourTime?: InputMaybe<Scalars['Boolean']>;
  /** Quiet hours */
  quietHours?: InputMaybe<QuietHoursInputV2>;
  /** Timezone. */
  timezone?: InputMaybe<Scalars['String']>;
  /** The title of the board. */
  title?: InputMaybe<Scalars['String']>;
};

export type QuietHoursInputV2 = {
  /** The end of quiet hours ex 1400. */
  end?: InputMaybe<Scalars['String']>;
  /** The end of Friday quiet hours ex 1400. */
  fridayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Friday quiet hours ex 1300. */
  fridayStart?: InputMaybe<Scalars['String']>;
  /** The end of Monday quiet hours ex 1400. */
  mondayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Monday quiet hours ex 1300. */
  mondayStart?: InputMaybe<Scalars['String']>;
  /** The end of Saturday quiet hours ex 1400. */
  saturdayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Saturday quiet hours ex 1300. */
  saturdayStart?: InputMaybe<Scalars['String']>;
  /** The start of quiet hours ex 1300. */
  start?: InputMaybe<Scalars['String']>;
  /** The end of Sunday quiet hours ex 1400. */
  sundayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Sunday quiet hours ex 1300. */
  sundayStart?: InputMaybe<Scalars['String']>;
  /** The end of Thursday quiet hours ex 1400. */
  thursdayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Thursday quiet hours ex 1300. */
  thursdayStart?: InputMaybe<Scalars['String']>;
  /** The end of Tuesday quiet hours ex 1400. */
  tuesdayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Tuesday quiet hours ex 1300. */
  tuesdayStart?: InputMaybe<Scalars['String']>;
  /** The end of Wednesday quiet hours ex 1400. */
  wednesdayEnd?: InputMaybe<Scalars['String']>;
  /** The start of Wednesday quiet hours ex 1300. */
  wednesdayStart?: InputMaybe<Scalars['String']>;
  /** The end of weekend quiet hours ex 1400. */
  weekendEnd?: InputMaybe<Scalars['String']>;
  /** The start of weekend quiet hours ex 1300. */
  weekendStart?: InputMaybe<Scalars['String']>;
};

export type CreateColorTemplateInput = {
  categoryId: Scalars['String'];
  characters: Array<Array<Scalars['Int']>>;
};

export type CreateColorTemplateSuccessful = {
  __typename?: 'CreateColorTemplateSuccessful';
  created: ColorTemplate;
};

export type CreateColorTemplateCategoryInput = {
  title: Scalars['String'];
};

export type CreateColorTemplateCategorySuccessful = {
  __typename?: 'CreateColorTemplateCategorySuccessful';
  created: ColorTemplateCategory;
};

export type CreateColorTemplateInputV2 = {
  messageIds: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateCustomerPortalSessionTokenResponse = {
  __typename?: 'CreateCustomerPortalSessionTokenResponse';
  url: Scalars['String'];
};

export type DealAssociationInputV2 = {
  dealId: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type DealAssociationResultV2 = DealAssociationErrorV2 | DealAssociationV2;

export type DealAssociationErrorV2 = {
  __typename?: 'DealAssociationErrorV2';
  error?: Maybe<Scalars['String']>;
  type: DealAssociationErrorType;
};

export enum DealAssociationErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type CreateDeveloperInput = {
  title: Scalars['String'];
};

export type CreateDisplayGroupMessageAppearanceInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  characters: Array<Array<Scalars['Float']>>;
  displayGroupId: Scalars['String'];
};

export type CreateDisplayGroupInputV2 = {
  boardIds: Array<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateDraftInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  messageId: Scalars['String'];
  personId?: InputMaybe<Scalars['String']>;
};

export type DraftResultV2 = DraftErrorV2 | DraftV2;

export type DraftErrorV2 = {
  __typename?: 'DraftErrorV2';
  error?: Maybe<Scalars['String']>;
  type: DraftErrorType;
};

export enum DraftErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type CreateFavoriteInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  messageId: Scalars['String'];
  personId?: InputMaybe<Scalars['String']>;
  sourceMarketplaceListingId?: InputMaybe<Scalars['String']>;
  sourcePersonId?: InputMaybe<Scalars['String']>;
  sourceSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type FavoriteResultV2 = FavoriteErrorV2 | FavoriteV2;

export type FavoriteErrorV2 = {
  __typename?: 'FavoriteErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FavoriteErrorType;
};

export enum FavoriteErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type CreateFeedItemInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  messageId: Scalars['String'];
  moderated?: InputMaybe<Scalars['Boolean']>;
  personId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFeedTagInputV2 = {
  title: Scalars['String'];
};

export type CreateFlagshipDeviceInputV2 = {
  deviceModel: FlagshipDeviceModel;
};

export type CreateHomeScreenBannerInputV2 = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttons?: InputMaybe<Array<HomeScreenBannerButtonInputV2>>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  positionInFeed: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type HomeScreenBannerButtonInputV2 = {
  deepLinkUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateInstallableInput = {
  developerId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateInstallableSuccessResponse = {
  __typename?: 'CreateInstallableSuccessResponse';
  created: Scalars['Boolean'];
  installable: Installable;
};

export type CreateInstallableInputV2 = {
  cadenceConfigurationUrl?: InputMaybe<Scalars['String']>;
  cadenceDisplayTemplate?: InputMaybe<Scalars['String']>;
  cadenceOnCommand?: InputMaybe<Scalars['Boolean']>;
  cadenceToken?: InputMaybe<Scalars['String']>;
  canBeRenamed?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  isV2Installable?: InputMaybe<Scalars['Boolean']>;
  subscriptionConfigurationUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateLikeInputV2 = {
  feedItemId?: InputMaybe<Scalars['String']>;
  pickId?: InputMaybe<Scalars['String']>;
  templateMessageId?: InputMaybe<Scalars['String']>;
};

export type LikeResultV2 = LikeErrorV2 | LikeV2;

export type LikeErrorV2 = {
  __typename?: 'LikeErrorV2';
  error?: Maybe<Scalars['String']>;
  type: LikeErrorType;
};

export enum LikeErrorType {
  AlreadyLiked = 'AlreadyLiked',
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound',
  ValidationError = 'ValidationError'
}

export type CreateMarketplaceCategoryInputV2 = {
  marketplaceListingIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateMarketplaceFeatureTypeInputV2 = {
  marketplaceListingIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateMarketplaceListingInput = {
  category?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  installable: Scalars['String'];
  messageSet?: InputMaybe<Scalars['String']>;
  questionAndAnswerId?: InputMaybe<Scalars['String']>;
  releaseDate: Scalars['Long'];
  stagingOnly: Scalars['Boolean'];
  tags?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateMarketplaceListingInputV2 = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  configuration?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  enabledInstallationsCount?: InputMaybe<Scalars['Float']>;
  featureTypeIds?: InputMaybe<Array<Scalars['String']>>;
  installableId: Scalars['String'];
  installationsCount?: InputMaybe<Scalars['Float']>;
  installationsInPast30DaysCount?: InputMaybe<Scalars['Float']>;
  installationsInPast7DaysCount?: InputMaybe<Scalars['Float']>;
  installDeepLink?: InputMaybe<Scalars['String']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  isSingleton?: InputMaybe<Scalars['Boolean']>;
  messageSetId?: InputMaybe<Scalars['String']>;
  notePreviewMessage?: InputMaybe<Scalars['String']>;
  previewMessage?: InputMaybe<Scalars['String']>;
  questionAndAnswerId?: InputMaybe<Scalars['String']>;
  releaseAt?: InputMaybe<Scalars['Float']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  stagingOnly?: InputMaybe<Scalars['Boolean']>;
  supportsFlagship?: InputMaybe<Scalars['Boolean']>;
  supportsNote?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  versionNumber?: InputMaybe<Scalars['String']>;
};

export type MasterPairingInputV2 = {
  accountEmailAddress?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['String']>;
  boardCreated?: InputMaybe<Scalars['Float']>;
  boardId: Scalars['String'];
  boardTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  dealId?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  hubspotMessage?: InputMaybe<Scalars['String']>;
  hubspotUpdated?: InputMaybe<Scalars['Boolean']>;
  manualReviewFlag?: InputMaybe<Scalars['Boolean']>;
  manualReviewMessage?: InputMaybe<Scalars['String']>;
  memberEmailAddresses?: InputMaybe<Array<Scalars['String']>>;
  memberIds?: InputMaybe<Array<Scalars['String']>>;
  pairingDate?: InputMaybe<Scalars['Float']>;
  personFirstName?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  personLastName?: InputMaybe<Scalars['String']>;
  plusApplicationDate?: InputMaybe<Scalars['Float']>;
  plusRenewalDate?: InputMaybe<Scalars['Float']>;
  plusRenewalFrequency?: InputMaybe<Scalars['String']>;
  synced?: InputMaybe<Scalars['Boolean']>;
};

export type CreatedMedia = {
  __typename?: 'CreatedMedia';
  media: Media;
  uploadUrl: Scalars['String'];
};

export type CreateMessageSuccessful = {
  __typename?: 'CreateMessageSuccessful';
  created: Scalars['Boolean'];
  currentPinnedMessage?: Maybe<GqlPinnedMessage>;
  message: Message;
  withinQuietHours: Scalars['Boolean'];
};

export type CreateMessage2Input = {
  boardId?: InputMaybe<Scalars['String']>;
  characters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  forced?: InputMaybe<Scalars['Boolean']>;
  forcePinnedMessageOverride?: InputMaybe<Scalars['Boolean']>;
  messageId?: InputMaybe<Scalars['String']>;
  pinFor?: InputMaybe<Scalars['Int']>;
  revertToPreviousMessageAfterPin?: InputMaybe<Scalars['Boolean']>;
  sendAt?: InputMaybe<Scalars['Long']>;
  text?: InputMaybe<Scalars['String']>;
  visualEditorSessionId?: InputMaybe<Scalars['String']>;
};

export type CreateMessageAppearanceInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  boardId: Scalars['String'];
  /** If the feed item is provided, we will bump the send count which increments the total number of likes */
  feedItemId?: InputMaybe<Scalars['String']>;
  forced?: InputMaybe<Scalars['Boolean']>;
  /** This comes from the token typically, SuperAdmins can set this for now to bridge V1 messages */
  marketplaceListingId?: InputMaybe<Scalars['String']>;
  messageId: Scalars['String'];
  /** This comes from the token typically, SuperAdmins can set this for now to bridge V1 messages */
  personId?: InputMaybe<Scalars['String']>;
  /** If the pick is provided, we will bump the send count which increments the total number of likes */
  pickId?: InputMaybe<Scalars['String']>;
  /** If true, we will not send this message over the websocket connection. This allows us to temporarily bridge the V1 platform subscriptions by sending the same messages but storing them in this service while we migrate */
  silent?: InputMaybe<Scalars['Boolean']>;
  /** This comes from the token typically, SuperAdmins can set this for now to bridge V1 messages */
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type CreateMessageSetInput = {
  dynamic?: InputMaybe<Scalars['Boolean']>;
  dynamicConfiguration?: InputMaybe<DynamicMessageSetConfigurationInput>;
  id?: InputMaybe<Scalars['String']>;
  public: Scalars['Boolean'];
  title: Scalars['String'];
};

export type DynamicMessageSetConfigurationInput = {
  rss?: InputMaybe<DynamicMessageSetRssConfigurationInput>;
};

export type DynamicMessageSetRssConfigurationInput = {
  url: Scalars['String'];
};

export type MessageSetCreated = {
  __typename?: 'MessageSetCreated';
  messageSet: MessageSet;
};

export type MessageSetSuggestionInputV2 = {
  messageId: Scalars['String'];
  messageSetId: Scalars['String'];
};

export type MessageSetSuggestionResultV2 = MessageSetSuggestionErrorV2 | MessageSetSuggestionV2;

export type MessageSetSuggestionErrorV2 = {
  __typename?: 'MessageSetSuggestionErrorV2';
  error?: Maybe<Scalars['String']>;
  type: MessageSetSuggestionErrorType;
};

export enum MessageSetSuggestionErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type MessageSetSuggestionV2 = {
  __typename?: 'MessageSetSuggestionV2';
  messageId: Scalars['String'];
  messageSetId: Scalars['String'];
  personId: Scalars['String'];
};

export type CreateMessageSetInputV2 = {
  currentVersionId?: InputMaybe<Scalars['ID']>;
  dynamic: Scalars['Boolean'];
  messageIds: Array<Scalars['String']>;
  public: Scalars['Boolean'];
  rssUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateMessageSetVersionInput = {
  messages: Array<Scalars['String']>;
  messageSet: Scalars['String'];
};

export type CreateMessageSetVersionInputV2 = {
  messageIds: Array<Scalars['String']>;
  messageSetId: Scalars['ID'];
  title: Scalars['String'];
};

export type CreateMessageShareTokenInput = {
  message: Scalars['String'];
};

export type CreatedMessageShareToken = {
  __typename?: 'CreatedMessageShareToken';
  messageShareToken: GqlMessageShareToken;
  rawToken: Scalars['String'];
};

export type CreateMessageInputV2 = {
  /** The characters in the message. Either characters or text are required */
  characters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  /** The display type of the message, e.g., flagship or note. This is only used if the message is text-based to make a smaller display suitable for Vestaboard Note. */
  displayType?: InputMaybe<MessageDisplayType>;
  /** Searchable tags associated with the message */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** The text of the message. Either text or characters are required */
  text?: InputMaybe<Scalars['String']>;
};

export enum MessageDisplayType {
  Flagship = 'flagship',
  Note = 'note'
}

export type CreateNotificationSegmentInputV2 = {
  dynamicUrl?: InputMaybe<Scalars['String']>;
  isDynamic?: InputMaybe<Scalars['Boolean']>;
  personIds: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateNotificationTagInputV2 = {
  tagGroup?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateOutgoingWebhookInputV2 = {
  boardId: Scalars['String'];
  installableId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  url: Scalars['String'];
};

export type OutgoingWebhookResultV2 = OutgoingWebhookErrorV2 | OutgoingWebhookV2;

export type OutgoingWebhookErrorV2 = {
  __typename?: 'OutgoingWebhookErrorV2';
  error?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreatePersonInput = {
  id: Scalars['String'];
};

export type CreatePersonSuccessful = {
  __typename?: 'CreatePersonSuccessful';
  created: Scalars['Boolean'];
  person: Person;
};

export type AddPersonToExistingBoardsInput = {
  boards?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};

export type AddPersonToExistingTenantSuccessful = {
  __typename?: 'AddPersonToExistingTenantSuccessful';
  added: Scalars['Boolean'];
  exists: Scalars['Boolean'];
};

export type AddPersonToExistingTenantInput = {
  boardId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type CreatePersonInputV2 = {
  auth0UserId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreatePickInput = {
  categoryIds: Array<Scalars['String']>;
  characters: Array<Array<Scalars['Int']>>;
  deduplicationId?: InputMaybe<Scalars['String']>;
  recommendAfter: Scalars['Long'];
  recommendBefore: Scalars['Long'];
};

export type CreatePickSuccessful = {
  __typename?: 'CreatePickSuccessful';
  created: Pick;
};

export type CreatePickCategoryInput = {
  title: Scalars['String'];
};

export type CreatePickCategorySuccessful = {
  __typename?: 'CreatePickCategorySuccessful';
  created: PickCategory;
};

export type CreatePickCategoryInputV2 = {
  title: Scalars['String'];
};

export type CreatePickInputV2 = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  date: Scalars['String'];
  messageId: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
};

export type CreateProductApplicationInput = {
  board: Scalars['String'];
};

export type CreateRecommendationInput = {
  automation: AssociateAutomationMutationInput;
  installable: Scalars['String'];
  serializedCriteria?: InputMaybe<Scalars['String']>;
};

export type AssociateAutomationMutationInput = {
  create?: InputMaybe<CreateAutomationMutationInput>;
};

export type CreateRecommendationMutationSuccessResponse = {
  __typename?: 'CreateRecommendationMutationSuccessResponse';
  created: Recommendation;
};

export type CreateReferralCodeInputV2 = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  personEmail?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  personName?: InputMaybe<Scalars['String']>;
};

export type CreateRoleInputV2 = {
  boardId: Scalars['String'];
  hasIgnoredInvite?: InputMaybe<Scalars['Boolean']>;
  hasPendingInvite?: InputMaybe<Scalars['Boolean']>;
  permission?: InputMaybe<Direction>;
  personId: Scalars['String'];
};

export type CreateScheduledMessageInputV2 = {
  boardId: Scalars['String'];
  forced?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['String'];
  sendAt: Scalars['Float'];
};

export type CreateScheduledNotificationInputV2 = {
  callToAction?: InputMaybe<Scalars['String']>;
  deepLink?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personIds?: InputMaybe<Array<Scalars['String']>>;
  segmentIds?: InputMaybe<Array<Scalars['String']>>;
  sendAt?: InputMaybe<Scalars['Float']>;
  tagId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateSimulatorTokenInputV2 = {
  boardId: Scalars['String'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
};

export type CreateSubscriptionInput = {
  boardId: Scalars['String'];
  installableId?: InputMaybe<Scalars['String']>;
  installationId?: InputMaybe<Scalars['String']>;
  marketplaceListingId?: InputMaybe<Scalars['String']>;
  messageSetId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionSuccessful = {
  __typename?: 'CreateSubscriptionSuccessful';
  created: Scalars['Boolean'];
  subscription: Subscription;
};

export type CreateSubscriptionSetInput = {
  id: Scalars['String'];
};

export type CreateSubscriptionSetSuccessful = {
  __typename?: 'CreateSubscriptionSetSuccessful';
  subscriptionSet: SubscriptionSet;
};

export type CreateSubscriptionInputV2 = {
  boardId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  isV2Installable?: InputMaybe<Scalars['Boolean']>;
  marketplaceListingId: Scalars['String'];
  muted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateTemplateCategoryInputV2 = {
  title: Scalars['String'];
};

export type CreateTemplateMessageSuggestionInputV2 = {
  messageId: Scalars['String'];
};

export type CreateTemplateMessageInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['String'];
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['String'];
};

export type CreateTenantInput = {
  created?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTenantSuccessful = {
  __typename?: 'CreateTenantSuccessful';
  created: Scalars['Boolean'];
  tenant: Tenant;
};

export type CreateWebhookDestinationInput = {
  url: Scalars['String'];
};

export type DeleteAcceptedReferralInputV2 = {
  id: Scalars['ID'];
};

export type DeleteAccountInput = {
  account: Scalars['String'];
  newOwners: Array<DeleteAccountNewOwnerInput>;
};

export type DeleteAccountNewOwnerInput = {
  newOwnerEmailAddress?: InputMaybe<Scalars['String']>;
  newOwnerPersonId?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
};

export type DeleteAccountResult = {
  __typename?: 'DeleteAccountResult';
  successful: Scalars['Boolean'];
};

export type DeleteApiCredentialInput = {
  id: Scalars['String'];
};

export type DeleteApiCredentialSuccessful = {
  __typename?: 'DeleteApiCredentialSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteBoardInput = {
  boardId: Scalars['String'];
};

export type DeleteBoardResponseSuccessful = {
  __typename?: 'DeleteBoardResponseSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteBoardInputV2 = {
  id: Scalars['String'];
};

export type DeleteColorTemplateInput = {
  id: Scalars['String'];
};

export type DeleteColorTemplateSuccessful = {
  __typename?: 'DeleteColorTemplateSuccessful';
  deleted: ColorTemplate;
};

export type DeleteColorTemplateCategoryInput = {
  id: Scalars['String'];
};

export type DeleteColorTemplateCategorySuccessful = {
  __typename?: 'DeleteColorTemplateCategorySuccessful';
  deleted: ColorTemplateCategory;
};

export type DeleteColorTemplateInputV2 = {
  id: Scalars['ID'];
};

export type DigitalDeviceResultV2 = DigitalDeviceErrorV2 | DigitalDeviceV2;

export type DigitalDeviceErrorV2 = {
  __typename?: 'DigitalDeviceErrorV2';
  error?: Maybe<Scalars['String']>;
  type: DigitalDeviceErrorType;
};

export enum DigitalDeviceErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type DeleteDisplayGroupInputV2 = {
  id: Scalars['String'];
};

export type DeleteDraftInput = {
  draftId: Scalars['String'];
};

export type DeleteDraftResponse = {
  __typename?: 'DeleteDraftResponse';
  deleted: Scalars['Boolean'];
};

export type DeleteFeedItemInputV2 = {
  id: Scalars['ID'];
};

export type DeleteFeedTagInputV2 = {
  id: Scalars['ID'];
};

export type DeleteFlagshipDeviceInputV2 = {
  boardId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type DeleteInstallableInput = {
  id: Scalars['String'];
};

export type DeleteInstallableSuccessful = {
  __typename?: 'DeleteInstallableSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteInstallableInputV2 = {
  id: Scalars['ID'];
};

export type DeleteInstallationInput = {
  id: Scalars['String'];
};

export type DeleteInstallationSuccessful = {
  __typename?: 'DeleteInstallationSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteMarketplaceCategoryInputV2 = {
  id: Scalars['ID'];
};

export type DeleteMarketplaceFeatureTypeInputV2 = {
  id: Scalars['ID'];
};

export type DeleteMarketplaceListingInput = {
  marketplaceListingId: Scalars['String'];
};

export type MarketplaceListingCarouselInputV2 = {
  index: Scalars['Int'];
  marketplaceListingId: Scalars['String'];
};

export type MarketplaceFeatureImageInputV2 = {
  marketplaceListingId: Scalars['String'];
};

export type MarketplaceListingIconInputV2 = {
  marketplaceListingId: Scalars['String'];
};

export type DeleteMarketplaceListingInputV2 = {
  id: Scalars['ID'];
};

export type DeleteMasterPairingInputV2 = {
  boardId: Scalars['String'];
  deviceId: Scalars['String'];
};

export type DeleteMessageAppearanceInputV2 = {
  id: Scalars['String'];
};

export type DeleteMessageSetInput = {
  id: Scalars['String'];
};

export type MessageSetDeleted = {
  __typename?: 'MessageSetDeleted';
  deleted: Scalars['Boolean'];
};

export type DeleteMessageSetInputV2 = {
  id: Scalars['ID'];
};

export type DeleteMessageSetVersionInputV2 = {
  id: Scalars['ID'];
  messageSetId: Scalars['ID'];
};

export type DeleteNotificationSegmentInputV2 = {
  id: Scalars['ID'];
};

export type DeleteNotificationTagInputV2 = {
  id: Scalars['ID'];
};

export type DeleteNotificationInputV2 = {
  id: Scalars['ID'];
};

export type DeletePersonTenantAssociationInput = {
  personTenantAssociationId: Scalars['String'];
};

export type DeletePersonInputV2 = {
  id: Scalars['ID'];
};

export type DeletePickInput = {
  id: Scalars['String'];
};

export type DeletePickSuccessful = {
  __typename?: 'DeletePickSuccessful';
  deleted: Pick;
};

export type DeletePickCategoryInput = {
  id: Scalars['String'];
};

export type DeletePickCategorySuccessful = {
  __typename?: 'DeletePickCategorySuccessful';
  deleted: PickCategory;
};

export type DeletePickCategoryInputV2 = {
  id: Scalars['ID'];
};

export type DeletePickInputV2 = {
  id: Scalars['ID'];
};

export type DeleteRecommendationMutationInput = {
  id: Scalars['String'];
};

export type DeleteRecommendationSuccessful = {
  __typename?: 'DeleteRecommendationSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteRoleInputV2 = {
  boardId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteScheduledMessageInputV2 = {
  boardId: Scalars['String'];
};

export type DeleteScheduledNotificationInputV2 = {
  id: Scalars['ID'];
};

export type DeleteSubscriptionInput = {
  id: Scalars['String'];
};

export type DeleteSubscriptionSuccessful = {
  __typename?: 'DeleteSubscriptionSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteSubscriptionSetInput = {
  id: Scalars['String'];
};

export type DeleteSubscriptionSetSuccessful = {
  __typename?: 'DeleteSubscriptionSetSuccessful';
  deleted: Scalars['Boolean'];
};

export type DeleteSubscriptionInputV2 = {
  id: Scalars['ID'];
};

export type DeleteTemplateCategoryInputV2 = {
  id: Scalars['ID'];
};

export type DeleteTemplateMessageInputV2 = {
  id: Scalars['ID'];
};

export type DeleteTenantInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DeleteTenantSuccessful = {
  __typename?: 'DeleteTenantSuccessful';
  deleted: Scalars['Boolean'];
};

export type SetProductionOsVersionInput = {
  id: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};

export type SetDeployedOsVersionSuccess = {
  __typename?: 'SetDeployedOSVersionSuccess';
  success: Scalars['Boolean'];
};

export type DisableOsVersionDeploySuccess = {
  __typename?: 'DisableOSVersionDeploySuccess';
  success: Scalars['Boolean'];
};

export type DropMirrorInputV2 = {
  droneBoardId: Scalars['String'];
};

export type EditDraftInput = {
  characters?: InputMaybe<Array<Array<Scalars['Int']>>>;
  draft: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type SubscriptionConfigTokenResponseV2 = {
  __typename?: 'SubscriptionConfigTokenResponseV2';
  error?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type ExecuteContractInput = {
  contractVersion: Scalars['String'];
};

export type ExecuteContractMutationResponse = {
  __typename?: 'ExecuteContractMutationResponse';
  contractExecution: ContractExecution;
  executed: Scalars['Boolean'];
};

export type ExpirePlusSubscriptionForBoardInput = {
  board: Scalars['String'];
};

export type FactoryResetMutationInput = {
  deviceId: Scalars['String'];
};

export type FactoryResetResult = {
  __typename?: 'FactoryResetResult';
  success: Scalars['Boolean'];
};

export type FlaggedFeedItemInputV2 = {
  feedItemId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type FlaggedFeedItemResultV2 = FlaggedFeedItemErrorV2 | FlaggedFeedItemV2;

export type FlaggedFeedItemErrorV2 = {
  __typename?: 'FlaggedFeedItemErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FlaggedFeedItemErrorType;
};

export enum FlaggedFeedItemErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type FlaggedMessageInputV2 = {
  messageId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type FlaggedMessageResultV2 = FlaggedMessageErrorV2 | FlaggedMessageV2;

export type FlaggedMessageErrorV2 = {
  __typename?: 'FlaggedMessageErrorV2';
  error?: Maybe<Scalars['String']>;
  type: FlaggedMessageErrorType;
};

export enum FlaggedMessageErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type ForceThreeYearContractInput = {
  forcedThreeYearContract: Scalars['Boolean'];
  productApplicationId: Scalars['String'];
};

export type ForgetDeviceNetworkMutationInput = {
  device: Scalars['String'];
};

export type DeviceForgetNetworkRequestCreated = {
  __typename?: 'DeviceForgetNetworkRequestCreated';
  created: Scalars['Boolean'];
  deviceForgetNetworkRequest: DeviceForgetNetworkRequest;
};

export type GenerateActivationCodesInput = {
  productPricingId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type GenerateFlagshipDeviceInputV2 = {
  count: Scalars['Float'];
  deviceModel: FlagshipDeviceModel;
};

export type BulkCreateFlagshipDevices = {
  __typename?: 'BulkCreateFlagshipDevices';
  count: Scalars['Float'];
  success: Scalars['Boolean'];
};

export type HomeScreenBannerImageResponseResultV2 = HomeScreenBannerErrorV2 | HomeScreenBannerImageResponseV2;

export type HomeScreenBannerImageResponseV2 = {
  __typename?: 'HomeScreenBannerImageResponseV2';
  url: Scalars['String'];
};

export type HideHistoryMessageMutationInput = {
  appearance: Scalars['String'];
};

export type HideHistoryMessageSuccessful = {
  __typename?: 'HideHistoryMessageSuccessful';
  hidden: Scalars['Boolean'];
};

export type IgnoreInvitationForPersonAndTenantInput = {
  personTenantAssociationId: Scalars['String'];
};

export type IgnoreInvitationForPersonAndTenantSuccessResponse = {
  __typename?: 'IgnoreInvitationForPersonAndTenantSuccessResponse';
  ignored: Scalars['Boolean'];
  personTenantAssociation: PersonTenantAssociation;
};

export type InvalidateActivationCodeInput = {
  activationCode: Scalars['String'];
};

export type InvalidateBoardDeviceAssociationsInput = {
  boardIds: Array<Scalars['String']>;
};

export type InvalidateDeviceSuccess = {
  __typename?: 'InvalidateDeviceSuccess';
  success: Scalars['Boolean'];
};

export type InstallableCacheKeyInvalidated = {
  __typename?: 'InstallableCacheKeyInvalidated';
  id: Scalars['String'];
};

export type InvalidatePeopleInput = {
  personIds: Array<Scalars['String']>;
};

export type InvalidatePeopleResponse = {
  __typename?: 'InvalidatePeopleResponse';
  success: Scalars['Boolean'];
};

export type InviteInputV2 = {
  boardId: Scalars['String'];
  email: Scalars['String'];
  permission: Direction;
};

export type LeaveBoardInputV2 = {
  boardId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type NotificationClickedInputV2 = {
  id: Scalars['ID'];
};

export type MarkNotificationAsReadInputV2 = {
  id: Scalars['ID'];
};

export type MarkNotificationAsUnReadInputV2 = {
  id: Scalars['ID'];
};

export type MigrationResultV2 = {
  __typename?: 'MigrationResultV2';
  description?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type BoardMigrateV2 = {
  __typename?: 'BoardMigrateV2';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MessageMigrateV2 = {
  __typename?: 'MessageMigrateV2';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MarketplaceListingMigrateV2 = {
  __typename?: 'MarketplaceListingMigrateV2';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MarketplaceMigrationResultV2 = {
  __typename?: 'MarketplaceMigrationResultV2';
  description?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MigrateMessageSourcesInputV2 = {
  boardId: Scalars['String'];
};

export type MigrateMessageSourcesResultV2 = {
  __typename?: 'MigrateMessageSourcesResultV2';
  success: Scalars['Boolean'];
};

export type MirrorBoardInputV2 = {
  droneBoardIds: Array<Scalars['String']>;
  queenBoardId: Scalars['String'];
};

export type ModerateFeedItemInputV2 = {
  id: Scalars['ID'];
};

export type OptIntoRenewalInput = {
  productApplicationId: Scalars['String'];
};

export type OptOutOfRenewalInput = {
  productApplicationId: Scalars['String'];
  reason: Scalars['String'];
};

export type OptOutOfUnactivatedRenewalInput = {
  purchaseId: Scalars['String'];
  reason: Scalars['String'];
};

export type PairDeviceWithBoardMutationInput = {
  boardId: Scalars['String'];
  deviceId: Scalars['String'];
};

export type PairDeviceWithBoardSuccessful = {
  __typename?: 'PairDeviceWithBoardSuccessful';
  paired: Scalars['Boolean'];
};

export type PairFlagshipDeviceInputV2 = {
  boardId: Scalars['String'];
  id: Scalars['String'];
  pairingCode: Scalars['String'];
};

export type PauseInstallablesInput = {
  board: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
};

export type PauseInstallablesResponse = {
  __typename?: 'PauseInstallablesResponse';
  paused: Scalars['Boolean'];
};

export type CreatePinnedMessageInputV2 = {
  boardId: Scalars['String'];
  messageId: Scalars['String'];
  secondsToPin: Scalars['Int'];
};

export type PinnedMessageResultV2 = PinnedMessageErrorV2 | PinnedMessageV2;

export type PinnedMessageErrorV2 = {
  __typename?: 'PinnedMessageErrorV2';
  error?: Maybe<Scalars['String']>;
  type: PinnedMessageErrorType;
};

export enum PinnedMessageErrorType {
  NotAuthorized = 'NotAuthorized',
  NotFound = 'NotFound'
}

export type PublishInstallableInput = {
  cadenceConfigurationUrl?: InputMaybe<Scalars['String']>;
  cadenceDisplayTemplate?: InputMaybe<Scalars['String']>;
  cadenceOnCommand?: InputMaybe<Scalars['Boolean']>;
  cadenceToken?: InputMaybe<Scalars['String']>;
  canRename: Scalars['Boolean'];
  description: Scalars['String'];
  developer?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['String'];
  installableCategory: Scalars['String'];
  isSingleton: Scalars['Boolean'];
  subscriptionConfigurationUrl: Scalars['String'];
  title: Scalars['String'];
  webhookUrl: Scalars['String'];
};

export type PublishMessageSetVersionInput = {
  messageSetVersion: Scalars['String'];
};

export type PublishMessageSetVersionInputV2 = {
  id: Scalars['ID'];
  messageSetId: Scalars['ID'];
};

export type DeviceRefreshKeysMutationInput = {
  device: Scalars['String'];
};

export type DeviceRefreshKeysMutationOutput = {
  __typename?: 'DeviceRefreshKeysMutationOutput';
  refreshRequested: Scalars['Boolean'];
};

export type RemoveDraftInputV2 = {
  messageId: Scalars['String'];
  personId?: InputMaybe<Scalars['String']>;
};

export type RemoveFavoriteInputV2 = {
  messageId: Scalars['String'];
  personId?: InputMaybe<Scalars['String']>;
};

export type RemoveLikeInputV2 = {
  feedItemId?: InputMaybe<Scalars['String']>;
  pickId?: InputMaybe<Scalars['String']>;
  templateMessageId?: InputMaybe<Scalars['String']>;
};

export type RemoveMarketplaceListingFeatureInput = {
  id: Scalars['String'];
};

export type RemoveMessageSetFromBlendedInput = {
  boardId: Scalars['String'];
  messageSetId: Scalars['String'];
};

export type RemoveNotificationRegistrationTokenInputV2 = {
  personId?: InputMaybe<Scalars['String']>;
  registrationToken: Scalars['String'];
};

export type RemoveNotificationTagInputV2 = {
  personId?: InputMaybe<Scalars['String']>;
  tagId: Scalars['String'];
};

export type RemoveOutgoingWebhookInputV2 = {
  boardId: Scalars['String'];
  id: Scalars['String'];
};

export type RenewProductApplicationInput = {
  productApplicationId: Scalars['String'];
};

export type DeviceHeartbeatStatusMutationInput = {
  device: Scalars['String'];
};

export type DeviceHeartbeatStatusMutationOutput = {
  __typename?: 'DeviceHeartbeatStatusMutationOutput';
  requested: Scalars['Boolean'];
};

export type DeviceLogsMutationInput = {
  device: Scalars['String'];
};

export type DeviceLogsMutationOutput = {
  __typename?: 'DeviceLogsMutationOutput';
  requested: Scalars['Boolean'];
};

export type ReserverPairingCodeInput = {
  size: Scalars['Int'];
};

export type ReservePairingCodesResult = {
  __typename?: 'ReservePairingCodesResult';
  pairingCode?: Maybe<ReservedPairingCode>;
};

export type ReservedPairingCode = {
  __typename?: 'ReservedPairingCode';
  created: Scalars['Long'];
  id: Scalars['String'];
  pairingCode: Scalars['String'];
  token: Scalars['String'];
};


export type ReservedPairingCodeTokenArgs = {
  modelUuid: Scalars['String'];
  type: Scalars['String'];
};

export type RevokeInvitationForPersonAndTenantInput = {
  personTenantAssociationId: Scalars['String'];
};

export type RevokeInvitationForPersonAndTenantSuccessResponse = {
  __typename?: 'RevokeInvitationForPersonAndTenantSuccessResponse';
  personTenantAssociation: PersonTenantAssociation;
  revoked: Scalars['Boolean'];
};

export type SaveDigitalDeviceInputV2 = {
  audioEnabled?: InputMaybe<Scalars['Boolean']>;
  boardId: Scalars['String'];
  digitalDeviceStyleId: Scalars['String'];
  screenSaverEnabled?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DigitalDeviceType>;
};

export type SaveDraftInput = {
  messageId: Scalars['String'];
};

export type SaveDraftResponse = {
  __typename?: 'SaveDraftResponse';
  draftMessage: DraftMessage;
  saved: Scalars['Boolean'];
};

export type SaveSystemMessageTemplateInputV2 = {
  callToAction?: InputMaybe<Scalars['String']>;
  deepLink?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  section?: InputMaybe<Scalars['String']>;
  template: Scalars['String'];
  title: Scalars['String'];
};

export type SendOwnerLocalApiEnablementTokenInput = {
  board: Scalars['String'];
};

export type SendOwnerLocalApiEnablementTokenResponse = {
  __typename?: 'SendOwnerLocalApiEnablementTokenResponse';
  success: Scalars['Boolean'];
};

export type SetColorTemplateSortOrdersInput = {
  colorTemplateCategoryId: Scalars['String'];
  colorTemplateIds: Array<Scalars['String']>;
};

export type FlagshipDeviceTransitionInputV2 = {
  id: Scalars['String'];
  transitionInterval?: InputMaybe<Scalars['Float']>;
  transitionStepSize?: InputMaybe<Scalars['Float']>;
  transitionStrategy?: InputMaybe<Scalars['String']>;
};

export type SetMessageFavoriteInput = {
  favorited: Scalars['Boolean'];
  message: Scalars['String'];
};

export type SetMessageFavoriteResponse = {
  __typename?: 'SetMessageFavoriteResponse';
  messageFavorite: MessageFavorite;
};

export type SetPersonAppTokenInput = {
  token: Scalars['String'];
};

export type SetPersonAppTokenResponse = {
  __typename?: 'SetPersonAppTokenResponse';
  success: Scalars['Boolean'];
};

export type SuggestedSearchTermsInput = {
  searchTerms: Array<Scalars['String']>;
};

export type ShareInputV2 = {
  messageId: Scalars['String'];
};

export type ShareResultV2 = ShareErrorV2 | ShareV2;

export type ShareErrorV2 = {
  __typename?: 'ShareErrorV2';
  error?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ShareV2 = {
  __typename?: 'ShareV2';
  imageUrl: Scalars['String'];
  message: MessageV2;
  messageId: Scalars['String'];
  shareUrl: Scalars['String'];
  token: Scalars['String'];
};

export type SoftDeleteOsVersionInput = {
  id: Scalars['String'];
};

export type SoftDeleteOsVersionSuccess = {
  __typename?: 'SoftDeleteOsVersionSuccess';
  success: Scalars['Boolean'];
};

export type SubmitMessageSetInputV2 = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  messages: Array<Array<Array<Scalars['Int']>>>;
  title: Scalars['String'];
};

export type SyncReservedPairingCodeInput = {
  boiSerialNumber?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  pairingCode: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type TagFeedItemInputV2 = {
  id: Scalars['ID'];
  tagIds: Array<Scalars['String']>;
};

export type TransferOwnershipMutationInput = {
  transfers: Array<OwnershipTransferInput>;
};

export type OwnershipTransferInput = {
  newOwnerEmailAddress?: InputMaybe<Scalars['String']>;
  newOwnerPersonId?: InputMaybe<Scalars['String']>;
  tenant: Scalars['String'];
};

export type TransferOwnershipSuccessful = {
  __typename?: 'TransferOwnershipSuccessful';
  successful: Scalars['Boolean'];
};

export type UnCacheBoardInput = {
  id: Scalars['String'];
};

export type UnCacheBoardInputResult = {
  __typename?: 'UnCacheBoardInputResult';
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UndeleteBoardInput = {
  board: Scalars['String'];
};

export type UnInvalidateActivationCodeInput = {
  activationCode: Scalars['String'];
};

export type UnleaveBoardInput = {
  personTenantAssociationId: Scalars['String'];
};

export type UnModerateFeedItemInputV2 = {
  id: Scalars['ID'];
};

export type UnpairDeviceWithBoardInput = {
  pairedDeviceId: Scalars['String'];
};

export type UnpairDeviceWithBoardSuccessfulResponse = {
  __typename?: 'UnpairDeviceWithBoardSuccessfulResponse';
  unpaired: Scalars['Boolean'];
};

export type UnpauseInstallablesInput = {
  board: Scalars['String'];
};

export type UnpauseInstallablesResponse = {
  __typename?: 'UnpauseInstallablesResponse';
  unpaused: Scalars['Boolean'];
};

export type RemovePinnedMessageInputV2 = {
  boardId: Scalars['String'];
};

export type UnscheduleMessageInput = {
  messageId: Scalars['String'];
};

export type UnscheduleMessageResponse = {
  __typename?: 'UnscheduleMessageResponse';
  unscheduled: Scalars['Boolean'];
};

export type UnSubmitMessageSetInputV2 = {
  id: Scalars['ID'];
};

export type UpdateAcceptedReferralInputV2 = {
  /** We should eventually remove this from update, but it is needed to fix bad data */
  createdAt?: InputMaybe<Scalars['Float']>;
  creditRedeemed?: InputMaybe<Scalars['Boolean']>;
  creditType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  invalidated?: InputMaybe<Scalars['Float']>;
  notified?: InputMaybe<Scalars['Float']>;
  orderDeliveredAt?: InputMaybe<Scalars['Float']>;
};

export type UpdateBoardInput = {
  boardId: Scalars['String'];
  boardStyle?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  isTwentyFourHourTime?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  publishTokenEnabled?: InputMaybe<Scalars['Boolean']>;
  quietHours?: InputMaybe<Scalars['String']>;
  quietHoursBegin?: InputMaybe<Scalars['String']>;
  quietHoursEnd?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updateTitle?: InputMaybe<UpdateBoardTitleInput>;
  weekendQuietHoursBegin?: InputMaybe<Scalars['String']>;
  weekendQuietHoursEnd?: InputMaybe<Scalars['String']>;
};

export type UpdateBoardTitleInput = {
  value: Scalars['String'];
};

export type UpdateBoardResponseSuccessful = {
  __typename?: 'UpdateBoardResponseSuccessful';
  board: Board;
  updated: Scalars['Boolean'];
};

export type UpdateBoardInputV2 = {
  /** Board style. Black/White */
  boardStyle?: InputMaybe<Scalars['String']>;
  /** Person that own's the board */
  creator?: InputMaybe<Scalars['String']>;
  /** The board's hubspot id. */
  hubspotDealId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** Is internal. */
  internalBoard?: InputMaybe<Scalars['Boolean']>;
  isDigital?: InputMaybe<Scalars['Boolean']>;
  isTwentyFourHourTime?: InputMaybe<Scalars['Boolean']>;
  /** Quiet hours */
  quietHours?: InputMaybe<QuietHoursInputV2>;
  /** Timezone. */
  timezone?: InputMaybe<Scalars['String']>;
  /** The title of the board. */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateColorTemplateInput = {
  categoryId: Scalars['String'];
  characters: Array<Array<Scalars['Int']>>;
  id: Scalars['String'];
};

export type UpdateColorTemplateSuccessful = {
  __typename?: 'UpdateColorTemplateSuccessful';
  updated: ColorTemplate;
};

export type UpdateColorTemplateCategoryInput = {
  id: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateColorTemplateCategorySuccessful = {
  __typename?: 'UpdateColorTemplateCategorySuccessful';
  updated: ColorTemplateCategory;
};

export type UpdateColorTemplateInputV2 = {
  id: Scalars['ID'];
  messageIds: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateDeveloperInput = {
  id: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateDeviceFirmwareVersionInput = {
  firmwareVersion?: InputMaybe<FirmwareVersion>;
  id: Scalars['String'];
};

export enum FirmwareVersion {
  Pvt = 'PVT',
  Yocto1 = 'YOCTO1',
  Yocto2 = 'YOCTO2',
  Yocto3 = 'YOCTO3'
}

export type UpdateDeviceYoctoStatusMutationInput = {
  date: Scalars['Long'];
  device: Scalars['String'];
};

export type UpdateDeviceYoctoStatusByTimezoneMutationInput = {
  confirmation: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type UpdateDisplayGroupInputV2 = {
  boardIds?: InputMaybe<Array<Array<Scalars['String']>>>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  messageId: Scalars['String'];
  personId?: InputMaybe<Scalars['String']>;
};

export type UpdateEmailAddressInput = {
  accountId: Scalars['String'];
  newEmailAddress: Scalars['String'];
};

export type UpdateFeedTagInputV2 = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type FlagshipDeviceHeartbeatInputV2 = {
  boardId?: InputMaybe<Scalars['ID']>;
  containers?: InputMaybe<Array<FlagshipDeviceHeartbeatContainerInputV2>>;
  created?: InputMaybe<Scalars['Float']>;
  deviceId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  ipAddress: Scalars['String'];
  lastSeen: Scalars['Float'];
  location?: InputMaybe<Scalars['String']>;
  maskStatus: Scalars['String'];
  networks?: InputMaybe<Array<FlagshipDeviceHeartbeatNetworkInputV2>>;
  timeago?: InputMaybe<Scalars['Float']>;
};

export type FlagshipDeviceHeartbeatContainerInputV2 = {
  id: Scalars['String'];
  image: Scalars['String'];
  since: Scalars['Float'];
  version: Scalars['String'];
};

export type FlagshipDeviceHeartbeatNetworkInputV2 = {
  ipAddress: Scalars['String'];
  online: Scalars['String'];
  ssid: Scalars['String'];
  type: Scalars['String'];
  up: Scalars['Boolean'];
};

/** Not all fields on Flagship device are required, omitting a field will not overwrite the current database fields for this mutation. We want to make sure pairing codes are reserved and unique */
export type UpdateFlagshipDeviceInputV2 = {
  deviceModel: FlagshipDeviceModel;
  id: Scalars['String'];
};

export type UpdateHomeScreenBannerInputV2 = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttons?: InputMaybe<Array<HomeScreenBannerButtonInputV2>>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  positionInFeed: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateInstallableInput = {
  cadenceConfigurationUrl?: InputMaybe<Scalars['String']>;
  cadenceDisplayTemplate?: InputMaybe<Scalars['String']>;
  cadenceOnCommand?: InputMaybe<Scalars['Boolean']>;
  cadenceToken?: InputMaybe<Scalars['String']>;
  canRename: Scalars['Boolean'];
  configurationSchema?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  developer: Scalars['String'];
  hiddenFromList: Scalars['Boolean'];
  id: Scalars['String'];
  isSingleton: Scalars['Boolean'];
  logo: Scalars['String'];
  releaseDay: Scalars['Int'];
  releaseMonth: Scalars['Int'];
  releaseYear: Scalars['Int'];
  subscriptionConfigurationUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  webhookDestinationId?: InputMaybe<Scalars['String']>;
};

export type UpdateInstallableInputV2 = {
  cadenceConfigurationUrl?: InputMaybe<Scalars['String']>;
  cadenceDisplayTemplate?: InputMaybe<Scalars['String']>;
  cadenceOnCommand?: InputMaybe<Scalars['Boolean']>;
  cadenceToken?: InputMaybe<Scalars['String']>;
  canBeRenamed?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isV2Installable?: InputMaybe<Scalars['Boolean']>;
  subscriptionConfigurationUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateMarketplaceCategoryInputV2 = {
  id: Scalars['String'];
  marketplaceListingIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type UpdateMarketplaceConfigurationInput = {
  featuredChannel?: InputMaybe<UpdateMarketplaceConfigurationFeaturedItemInput>;
  featuredItems: Array<UpdateMarketplaceConfigurationFeaturedItemInput>;
};

export type UpdateMarketplaceConfigurationFeaturedItemInput = {
  description?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
  imageVariant?: InputMaybe<Scalars['String']>;
  marketplaceListingId: Scalars['String'];
};

export type UpdateMarketplaceConfigurationSuccessResponse = {
  __typename?: 'UpdateMarketplaceConfigurationSuccessResponse';
  success: Scalars['Boolean'];
};

export type UpdateMarketplaceFeatureTypeInputV2 = {
  id: Scalars['String'];
  marketplaceListingIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type SaveMarketplaceGalleryInputV2 = {
  items: Array<SaveMarketplaceGalleryItemInputV2>;
};

export type SaveMarketplaceGalleryItemInputV2 = {
  description: Scalars['String'];
  id: Scalars['ID'];
  marketplaceListingId: Scalars['String'];
};

export type UpdateMarketplaceListingInput = {
  carouselImage1?: InputMaybe<Scalars['String']>;
  carouselImage2?: InputMaybe<Scalars['String']>;
  carouselImage3?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  developer: Scalars['String'];
  featured?: InputMaybe<Scalars['Boolean']>;
  free?: InputMaybe<Scalars['Boolean']>;
  iconUrl: Scalars['String'];
  id: Scalars['String'];
  installable: Scalars['String'];
  isSingleton?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  messageSet?: InputMaybe<Scalars['String']>;
  noteCarouselImage1?: InputMaybe<Scalars['String']>;
  noteCarouselImage2?: InputMaybe<Scalars['String']>;
  noteCarouselImage3?: InputMaybe<Scalars['String']>;
  notePreviewMessage?: InputMaybe<Scalars['String']>;
  previewMessage?: InputMaybe<Scalars['String']>;
  questionAndAnswerId?: InputMaybe<Scalars['String']>;
  releaseDay: Scalars['Int'];
  releaseMonth: Scalars['Int'];
  releaseYear: Scalars['Int'];
  shortDescription?: InputMaybe<Scalars['String']>;
  stagingOnly?: InputMaybe<Scalars['Boolean']>;
  supportsFlagship?: InputMaybe<Scalars['Boolean']>;
  supportsNote?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
  voiceControlIntent?: InputMaybe<Scalars['String']>;
  voiceControlOrderPreference?: InputMaybe<Scalars['String']>;
  voiceControlSlotValues?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketplaceListingFeatureInput = {
  id: Scalars['String'];
  marketplaceListingIds: Array<Scalars['String']>;
};

export type UpdateMarketplaceListingInputV2 = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  configuration?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  enabledInstallationsCount?: InputMaybe<Scalars['Float']>;
  featureTypeIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  installableId: Scalars['String'];
  installationsCount?: InputMaybe<Scalars['Float']>;
  installationsInPast30DaysCount?: InputMaybe<Scalars['Float']>;
  installationsInPast7DaysCount?: InputMaybe<Scalars['Float']>;
  installDeepLink?: InputMaybe<Scalars['String']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  isSingleton?: InputMaybe<Scalars['Boolean']>;
  messageSetId?: InputMaybe<Scalars['String']>;
  notePreviewMessage?: InputMaybe<Scalars['String']>;
  previewMessage?: InputMaybe<Scalars['String']>;
  questionAndAnswerId?: InputMaybe<Scalars['String']>;
  releaseAt?: InputMaybe<Scalars['Float']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  stagingOnly?: InputMaybe<Scalars['Boolean']>;
  supportsFlagship?: InputMaybe<Scalars['Boolean']>;
  supportsNote?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  versionNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateMessageSetInput = {
  id: Scalars['String'];
  public: Scalars['Boolean'];
  published?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateMessageSetInputV2 = {
  currentVersionId?: InputMaybe<Scalars['ID']>;
  dynamic: Scalars['Boolean'];
  id: Scalars['ID'];
  messageIds: Array<Scalars['String']>;
  public: Scalars['Boolean'];
  rssUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateMessageSetVersionInputV2 = {
  id: Scalars['ID'];
  messageIds: Array<Scalars['String']>;
  messageSetId: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateNotificationSegmentInputV2 = {
  dynamicUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isDynamic?: InputMaybe<Scalars['Boolean']>;
  personIds: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateNotificationTagInputV2 = {
  id: Scalars['String'];
  tagGroup?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdatePersonInput = {
  id: Scalars['String'];
  name?: InputMaybe<UpdatePersonNameInput>;
  photo?: InputMaybe<UpdatePersonPhotoInput>;
};

export type UpdatePersonNameInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpdatePersonPhotoInput = {
  photo: Scalars['String'];
};

export type UpdatePersonSuccessful = {
  __typename?: 'UpdatePersonSuccessful';
  person: Person;
  updated: Scalars['Boolean'];
};

export type UpdatePersonTenantAssociationInput = {
  newRole?: InputMaybe<UpdatePersonTenantAssociationRoleInput>;
  personTenantAssociationId: Scalars['String'];
};

export type UpdatePersonTenantAssociationRoleInput = {
  role: Scalars['String'];
};

export type UpdatePersonInputV2 = {
  auth0UserId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpdatePickInput = {
  categoryIds: Array<Scalars['String']>;
  characters: Array<Array<Scalars['Int']>>;
  id: Scalars['String'];
  recommendAfter: Scalars['Long'];
  recommendBefore: Scalars['Long'];
};

export type UpdatePickSuccessful = {
  __typename?: 'UpdatePickSuccessful';
  updated: Pick;
};

export type UpdatePickCategoryInput = {
  id: Scalars['String'];
  title: Scalars['String'];
};

export type UpdatePickCategorySuccessful = {
  __typename?: 'UpdatePickCategorySuccessful';
  updated: PickCategory;
};

export type UpdatePickCategoryInputV2 = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdatePickInputV2 = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  date: Scalars['String'];
  id: Scalars['ID'];
  messageId: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
};

export type UpdateProductApplicationInput = {
  productApplicationId: Scalars['String'];
  productPricingId: Scalars['String'];
};

export type UpdateReferralInput = {
  id: Scalars['String'];
  invalid: Scalars['Boolean'];
};

export type UpdateReferralSuccess = {
  __typename?: 'UpdateReferralSuccess';
  success: Scalars['Boolean'];
};

export type UpdateRoleInputV2 = {
  boardId: Scalars['String'];
  hasPendingInvite?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  permission?: InputMaybe<Direction>;
  personId: Scalars['String'];
};

export type UpdateScheduledNotificationInputV2 = {
  callToAction?: InputMaybe<Scalars['String']>;
  deepLink?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  message: Scalars['String'];
  personIds?: InputMaybe<Array<Scalars['String']>>;
  segmentId?: InputMaybe<Scalars['String']>;
  segmentIds?: InputMaybe<Array<Scalars['String']>>;
  sendAt?: InputMaybe<Scalars['Float']>;
  tagId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateShopifyPaymentMethodMutationInput = {
  productApplicationId: Scalars['String'];
};

export type ShopifyUpdatePaymentMethodResult = {
  __typename?: 'ShopifyUpdatePaymentMethodResult';
  success: Scalars['Boolean'];
};

export type UpdateSubscriptionInput = {
  muted?: InputMaybe<Scalars['Boolean']>;
  subscriptionId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSubscriptionSuccessful = {
  __typename?: 'UpdateSubscriptionSuccessful';
  subscription: Subscription;
};

export type UpdateSubscriptionSetInput = {
  subscriptionSet: Scalars['String'];
  subscriptionsOrdered: Array<Array<Scalars['String']>>;
};

export type UpdateSubscriptionSetSuccessful = {
  __typename?: 'UpdateSubscriptionSetSuccessful';
  subscriptionSet: SubscriptionSet;
};

export type UpdateSubscriptionInputV2 = {
  boardId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isV2Installable?: InputMaybe<Scalars['Boolean']>;
  marketplaceListingId: Scalars['String'];
  muted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTemplateCategoryInputV2 = {
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateTemplateMessageInputV2 = {
  attribution?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['String'];
  id: Scalars['ID'];
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['String'];
};

export type UpdateTenantInput = {
  id: Scalars['String'];
  name?: InputMaybe<UpdateTenantNameInput>;
};

export type UpdateTenantNameInput = {
  value: Scalars['String'];
};

export type UpdateTenantSuccessful = {
  __typename?: 'UpdateTenantSuccessful';
  updated: Scalars['Boolean'];
};

export type DeviceUpgradeFirmwareMutationInput = {
  device: Scalars['String'];
  osVersionId: Scalars['String'];
};

export type DeviceUpgradeFirmwareMutationOutput = {
  __typename?: 'DeviceUpgradeFirmwareMutationOutput';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MarketplaceGalleryUploadResultV2 = MarketplaceGalleryErrorV2 | MarketplaceGalleryUploadV2;

export type MarketplaceGalleryUploadV2 = {
  __typename?: 'MarketplaceGalleryUploadV2';
  uploadUrl: Scalars['String'];
};

export type MarketplaceListingUploadResultV2 = MarketplaceListingErrorV2 | MarketplaceListingUploadV2;

export type MarketplaceListingUploadV2 = {
  __typename?: 'MarketplaceListingUploadV2';
  uploadUrl: Scalars['String'];
};

export type PersonProfileImageUploadResultV2 = PersonErrorV2 | PersonProfileImageUploadV2;

export type PersonProfileImageUploadV2 = {
  __typename?: 'PersonProfileImageUploadV2';
  uploadUrl: Scalars['String'];
};

export type UpsertSingletonChannelForListingInput = {
  board: Scalars['String'];
  data?: InputMaybe<Scalars['String']>;
  listing: Scalars['String'];
};

export type UpsertSingletonChannelForListingResponse = {
  __typename?: 'UpsertSingletonChannelForListingResponse';
  channel: Subscription;
};

export type BalanceUpdateOrderTimelineItem = OrderTimelineItem & {
  __typename?: 'BalanceUpdateOrderTimelineItem';
  balance: Scalars['Int'];
  created: Scalars['Long'];
  id: Scalars['String'];
};

export type BoardPrincipal = Principal & {
  __typename?: 'BoardPrincipal';
  board: Board;
  created: Scalars['String'];
  id: Scalars['String'];
};

export type DevicePrincipal = Principal & {
  __typename?: 'DevicePrincipal';
  created: Scalars['String'];
  id: Scalars['String'];
};

export type EmptyPrincipal = Principal & {
  __typename?: 'EmptyPrincipal';
  created: Scalars['String'];
  id: Scalars['String'];
};

export type EmptyTenant = Tenant & {
  __typename?: 'EmptyTenant';
  boards: Array<Board>;
  created: Scalars['String'];
  id: Scalars['String'];
  installations: Array<Installation>;
  members: Array<PersonTenantAssociation>;
  name: Scalars['String'];
};


export type EmptyTenantBoardsArgs = {
  roles?: InputMaybe<Scalars['String']>;
};

export type GqlFactoryPrincipal = Principal & {
  __typename?: 'GqlFactoryPrincipal';
  created: Scalars['String'];
  id: Scalars['String'];
};

export type GqlSystemPrincipal = Principal & {
  __typename?: 'GqlSystemPrincipal';
  created: Scalars['String'];
  id: Scalars['String'];
};

export type GroupTenant = Tenant & {
  __typename?: 'GroupTenant';
  boards: Array<Board>;
  created: Scalars['String'];
  id: Scalars['String'];
  installations: Array<Installation>;
  members: Array<PersonTenantAssociation>;
  name: Scalars['String'];
};


export type GroupTenantBoardsArgs = {
  roles?: InputMaybe<Scalars['String']>;
};

export type InstallablePrincipal = Principal & {
  __typename?: 'InstallablePrincipal';
  apiCredentials: Array<ApiCredential>;
  created: Scalars['String'];
  id: Scalars['String'];
  installable: Installable;
};

export type InstallationPrincipal = Principal & {
  __typename?: 'InstallationPrincipal';
  apiCredentials: Array<ApiCredential>;
  created: Scalars['String'];
  id: Scalars['String'];
  installation: Installation;
};

export type MessageDraftSearchResult = MessageSearchResult & {
  __typename?: 'MessageDraftSearchResult';
  created: Scalars['Long'];
  message: Message;
  person: Person;
};

export type MessageFavoriteSearchResult = MessageSearchResult & {
  __typename?: 'MessageFavoriteSearchResult';
  created: Scalars['Long'];
  message: Message;
  person: Person;
};

export type MessageHistorySearchResult = MessageSearchResult & {
  __typename?: 'MessageHistorySearchResult';
  board?: Maybe<Board>;
  created: Scalars['Long'];
  message: Message;
  messageAppearance: MessageAppearance;
};

export type MessageSetPrincipal = Principal & {
  __typename?: 'MessageSetPrincipal';
  created: Scalars['String'];
  id: Scalars['String'];
  messageSet: MessageSet;
};

export type PaymentOrderTimelineItem = OrderTimelineItem & {
  __typename?: 'PaymentOrderTimelineItem';
  afterBalanceId: Scalars['String'];
  amount: Scalars['Int'];
  created: Scalars['Long'];
  id: Scalars['String'];
  stripeChargeId: Scalars['String'];
  totalPaymentAmount: Scalars['Int'];
};

export type PersonPrincipal = Principal & {
  __typename?: 'PersonPrincipal';
  apiCredentials: Array<ApiCredential>;
  created: Scalars['String'];
  id: Scalars['String'];
  person: Person;
};

export type SingleBoardsSelectorQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type SingleBoardsSelectorQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, title: string } };

export type ApplyProductMutationVariables = Exact<{
  board: Scalars['String'];
  code: Scalars['String'];
}>;


export type ApplyProductMutation = { __typename?: 'Mutation', applyRedemptionCode: { __typename?: 'AppliedRedemptionCode', productApplication: { __typename?: 'ProductApplication', id: string, board?: { __typename?: 'Board', id: string } | null } } };

export type ProductPricingQueryVariables = Exact<{
  quantity: Scalars['Int'];
}>;


export type ProductPricingQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, productPricings: Array<{ __typename?: 'ProductPricing', id: string, chargeFrequency: string, title?: string | null, priceInCents: number, pricePerMonthInCents?: number | null, estimatedPriceInCents: { __typename?: 'EstimatedPrice', totalPrice: number, cartLink?: string | null } }> } };

export type ValidateActivationCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ValidateActivationCodeQuery = { __typename?: 'Query', activationCodeQuery: { __typename?: 'ActivationCodeValidation', isValid: boolean, message?: string | null } };

export type ResendMessageMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
  characters?: InputMaybe<Array<Array<Scalars['Int']> | Scalars['Int']> | Array<Scalars['Int']> | Scalars['Int']>;
  messageId?: InputMaybe<Scalars['String']>;
  boardId: Scalars['String'];
  forced?: InputMaybe<Scalars['Boolean']>;
  forcePinnedMessageOverride?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResendMessageMutation = { __typename?: 'Mutation', createMessage2: { __typename?: 'CreateMessage2Successful', created: boolean, message?: { __typename?: 'Message', id: string } | null } };

export type GetMessageSetCreatorSubscriptionsQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetMessageSetCreatorSubscriptionsQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, title: string, subscriptionSet: { __typename?: 'SubscriptionSet', id: string, subscriptions: Array<{ __typename?: 'Subscription', id: string, title?: string | null, icon?: string | null }> } } };

export type AddMessageSetCreatorMessageMutationVariables = Exact<{
  input: AddMessageSetCreatorMessageInput;
}>;


export type AddMessageSetCreatorMessageMutation = { __typename?: 'Mutation', addMessageSetCreatorMessage: { __typename?: 'AddMessageSetCreatorMessageResponse', success: boolean } };

export type AcceptInviteMutationVariables = Exact<{
  personTenantAssociationId: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptPersonTenantInvitation: { __typename?: 'AcceptInvitationForPersonAndTenantSuccessResponse', accepted: boolean } };

export type GetBoardRoles2QueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetBoardRoles2Query = { __typename?: 'Query', board: { __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, invitationStatus: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, invitationStatus: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, invitationStatus: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } } };

export type AddMessageSetToBlendedMutationVariables = Exact<{
  input: AddMessageSetToBlendedInput;
}>;


export type AddMessageSetToBlendedMutation = { __typename?: 'Mutation', addMessageSetToBlended: { __typename?: 'Blended', id: string, messageSetIds: Array<string> } };

export type RemoveMessageSetFromBlendedMutationVariables = Exact<{
  input: RemoveMessageSetFromBlendedInput;
}>;


export type RemoveMessageSetFromBlendedMutation = { __typename?: 'Mutation', removeMessageSetFromBlended: { __typename?: 'Blended', id: string, messageSetIds: Array<string> } };

export type BlendedQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BlendedQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, blended?: { __typename?: 'Blended', id: string, messageSetIds: Array<string> } | null } };

export type BoardQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, boardStyle: string, title: string, publicUrl: string, tenant: { __typename?: 'PersonTenant', id: string, name: string } | { __typename?: 'EmptyTenant', id: string, name: string } | { __typename?: 'GroupTenant', id: string, name: string }, subscriptionSet: { __typename?: 'SubscriptionSet', id: string, subscriptions: Array<{ __typename?: 'Subscription', id: string, created: string, installation?: { __typename?: 'Installation', id: string, installable: { __typename?: 'Installable', id: string, title?: string | null } } | null }> } } };

export type BoardsSelectorQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type BoardsSelectorQuery = { __typename?: 'Query', boards: Array<{ __typename?: 'Board', id: string, title: string, boardStyle: string }> };

export type BroadcastMessageMutationVariables = Exact<{
  input: BroadcastMessageInput;
}>;


export type BroadcastMessageMutation = { __typename?: 'Mutation', broadcastMessage: { __typename?: 'BroadcastMessageResponse', messages: Array<{ __typename?: 'CreateMessage2Successful', created: boolean }> } };

export type CreateBoardV2MutationVariables = Exact<{
  input: CreateBoardInputV2;
}>;


export type CreateBoardV2Mutation = { __typename?: 'Mutation', createBoardV2: { __typename?: 'BoardErrorV2', type: BoardErrorType, error?: string | null } | { __typename?: 'BoardV2', id: string, title: string, boardStyle?: string | null } };

export type CreateDraftV2MutationVariables = Exact<{
  input: CreateDraftInputV2;
}>;


export type CreateDraftV2Mutation = { __typename?: 'Mutation', createDraft: { __typename: 'DraftErrorV2', type: DraftErrorType, error?: string | null } | { __typename: 'DraftV2', id: string, created: number, attribution: string, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> } } };

export type FavoriteV2MutationVariables = Exact<{
  input: CreateFavoriteInputV2;
}>;


export type FavoriteV2Mutation = { __typename?: 'Mutation', createFavorite: { __typename?: 'FavoriteErrorV2', type: FavoriteErrorType, error?: string | null } | { __typename?: 'FavoriteV2', id: string, message: { __typename?: 'MessageV2', id: string, isFavorited: boolean } } };

export type CreateFeedItemV2MutationVariables = Exact<{
  input: CreateFeedItemInputV2;
}>;


export type CreateFeedItemV2Mutation = { __typename?: 'Mutation', createFeedItem: { __typename?: 'FeedItemErrorV2', type: FeedItemErrorType, error?: string | null } | { __typename?: 'FeedItemV2', id: string, personId?: string | null, subscriptionId?: string | null, attribution: string, likeCount: number, moderated?: boolean | null, created: number, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> } } };

export type CreateLikeV2MutationVariables = Exact<{
  input: CreateLikeInputV2;
}>;


export type CreateLikeV2Mutation = { __typename?: 'Mutation', createLike: { __typename?: 'LikeErrorV2', type: LikeErrorType, error?: string | null } | { __typename: 'LikeV2', feedItem?: { __typename?: 'FeedItemV2', id: string, isLikedByMe: boolean, likeCount: number } | null, pick?: { __typename?: 'PickV2', id: string, isLikedByMe: boolean, likeCount: number } | null } };

export type CreateBoardMessageMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
  characters?: InputMaybe<Array<Array<Scalars['Int']> | Scalars['Int']> | Array<Scalars['Int']> | Scalars['Int']>;
  messageId?: InputMaybe<Scalars['String']>;
  boardId: Scalars['String'];
}>;


export type CreateBoardMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'CreateMessageSuccessful', created: boolean, message: { __typename?: 'Message', id: string } } };

export type CreateMessageAppearanceV2MutationVariables = Exact<{
  input: CreateMessageAppearanceInputV2;
}>;


export type CreateMessageAppearanceV2Mutation = { __typename?: 'Mutation', createMessageAppearance: { __typename?: 'MessageAppearanceErrorV2', type: MessageAppearanceErrorType, error?: string | null } | { __typename?: 'MessageAppearanceV2', id: string, attribution: string, sentAt: number, created: number, subscriptionId?: string | null, personId?: string | null, boardId: string, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null } } };

export type CreateMessageV2MutationVariables = Exact<{
  input: CreateMessageInputV2;
}>;


export type CreateMessageV2Mutation = { __typename?: 'Mutation', createMessage: { __typename?: 'MessageErrorV2', type: MessageErrorType, error?: string | null } | { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null } };

export type CreateScheduledMessageV2MutationVariables = Exact<{
  input: CreateScheduledMessageInputV2;
}>;


export type CreateScheduledMessageV2Mutation = { __typename?: 'Mutation', createScheduledMessage: { __typename: 'ScheduledMessageErrorV2', type: ScheduledMessageErrorType, error?: string | null } | { __typename: 'ScheduledMessageV2', id: string, sendAt: number, attribution: string, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> } } };

export type CreateMessageShareTokenMutationVariables = Exact<{
  input: CreateMessageShareTokenInput;
}>;


export type CreateMessageShareTokenMutation = { __typename?: 'Mutation', createMessageShareToken: { __typename?: 'CreatedMessageShareToken', rawToken: string, messageShareToken: { __typename?: 'GqlMessageShareToken', id: string, created: any } } };

export type DeleteBoardMutationVariables = Exact<{
  input: DeleteBoardInput;
}>;


export type DeleteBoardMutation = { __typename?: 'Mutation', deleteBoard: { __typename?: 'DeleteBoardResponseSuccessful', deleted: boolean } };

export type DeleteBoardV2MutationVariables = Exact<{
  input: DeleteBoardInputV2;
}>;


export type DeleteBoardV2Mutation = { __typename?: 'Mutation', deleteBoardV2: { __typename?: 'BoardErrorV2', type: BoardErrorType, error?: string | null } | { __typename?: 'BoardV2', id: string, title: string } };

export type DeleteDraftMutationVariables = Exact<{
  input: DeleteDraftInput;
}>;


export type DeleteDraftMutation = { __typename?: 'Mutation', deleteDraft: { __typename?: 'DeleteDraftResponse', deleted: boolean } };

export type DeleteDraftV2MutationVariables = Exact<{
  input: RemoveDraftInputV2;
}>;


export type DeleteDraftV2Mutation = { __typename?: 'Mutation', removeDraft: { __typename: 'DraftErrorV2', type: DraftErrorType, error?: string | null } | { __typename: 'DraftV2', id: string, created: number, attribution: string, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> } } };

export type DeleteFeedItemV2MutationVariables = Exact<{
  input: DeleteFeedItemInputV2;
}>;


export type DeleteFeedItemV2Mutation = { __typename?: 'Mutation', deleteFeedItem: { __typename?: 'FeedItemErrorV2', type: FeedItemErrorType, error?: string | null } | { __typename?: 'FeedItemV2', id: string } };

export type DeleteMessageAppearanceV2MutationVariables = Exact<{
  input: DeleteMessageAppearanceInputV2;
}>;


export type DeleteMessageAppearanceV2Mutation = { __typename?: 'Mutation', deleteMessageAppearance: { __typename?: 'MessageAppearanceErrorV2', type: MessageAppearanceErrorType, error?: string | null } | { __typename?: 'MessageAppearanceV2', id: string } };

export type DeleteScheduledMessageV2MutationVariables = Exact<{
  input: DeleteScheduledMessageInputV2;
}>;


export type DeleteScheduledMessageV2Mutation = { __typename?: 'Mutation', deleteScheduledMessage: { __typename: 'ScheduledMessageErrorV2', type: ScheduledMessageErrorType, error?: string | null } | { __typename: 'ScheduledMessageV2', id: string, sendAt: number, attribution: string, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> } } };

export type DeleteSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DeleteSubscriptionMutation = { __typename?: 'Mutation', deleteSubscription: { __typename?: 'DeleteSubscriptionSuccessful', deleted: boolean } };

export type GetDiscoverCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscoverCategoriesQuery = { __typename?: 'Query', marketplaceListingsCategories: Array<{ __typename?: 'InstallableCategory', id: string, title: string }> };

export type FlagFeedItemV2MutationVariables = Exact<{
  input: FlaggedFeedItemInputV2;
}>;


export type FlagFeedItemV2Mutation = { __typename?: 'Mutation', flagFeedItem: { __typename?: 'FlaggedFeedItemErrorV2', type: FlaggedFeedItemErrorType, error?: string | null } | { __typename?: 'FlaggedFeedItemV2', feedItem: { __typename?: 'FeedItemV2', id: string, isFlaggedByMe: boolean } } };

export type BoardStyleQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardStyleQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, boardStyle: string, title: string } };

export type GetBoardV2QueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBoardV2Query = { __typename?: 'Query', BoardV2: { __typename?: 'BoardErrorV2' } | { __typename?: 'BoardV2', id: string, title: string, createdAt: number, isQuietHours?: boolean | null, timezone?: string | null, boardStyle?: string | null, quietHours?: { __typename?: 'QuietHoursV2', start?: string | null, end?: string | null } | null, listFlagshipDevices?: { __typename?: 'ListFlagshipDevices', flagshipDevices: Array<{ __typename?: 'FlagshipDeviceV2', id: string, heartbeat?: { __typename?: 'FlagshipDeviceHeartbeatV2', lastSeen: number } | null }> } | null } };

export type GetBoardQuietHoursV2QueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBoardQuietHoursV2Query = { __typename?: 'Query', BoardV2: { __typename?: 'BoardErrorV2' } | { __typename?: 'BoardV2', id: string, title: string, createdAt: number, isQuietHours?: boolean | null, timezone?: string | null, boardStyle?: string | null, quietHours?: { __typename?: 'QuietHoursV2', start?: string | null, end?: string | null } | null } };

export type GetColorTemplateV2QueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetColorTemplateV2Query = { __typename?: 'Query', colorTemplate: { __typename: 'ColorTemplateErrorV2', type: ColorTemplateErrorType, error?: string | null } | { __typename: 'ColorTemplateV2', id: string, title: string, createdAt: number, messages: Array<{ __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> }> } };

export type GetDraftsQueryVariables = Exact<{
  page: Scalars['Int'];
}>;


export type GetDraftsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', person: { __typename?: 'Person', draftsCount: number, drafts: Array<{ __typename?: 'DraftMessage', id: string, message: { __typename?: 'Message', id: string, authorFormatted: string, text?: string | null, created: string, formatted?: Array<Array<number>> | null } }> } } | null } | null };

export type GetLiveQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', id: string, person: { __typename?: 'Person', id: string } } | null } | null, tenants: Array<{ __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, friendlyIdentifier: string, pausedUntil?: any | null, title: string, boardStyle: string, devices: Array<{ __typename?: 'Device', id: string }>, history: Array<{ __typename?: 'MessageAppearance', id: string, message?: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, authorFormatted: string, created: string, sendAt?: any | null } | null }> }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, friendlyIdentifier: string, pausedUntil?: any | null, title: string, boardStyle: string, devices: Array<{ __typename?: 'Device', id: string }>, history: Array<{ __typename?: 'MessageAppearance', id: string, message?: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, authorFormatted: string, created: string, sendAt?: any | null } | null }> }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, friendlyIdentifier: string, pausedUntil?: any | null, title: string, boardStyle: string, devices: Array<{ __typename?: 'Device', id: string }>, history: Array<{ __typename?: 'MessageAppearance', id: string, message?: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, authorFormatted: string, created: string, sendAt?: any | null } | null }> }> }> };

export type GetLiveBoardQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLiveBoardQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', id: string, person: { __typename?: 'Person', id: string } } | null } | null, board: { __typename?: 'Board', id: string, friendlyIdentifier: string, pausedUntil?: any | null, title: string, boardStyle: string, devices: Array<{ __typename?: 'Device', id: string }>, history: Array<{ __typename?: 'MessageAppearance', id: string, message?: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, authorFormatted: string, created: string, sendAt?: any | null } | null }> } };

export type BoardPinnedQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardPinnedQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, pinnedMessage?: { __typename?: 'GqlPinnedMessage', pinnedUntil: any, message: { __typename?: 'Message', id: string, text?: string | null, pinnedUntil?: any | null } } | null } };

export type GetBoardRolesQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetBoardRolesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', id: string } | null } | null, board: { __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } } };

export type GetRolesV2QueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetRolesV2Query = { __typename?: 'Query', BoardV2: { __typename?: 'BoardErrorV2' } | { __typename: 'BoardV2', id: string, title: string, listRoles?: { __typename?: 'ListRoles', roles: Array<{ __typename?: 'RoleV2', id: string, permission: Direction, hasPendingInvite?: boolean | null, person: { __typename?: 'PersonV2', id: string, emailAddress: string, firstName?: string | null, lastName?: string | null } }> } | null } };

export type GetMyRoleV2QueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetMyRoleV2Query = { __typename?: 'Query', viewerV2: { __typename?: 'PersonErrorV2' } | { __typename?: 'PersonV2', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string, myRoleForBoard: { __typename?: 'RoleV2', id: string, personId: string, permission: Direction, hasPendingInvite?: boolean | null } } };

export type GetShareQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShareQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', person: { __typename?: 'Person', shares: Array<{ __typename?: 'GqlMessageShareToken', id: string, message: { __typename?: 'Message', id: string, authorFormatted: string, text?: string | null, created: string, formatted?: Array<Array<number>> | null, sendAt?: any | null } }> } } | null } | null };

export type HideHistoryMutationVariables = Exact<{
  input: HideHistoryMessageMutationInput;
}>;


export type HideHistoryMutation = { __typename?: 'Mutation', hideHistoryMessage: { __typename?: 'HideHistoryMessageSuccessful', hidden: boolean } };

export type InviteRoleV2MutationVariables = Exact<{
  input: InviteInputV2;
}>;


export type InviteRoleV2Mutation = { __typename?: 'Mutation', inviteV2: { __typename?: 'RoleErrorV2', type: RoleErrorType, error?: string | null } | { __typename?: 'RoleV2', id: string, permission: Direction, hasPendingInvite?: boolean | null, person: { __typename?: 'PersonV2', id: string, emailAddress: string } } };

export type IgnoreInviteMutationVariables = Exact<{
  personTenantAssociationId: Scalars['String'];
}>;


export type IgnoreInviteMutation = { __typename?: 'Mutation', ignorePersonTenantInvitation: { __typename?: 'IgnoreInvitationForPersonAndTenantSuccessResponse', ignored: boolean } };

export type LeaveBoardV2MutationVariables = Exact<{
  input: LeaveBoardInputV2;
}>;


export type LeaveBoardV2Mutation = { __typename?: 'Mutation', board: { __typename?: 'BoardErrorV2', type: BoardErrorType, error?: string | null } | { __typename?: 'BoardV2', id: string } };

export type ListColorTemplatesV2QueryVariables = Exact<{
  input: ListColorTemplateInputV2;
}>;


export type ListColorTemplatesV2Query = { __typename?: 'Query', listColorTemplates: { __typename?: 'ListColorTemplateV2', colorTemplates: Array<{ __typename?: 'ColorTemplateIndexV2', id: string, title: string, messages: Array<{ __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>> }> }> } };

export type ListMessageSourcesV2QueryVariables = Exact<{
  input: ListMessageSourcesByBoardInputV2;
}>;


export type ListMessageSourcesV2Query = { __typename?: 'Query', listMessageSources: { __typename?: 'ListMessageSourcesV2', nextCursor?: string | null, messageSources: Array<{ __typename?: 'MessageSourceV2', id: string, title: string }> } };

export type GetMarketplaceListingFeatureTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMarketplaceListingFeatureTypeQuery = { __typename?: 'Query', marketplaceListingFeatureType: { __typename?: 'MarketplaceListingFeatureType', id: string, title: string, items: Array<{ __typename?: 'MarketplaceListingFeatureItem', id: string, sortOrder?: number | null, marketplaceListing: { __typename?: 'MarketplaceListing', id: string, title: string, description?: string | null, shortDescription?: string | null, icon: string, free?: boolean | null, supportsFlagship: boolean, installable: { __typename?: 'Installable', id: string, icon?: string | null, installationsAreSingleton?: boolean | null } } }> } };

export type ListMarketplaceListingFeatureTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMarketplaceListingFeatureTypesQuery = { __typename?: 'Query', marketplaceListingFeatureTypes: Array<{ __typename?: 'MarketplaceListingFeatureType', id: string, title: string }> };

export type BoardMessageAppearancesQueryVariables = Exact<{
  boardId: Scalars['String'];
  page: Scalars['Int'];
  sources?: InputMaybe<Scalars['String']>;
}>;


export type BoardMessageAppearancesQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, boardStyle: string, history: Array<{ __typename?: 'MessageAppearance', id: string, appeared: string, message?: { __typename?: 'Message', id: string, text?: string | null, formatted?: Array<Array<number>> | null, created: string, authorFormatted: string, sendAt?: any | null } | null }> } };

export type BoardMessageAppearancesSearchQueryVariables = Exact<{
  boardId: Scalars['String'];
  page: Scalars['Int'];
  term: Scalars['String'];
}>;


export type BoardMessageAppearancesSearchQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, boardStyle: string, history: Array<{ __typename?: 'MessageAppearance', id: string, appeared: string, message?: { __typename?: 'Message', id: string, text?: string | null, formatted?: Array<Array<number>> | null, created: string, authorFormatted: string, sendAt?: any | null } | null }> } };

export type MyBoardsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type MyBoardsV2Query = { __typename?: 'Query', BoardsV2: { __typename?: 'ListBoards', boards: Array<{ __typename?: 'BoardV2', id: string, title: string, boardStyle?: string | null, createdAt: number }> } };

export type MyAdminBoardsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type MyAdminBoardsV2Query = { __typename?: 'Query', BoardsV2: { __typename?: 'ListBoards', boards: Array<{ __typename?: 'BoardV2', id: string, title: string, boardStyle?: string | null, createdAt: number }> } };

export type PaywallQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type PaywallQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, devices: Array<{ __typename?: 'Device', id: string }>, productApplications: Array<{ __typename?: 'ProductApplication', id: string, pricing?: { __typename?: 'ProductPricing', id: string, title?: string | null, product: { __typename?: 'Product', id: string, title: string, isPlus: boolean } } | null }> } };

export type GetViewerRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerRoleQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, superadmin?: { __typename?: 'Superadmin', id: string } | null, account?: { __typename?: 'Account', id: string, emailAddress: string, person: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, tenants: Array<{ __typename?: 'PersonTenant', id: string, name: string }>, tenantAssociations: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string }> } } | null } | null };

export type MessageFavoritesQueryVariables = Exact<{
  page: Scalars['Int'];
}>;


export type MessageFavoritesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', id: string, person: { __typename?: 'Person', id: string, favoritesCount: number, favorites: Array<{ __typename?: 'MessageFavorite', id: string, message: { __typename?: 'Message', id: string, text?: string | null, authorFormatted: string, formatted?: Array<Array<number>> | null, created: string, sendAt?: any | null } }> } } | null } | null };

export type SetMessageFavoriteMutationVariables = Exact<{
  messageId: Scalars['String'];
  favorited: Scalars['Boolean'];
}>;


export type SetMessageFavoriteMutation = { __typename?: 'Mutation', setMessageFavorite: { __typename?: 'SetMessageFavoriteResponse', messageFavorite: { __typename?: 'MessageFavorite', id: string, favorited?: boolean | null, message: { __typename?: 'Message', id: string } } } };

export type ListPicksCategoriesV2QueryVariables = Exact<{
  input: ListPickCategoriesInputV2;
}>;


export type ListPicksCategoriesV2Query = { __typename?: 'Query', listPickCategories: { __typename?: 'ListPickCategoriesV2', nextCursor?: string | null, pickCategories: Array<{ __typename?: 'PickCategoryV2', id: string, title: string }> } };

export type PicksCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PicksCategoriesQuery = { __typename?: 'Query', picksCategories: Array<{ __typename?: 'PickCategory', id: string, title: string }> };

export type PicksQueryVariables = Exact<{
  categoryId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type PicksQuery = { __typename?: 'Query', pickCategory: { __typename?: 'PickCategory', id: string, picksLength: number, picks: Array<{ __typename?: 'Pick', id: string, message: { __typename?: 'Message', id: string, text?: string | null, formatted?: Array<Array<number>> | null } }> } };

export type TodaysPicksQueryVariables = Exact<{ [key: string]: never; }>;


export type TodaysPicksQuery = { __typename?: 'Query', todaysPicks: Array<{ __typename?: 'Pick', id: string, recommendBefore: any, recommendAfter: any, message: { __typename?: 'Message', id: string, text?: string | null, formatted?: Array<Array<number>> | null } }> };

export type PinMessageToBoardV2MutationVariables = Exact<{
  input: CreatePinnedMessageInputV2;
}>;


export type PinMessageToBoardV2Mutation = { __typename?: 'Mutation', pinMessageToBoard: { __typename?: 'PinnedMessageErrorV2', type: PinnedMessageErrorType, error?: string | null } | { __typename?: 'PinnedMessageV2', id: string, boardId: string, message: { __typename?: 'MessageV2', id: string } } };

export type PinMessageMutationVariables = Exact<{
  input: CreateMessage2Input;
}>;


export type PinMessageMutation = { __typename?: 'Mutation', createMessage2: { __typename?: 'CreateMessage2Successful', created: boolean, withinQuietHours: boolean, message?: { __typename?: 'Message', id: string, created: string, text?: string | null } | null, existingPinnedMessage?: { __typename?: 'GqlPinnedMessage', pinnedUntil: any } | null } };

export type ReferralCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralCodeQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', account?: { __typename?: 'Account', person: { __typename?: 'Person', id: string, referralCode: { __typename?: 'ReferralCode', code: string, created: any, discountForNewCustomer: number, id: string, revenueShareForExistingCustomer: number, url: string }, tenants: Array<{ __typename?: 'PersonTenant', boards: Array<{ __typename?: 'Board', id: string, devices: Array<{ __typename?: 'Device', id: string, latestLocationCountryCode?: string | null }> }> }> } } | null } | null };

export type UnFavoriteV2MutationVariables = Exact<{
  input: RemoveFavoriteInputV2;
}>;


export type UnFavoriteV2Mutation = { __typename?: 'Mutation', removeFavorite: { __typename?: 'FavoriteErrorV2', type: FavoriteErrorType, error?: string | null } | { __typename?: 'FavoriteV2', id: string, message: { __typename?: 'MessageV2', id: string, isFavorited: boolean } } };

export type RemoveLikeV2MutationVariables = Exact<{
  input: RemoveLikeInputV2;
}>;


export type RemoveLikeV2Mutation = { __typename?: 'Mutation', removeLike: { __typename: 'LikeErrorV2', type: LikeErrorType, error?: string | null } | { __typename: 'LikeV2', feedItem?: { __typename?: 'FeedItemV2', id: string, isLikedByMe: boolean, likeCount: number } | null, pick?: { __typename?: 'PickV2', id: string, isLikedByMe: boolean, likeCount: number } | null } };

export type RenameBoardMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;


export type RenameBoardMutation = { __typename?: 'Mutation', updateBoard: { __typename?: 'UpdateBoardResponseSuccessful', board: { __typename?: 'Board', id: string, title: string } } };

export type RenameBoardV2MutationVariables = Exact<{
  input: UpdateBoardInputV2;
}>;


export type RenameBoardV2Mutation = { __typename?: 'Mutation', updateBoardV2: { __typename?: 'BoardErrorV2', type: BoardErrorType, error?: string | null } | { __typename?: 'BoardV2', id: string, title: string } };

export type DeleteRoleV2MutationVariables = Exact<{
  input: DeleteRoleInputV2;
}>;


export type DeleteRoleV2Mutation = { __typename?: 'Mutation', deleteRoleV2: { __typename?: 'RoleErrorV2', type: RoleErrorType, error?: string | null } | { __typename?: 'RoleV2', id: string, hasPendingInvite?: boolean | null } };

export type ListSearchMessagesV2QueryVariables = Exact<{
  input: SearchMessageInputV2;
}>;


export type ListSearchMessagesV2Query = { __typename?: 'Query', listSearchMessages: { __typename?: 'ListSearchMessagesUnionV2', nextCursor?: string | null, searchMessages: Array<{ __typename: 'DraftV2', id: string, attribution: string, created: number, sourceId: string, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null, isFavorited: boolean } } | { __typename: 'FavoriteV2', id: string, attribution: string, created: number, sourceId: string, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null, isFavorited: boolean } } | { __typename: 'FeedItemV2', id: string, attribution: string, created: number, likeCount: number, isLikedByMe: boolean, sourceId: string, personId?: string | null, isSharedByMe: boolean, isFlaggedByMe: boolean, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null, isFavorited: boolean } } | { __typename: 'MessageAppearanceV2', id: string, attribution: string, created: number, sourceId: string, personId?: string | null, subscriptionId?: string | null, marketplaceListingId?: string | null, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null, isFavorited: boolean } } | { __typename: 'MessageSetMessageV2', id: string, attribution: string, created: number, messageSetId: string, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, text?: string | null, isFavorited: boolean } } | { __typename: 'PickV2', id: string, date: string, sortOrder: number, public: boolean, attribution: string, created: number, isLikedByMe: boolean, likeCount: number, message: { __typename?: 'MessageV2', id: string, text?: string | null, characters: Array<Array<number>>, isFavorited: boolean }, categories?: Array<{ __typename?: 'PickCategoryV2', id: string, title: string }> | null } | { __typename: 'TemplateMessageV2' }> } };

export type TenantBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantBoardsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> } | { __typename?: 'EmptyTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> } | { __typename?: 'GroupTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> }> };

export type ViewersAdminOwnerBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewersAdminOwnerBoardsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string } | { __typename?: 'EmptyTenant', id: string } | { __typename?: 'GroupTenant', id: string } }> } | { __typename?: 'EmptyTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string } | { __typename?: 'EmptyTenant', id: string } | { __typename?: 'GroupTenant', id: string } }> } | { __typename?: 'GroupTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string } | { __typename?: 'EmptyTenant', id: string } | { __typename?: 'GroupTenant', id: string } }> }> };

export type ShareMessageV2MutationVariables = Exact<{
  input: ShareInputV2;
}>;


export type ShareMessageV2Mutation = { __typename?: 'Mutation', shareMessage: { __typename?: 'ShareErrorV2', type: string, error?: string | null } | { __typename?: 'ShareV2', shareUrl: string, imageUrl: string } };

export type TemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type TemplatesQuery = { __typename?: 'Query', colorTemplateCategories: Array<{ __typename?: 'ColorTemplateCategory', id: string, title: string, colorTemplatesLength: number, colorTemplates: Array<{ __typename?: 'ColorTemplate', id: string, message: { __typename?: 'Message', id: string, text?: string | null, formatted?: Array<Array<number>> | null } }> }> };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'PersonTenant', id: string, name: string } | { __typename?: 'EmptyTenant', id: string, name: string } | { __typename?: 'GroupTenant', id: string, name: string }> };

export type TransferOwnershipMutationVariables = Exact<{
  input: TransferOwnershipMutationInput;
}>;


export type TransferOwnershipMutation = { __typename?: 'Mutation', transferOwnership: { __typename?: 'TransferOwnershipSuccessful', successful: boolean } };

export type TransferOwnershipV2MutationVariables = Exact<{
  toInput: UpdateRoleInputV2;
  fromInput: UpdateRoleInputV2;
}>;


export type TransferOwnershipV2Mutation = { __typename?: 'Mutation', transferOwnershipTo: { __typename?: 'RoleErrorV2', type: RoleErrorType, error?: string | null } | { __typename?: 'RoleV2', id: string, permission: Direction, hasPendingInvite?: boolean | null }, transferOwnershipFrom: { __typename?: 'RoleErrorV2', type: RoleErrorType, error?: string | null } | { __typename?: 'RoleV2', id: string, permission: Direction, hasPendingInvite?: boolean | null } };

export type UnPinMessageFromBoardV2MutationVariables = Exact<{
  input: RemovePinnedMessageInputV2;
}>;


export type UnPinMessageFromBoardV2Mutation = { __typename?: 'Mutation', unpinMessageFromBoard: { __typename?: 'PinnedMessageErrorV2', type: PinnedMessageErrorType, error?: string | null } | { __typename?: 'PinnedMessageV2', id: string, boardId: string, message: { __typename?: 'MessageV2', id: string } } };

export type UpdateBoardV2MutationVariables = Exact<{
  input: UpdateBoardInputV2;
}>;


export type UpdateBoardV2Mutation = { __typename?: 'Mutation', updateBoardV2: { __typename?: 'BoardErrorV2', type: BoardErrorType, error?: string | null } | { __typename?: 'BoardV2', id: string, title: string, timezone?: string | null, quietHours?: { __typename?: 'QuietHoursV2', start?: string | null, end?: string | null } | null } };

export type UpdatePersonV2MutationVariables = Exact<{
  input: UpdatePersonInputV2;
}>;


export type UpdatePersonV2Mutation = { __typename?: 'Mutation', updatePersonV2: { __typename?: 'PersonErrorV2', type: PersonErrorType, error?: string | null } | { __typename?: 'PersonV2', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string } };

export type UpdateRoleV2MutationVariables = Exact<{
  input: UpdateRoleInputV2;
}>;


export type UpdateRoleV2Mutation = { __typename?: 'Mutation', updateRoleV2: { __typename?: 'RoleErrorV2', type: RoleErrorType, error?: string | null } | { __typename?: 'RoleV2', id: string, permission: Direction } };

export type AddSubscriptionQueryVariables = Exact<{
  installationId: Scalars['String'];
  boardId: Scalars['String'];
}>;


export type AddSubscriptionQuery = { __typename?: 'Query', installation: { __typename?: 'Installation', id: string, created: string, installable: { __typename?: 'Installable', id: string, title?: string | null } }, board: { __typename?: 'Board', id: string, title: string, subscriptionSet: { __typename?: 'SubscriptionSet', id: string } } };

export type CreateSubscriptionPageMutationVariables = Exact<{
  boardId: Scalars['String'];
  installationId?: InputMaybe<Scalars['String']>;
  installableId?: InputMaybe<Scalars['String']>;
  marketplaceListing?: InputMaybe<Scalars['String']>;
}>;


export type CreateSubscriptionPageMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionSuccessful', created: boolean } };

export type ApiKeySelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeySelectorQuery = { __typename?: 'Query', apiCredentials: Array<{ __typename?: 'ApiCredential', id: string, key: string }> };

export type DeveloperInstallablesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeveloperInstallablesQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', account?: { __typename?: 'Account', person: { __typename?: 'Person', developer: { __typename?: 'DeveloperPersonAssociation', developer: { __typename?: 'Developer', id: string, installables: Array<{ __typename?: 'Installable', id: string, title?: string | null, installations: Array<{ __typename?: 'Installation', id: string, subscriptions: Array<{ __typename?: 'Subscription', id: string }> }> }> } } } } | null } | null };

export type CreateInstallableMutationVariables = Exact<{
  title: Scalars['String'];
  developerId: Scalars['String'];
}>;


export type CreateInstallableMutation = { __typename?: 'Mutation', createInstallable: { __typename?: 'CreateInstallableSuccessResponse', created: boolean, installable: { __typename?: 'Installable', id: string } } };

export type DeleteInstallableMutationVariables = Exact<{
  input: DeleteInstallableInput;
}>;


export type DeleteInstallableMutation = { __typename?: 'Mutation', deleteInstallable: { __typename?: 'DeleteInstallableSuccessful', deleted: boolean } };

export type DeveloperInstallableQueryVariables = Exact<{
  installableId: Scalars['String'];
}>;


export type DeveloperInstallableQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', account?: { __typename?: 'Account', person: { __typename?: 'Person', tenants: Array<{ __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> }> } } | null } | null, installable: { __typename?: 'Installable', id: string, title?: string | null, createdLong: any, friendlyIdentifier: string, installations: Array<{ __typename?: 'Installation', id: string, tenant: { __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> } | { __typename?: 'EmptyTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> } | { __typename?: 'GroupTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> }, principal: { __typename?: 'BoardPrincipal', id: string } | { __typename?: 'DevicePrincipal', id: string } | { __typename?: 'EmptyPrincipal', id: string } | { __typename?: 'GqlFactoryPrincipal', id: string } | { __typename?: 'GqlSystemPrincipal', id: string } | { __typename?: 'InstallablePrincipal', id: string } | { __typename?: 'InstallationPrincipal', id: string, apiCredentials: Array<{ __typename?: 'ApiCredential', id: string, created: string, key: string }> } | { __typename?: 'MessageSetPrincipal', id: string } | { __typename?: 'PersonPrincipal', id: string } }> } };

export type CreateApiKeyMutationVariables = Exact<{
  boardId: Scalars['String'];
  installableId: Scalars['String'];
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiCredential: { __typename?: 'CreateApiCredentialSuccess', created: boolean, secret: string, apiCredential: { __typename?: 'ApiCredential', id: string, created: string, key: string } } };

export type CreateApiKeyBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateApiKeyBoardsQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', account?: { __typename?: 'Account', person: { __typename?: 'Person', tenants: Array<{ __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> }> } } | null } | null };

export type DeleteApiCredentialMutationVariables = Exact<{
  apiCredentialId: Scalars['String'];
}>;


export type DeleteApiCredentialMutation = { __typename?: 'Mutation', deleteApiCredential: { __typename?: 'DeleteApiCredentialSuccessful', deleted: boolean } };

export type BoardsForTenantQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type BoardsForTenantQuery = { __typename?: 'Query', boards: Array<{ __typename?: 'Board', id: string, title: string, boardStyle: string }> };

export type BoardMessageQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardMessageQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, boardStyle: string, sendLaterMessage?: { __typename?: 'Message', id: string, text?: string | null, sendAt?: any | null } | null } };

export type UnscheduleMessageMutationVariables = Exact<{
  messageId: Scalars['String'];
}>;


export type UnscheduleMessageMutation = { __typename?: 'Mutation', unscheduleMessage: { __typename?: 'UnscheduleMessageResponse', unscheduled: boolean } };

export type CreateMessageFromComposeViewMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  boardId: Scalars['String'];
}>;


export type CreateMessageFromComposeViewMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'CreateMessageSuccessful', created: boolean, message: { __typename?: 'Message', id: string } } };

export type UpdateBoardFromComposeViewMutationVariables = Exact<{
  boardId: Scalars['String'];
  updateTitle?: InputMaybe<UpdateBoardTitleInput>;
}>;


export type UpdateBoardFromComposeViewMutation = { __typename?: 'Mutation', updateBoard: { __typename?: 'UpdateBoardResponseSuccessful', updated: boolean, board: { __typename?: 'Board', id: string } } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessage2Input;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage2: { __typename?: 'CreateMessage2Successful', created: boolean, message?: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, sendAt?: any | null } | null } };

export type SaveDraftMutationVariables = Exact<{
  input: SaveDraftInput;
}>;


export type SaveDraftMutation = { __typename?: 'Mutation', saveDraft: { __typename?: 'SaveDraftResponse', saved: boolean, draftMessage: { __typename?: 'DraftMessage', id: string, message: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null } } } };

export type ConfigureInstallableQueryVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type ConfigureInstallableQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, configurationUrl?: string | null } };

export type CreateBoardFromPageMutationVariables = Exact<{
  input: CreateBoardInput;
}>;


export type CreateBoardFromPageMutation = { __typename?: 'Mutation', createBoard: { __typename?: 'CreateBoardResponseSuccessful', created: boolean, board: { __typename?: 'Board', id: string, boardSet?: { __typename?: 'BoardSet', id: string, title: string, boards: Array<{ __typename?: 'Board', id: string, title: string }> } | null } } };

export type BoardSourcesQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardSourcesQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, subscriptionSet: { __typename?: 'SubscriptionSet', id: string, messageSources: Array<{ __typename?: 'MessageSource', id: string, title: string }> } } };

export type MarketplaceCategroyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MarketplaceCategroyQuery = { __typename?: 'Query', marketplaceListingsCategory: { __typename?: 'InstallableCategory', id: string, title: string } };

export type MarketplaceListingsByCategroyQueryVariables = Exact<{
  categoryTitle: Scalars['String'];
  boardId: Scalars['String'];
  sortBy?: InputMaybe<MarketplaceListingSortBy>;
  sortOrder?: InputMaybe<MarketplaceListingSortOrder>;
}>;


export type MarketplaceListingsByCategroyQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, subscriptionSet: { __typename?: 'SubscriptionSet', channels: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string } | null }> } }, searchMarketPlaceListings: Array<{ __typename?: 'MarketplaceListing', id: string, free?: boolean | null, releaseDate?: any | null, stagingOnly?: boolean | null, icon: string, title: string, description?: string | null, shortDescription?: string | null, installable: { __typename?: 'Installable', id: string, created: string, hideFromInstallablesList?: boolean | null, installationsAreSingleton?: boolean | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } }> };

export type InstallableDetailQueryVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type InstallableDetailQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, title?: string | null, icon?: string | null, muted?: boolean | null, configurationUrl?: string | null, description?: string | null, created: string, requiresConfiguration: boolean, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string, title: string, icon: string, free?: boolean | null } | null, installation?: { __typename?: 'Installation', id: string, installable: { __typename?: 'Installable', id: string, created: string, title?: string | null, description?: string | null, installationsAreSingleton?: boolean | null, subscriptionsCanBeRenamed?: boolean | null, hideFromInstallablesList?: boolean | null, coverPhoto?: string | null, icon?: string | null, published?: boolean | null, public?: boolean | null, confirmedBody?: string | null, confirmedMessage?: string | null, setupCallToActionUrl?: string | null, setupMessage?: string | null, setupBody?: string | null, setupCallToActionLabel?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } } | null } };

export type MarketplaceListingDetailQueryVariables = Exact<{
  id: Scalars['String'];
  tenantId: Scalars['String'];
  boardId: Scalars['String'];
}>;


export type MarketplaceListingDetailQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, subscriptionSet: { __typename?: 'SubscriptionSet', channels: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string, free?: boolean | null } | null }> } }, marketplaceListing: { __typename?: 'MarketplaceListing', id: string, releaseDate?: any | null, version?: string | null, free?: boolean | null, icon: string, title: string, description?: string | null, shortDescription?: string | null, stagingOnly?: boolean | null, carouselMedia1?: string | null, carouselMedia2?: string | null, carouselMedia3?: string | null, installations: Array<{ __typename?: 'Installation', id: string, subscriptions: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null }> }>, language?: { __typename?: 'GqlLanguage', id: string, language: string } | null, category?: { __typename?: 'InstallableCategory', id: string, title: string, marketplaceListings: Array<{ __typename?: 'MarketplaceListing', id: string, free?: boolean | null, title: string, icon: string, shortDescription?: string | null, installable: { __typename?: 'Installable', id: string, installationsAreSingleton?: boolean | null } }> } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null, installable: { __typename?: 'Installable', id: string, created: string, title?: string | null, icon?: string | null, description?: string | null, hideFromInstallablesList?: boolean | null, installationsAreSingleton?: boolean | null }, messageSet?: { __typename?: 'MessageSet', id: string, title?: string | null } | null } };

export type MarketplaceListingSearchQueryVariables = Exact<{
  term: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type MarketplaceListingSearchQuery = { __typename?: 'Query', marketplaceListings: Array<{ __typename?: 'MarketplaceListing', id: string, icon: string, shortDescription?: string | null, title: string, free?: boolean | null, installations: Array<{ __typename?: 'Installation', id: string, subscriptions: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null }> }>, installable: { __typename?: 'Installable', installationsAreSingleton?: boolean | null } }> };

export type CreateSubscriptionMutationVariables = Exact<{
  installationId?: InputMaybe<Scalars['String']>;
  installableId?: InputMaybe<Scalars['String']>;
  boardId: Scalars['String'];
  messageSet?: InputMaybe<Scalars['String']>;
  marketplaceListing?: InputMaybe<Scalars['String']>;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionSuccessful', created: boolean, subscription: { __typename?: 'Subscription', id: string } } };

export type InstallablesAndSubscriptionsQueryVariables = Exact<{
  boardId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type InstallablesAndSubscriptionsQuery = { __typename?: 'Query', installables: Array<{ __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null, description?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null }>, board: { __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', installations: Array<{ __typename?: 'Installation', id: string, created: string, installable: { __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null, description?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } }> } | { __typename?: 'EmptyTenant', installations: Array<{ __typename?: 'Installation', id: string, created: string, installable: { __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null, description?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } }> } | { __typename?: 'GroupTenant', installations: Array<{ __typename?: 'Installation', id: string, created: string, installable: { __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null, description?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } }> }, subscriptionSet: { __typename?: 'SubscriptionSet', subscriptions: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null, configurationUrl?: string | null, configurationToken: string, installation?: { __typename?: 'Installation', id: string, installable: { __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, public?: boolean | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null, description?: string | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null } } | null }> } } };

export type MarketplaceListingsCategoriesQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type MarketplaceListingsCategoriesQuery = { __typename?: 'Query', marketplaceListingsCategories: Array<{ __typename?: 'InstallableCategory', id: string, title: string }>, board: { __typename?: 'Board', id: string, pausedUntil?: any | null, subscriptionSet: { __typename?: 'SubscriptionSet', channels: Array<{ __typename?: 'Subscription', id: string, configurationUrl?: string | null, title?: string | null, icon?: string | null, muted?: boolean | null, description?: string | null, created: string, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string, free?: boolean | null } | null }> } } };

export type UpdateSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  muted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'UpdateSubscriptionSuccessful', subscription: { __typename?: 'Subscription', id: string, muted?: boolean | null, runOfShow: { __typename?: 'RunOfShow', description?: string | null, firstAppearance?: string | null } } } };

export type ExistingMarketplaceListingSubscriptionQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type ExistingMarketplaceListingSubscriptionQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, subscriptionSet: { __typename?: 'SubscriptionSet', channels: Array<{ __typename?: 'Subscription', id: string, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string } | null }> } } };

export type GetDiscoverQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetDiscoverQuery = { __typename?: 'Query', featuredMarketplaceListings: Array<{ __typename?: 'FeaturedMarketplaceItem', image: string, description?: string | null, marketplaceListing: { __typename?: 'MarketplaceListing', id: string, title: string, free?: boolean | null, installable: { __typename?: 'Installable', id: string, installationsAreSingleton?: boolean | null } } }>, featuredMarketplaceChannel?: { __typename?: 'FeaturedMarketplaceItem', image: string, description?: string | null, imageMedia?: { __typename?: 'Media', id: string, cdnUrl: string } | null, imageVariantMedia?: { __typename?: 'Media', id: string, cdnUrl: string } | null, marketplaceListing: { __typename?: 'MarketplaceListing', id: string, title: string, installable: { __typename?: 'Installable', id: string, installationsAreSingleton?: boolean | null } } } | null, board: { __typename?: 'Board', id: string, subscriptionSet: { __typename?: 'SubscriptionSet', channels: Array<{ __typename?: 'Subscription', id: string, muted?: boolean | null, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string } | null }> } } };

export type GetDiscoverMarketPlaceListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscoverMarketPlaceListingsQuery = { __typename?: 'Query', marketplaceListingsCategories: Array<{ __typename?: 'InstallableCategory', id: string, title: string, marketplaceListings: Array<{ __typename?: 'MarketplaceListing', id: string, releaseDate?: any | null, free?: boolean | null, supportsFlagship: boolean, icon: string, title: string, shortDescription?: string | null, description?: string | null, stagingOnly?: boolean | null, installable: { __typename?: 'Installable', id: string, created: string, title?: string | null, icon?: string | null, description?: string | null, hideFromInstallablesList?: boolean | null, installationsAreSingleton?: boolean | null, category?: { __typename?: 'InstallableCategory', id: string, title: string } | null, developer?: { __typename?: 'Developer', id: string, title: string } | null }, messageSet?: { __typename?: 'MessageSet', id: string, title?: string | null } | null }> }> };

export type GetInstalledInstallablesQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetInstalledInstallablesQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, pausedUntil?: any | null, subscriptionSet: { __typename?: 'SubscriptionSet', id: string, channels: Array<{ __typename?: 'Subscription', id: string, configurationUrl?: string | null, title?: string | null, icon?: string | null, muted?: boolean | null, created: string, runOfShow: { __typename?: 'RunOfShow', id: string, description?: string | null, firstAppearance?: string | null }, marketplaceListing?: { __typename?: 'MarketplaceListing', id: string, title: string, icon: string, hiddenFromProduction?: boolean | null, free?: boolean | null, installable: { __typename?: 'Installable', id: string, title?: string | null, icon?: string | null, created: string, public?: boolean | null, installationsAreSingleton?: boolean | null, hideFromInstallablesList?: boolean | null } } | null }> } } };

export type PauseInstallablesMutationVariables = Exact<{
  board: Scalars['String'];
  duration: Scalars['Int'];
}>;


export type PauseInstallablesMutation = { __typename?: 'Mutation', pauseInstallables: { __typename?: 'PauseInstallablesResponse', paused: boolean } };

export type LiveV2QueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LiveV2Query = { __typename?: 'Query', BoardV2: { __typename?: 'BoardErrorV2', error?: string | null, type: BoardErrorType } | { __typename?: 'BoardV2', id: string, title: string, createdAt: number, listMessageAppearances: { __typename?: 'ListMessageAppearancesV2', messageAppearances: Array<{ __typename?: 'MessageAppearanceV2', id: string, attribution: string, message: { __typename?: 'MessageV2', id: string, characters: Array<Array<number>>, isFavorited: boolean } }> }, listFlagshipDevices?: { __typename?: 'ListFlagshipDevices', flagshipDevices: Array<{ __typename?: 'FlagshipDeviceV2', id: string, heartbeat?: { __typename?: 'FlagshipDeviceHeartbeatV2', lastSeen: number } | null }> } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'UpdatePersonSuccessful', person: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null } } };

export type UpdateEmailAddressMutationVariables = Exact<{
  input: UpdateEmailAddressInput;
}>;


export type UpdateEmailAddressMutation = { __typename?: 'Mutation', updateEmailAddress: { __typename?: 'Account', id: string, emailAddress: string } };

export type CreateSimulatorTokenMutationVariables = Exact<{
  input: CreateSimulatorTokenInputV2;
}>;


export type CreateSimulatorTokenMutation = { __typename?: 'Mutation', createSimulatorToken: { __typename?: 'SimulatorTokenErrorV2', type: SimulatorTokenErrorType, error?: string | null } | { __typename?: 'SimulatorTokenV2', id: string, token: string, expiresAt?: number | null, isPublic?: boolean | null, boardId: string, url: string } };

export type DeleteSimulatorTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type DeleteSimulatorTokenMutation = { __typename?: 'Mutation', deleteSimulatorToken: { __typename?: 'SimulatorTokenErrorV2', type: SimulatorTokenErrorType, error?: string | null } | { __typename?: 'SimulatorTokenV2', id: string } };

export type GetPublicSimulatorTokenQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetPublicSimulatorTokenQuery = { __typename?: 'Query', publicSimulatorTokenV2: { __typename?: 'SimulatorTokenErrorV2', type: SimulatorTokenErrorType, error?: string | null } | { __typename?: 'SimulatorTokenV2', id: string, token: string, url: string } };

export type GetTenantBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantBoardsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'PersonTenant', id: string, boards: Array<{ __typename?: 'Board', id: string }> } | { __typename?: 'EmptyTenant', id: string, boards: Array<{ __typename?: 'Board', id: string }> } | { __typename?: 'GroupTenant', id: string, boards: Array<{ __typename?: 'Board', id: string }> }> };

export type FetchAllBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllBoardsQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, title: string, friendlyIdentifier: string, devices: Array<{ __typename?: 'Device', id: string }>, productApplications: Array<{ __typename?: 'ProductApplication', id: string }> }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, title: string, friendlyIdentifier: string, devices: Array<{ __typename?: 'Device', id: string }>, productApplications: Array<{ __typename?: 'ProductApplication', id: string }> }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string, title: string, friendlyIdentifier: string, devices: Array<{ __typename?: 'Device', id: string }>, productApplications: Array<{ __typename?: 'ProductApplication', id: string }> }> }> };

export type BoardPurchasesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BoardPurchasesQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, productApplications: Array<{ __typename?: 'ProductApplication', id: string, nextBillingDate?: any | null, ends?: any | null, optOutOfAutoRenewal: boolean, created: any, activationCode?: { __typename?: 'ActivationCode', id: string, code: string } | null, pricing?: { __typename?: 'ProductPricing', id: string, title?: string | null } | null, purchaseLineItem?: { __typename?: 'PlusPurchaseSessionPurchaseLineItem', id: string, purchase?: { __typename?: 'PlusPurchaseSessionPurchase', id: string, emailAddress: string, purchaseSession?: { __typename?: 'PlusPurchaseSession', id: string, paymentMethod?: { __typename?: 'ShopifyPaymentMethod', id?: string | null, company?: string | null, number?: string | null } | null } | null } | null } | null }> } };

export type UpdatePaymentMethodMutationVariables = Exact<{
  productApplicationId: Scalars['String'];
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updateShopifyPaymentMethod: { __typename?: 'ShopifyUpdatePaymentMethodResult', success: boolean } };

export type OptOutOfRenewalMutationVariables = Exact<{
  productApplicationId: Scalars['String'];
  reason: Scalars['String'];
}>;


export type OptOutOfRenewalMutation = { __typename?: 'Mutation', optOutOfRenewal: { __typename?: 'ProductApplication', id: string, optOutOfAutoRenewal: boolean, optOutReason?: string | null, optOutDate?: any | null } };

export type UpsertSingletonChannelForListingMutationVariables = Exact<{
  listing: Scalars['String'];
  board: Scalars['String'];
  data?: InputMaybe<Scalars['String']>;
}>;


export type UpsertSingletonChannelForListingMutation = { __typename?: 'Mutation', upsertSingletonChannelForListing: { __typename?: 'UpsertSingletonChannelForListingResponse', channel: { __typename?: 'Subscription', id: string, configurationToken: string } } };

export type GetQuietHoursQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type GetQuietHoursQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, quietHoursBegin?: string | null, quietHoursEnd?: string | null } };

export type UpdateQuietHoursMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;


export type UpdateQuietHoursMutation = { __typename?: 'Mutation', updateBoard: { __typename?: 'UpdateBoardResponseSuccessful', board: { __typename?: 'Board', id: string, quietHoursBegin?: string | null, quietHoursEnd?: string | null } } };

export type BoardTimezoneQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardTimezoneQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, timezone?: { __typename?: 'TimezoneCity', id: string, timezoneCity: string, created: any } | null }, countries: Array<{ __typename?: 'Country', country: string, id: string, timezones: Array<{ __typename?: 'TimezoneCity', id: string, timezoneCity: string }> }> };

export type UpdateBoardTimezoneMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;


export type UpdateBoardTimezoneMutation = { __typename?: 'Mutation', updateBoard: { __typename?: 'UpdateBoardResponseSuccessful', board: { __typename?: 'Board', id: string, timezone?: { __typename?: 'TimezoneCity', id: string, timezoneCity: string, created: any } | null } } };

export type CreateInvitationMutationVariables = Exact<{
  input: AddPersonToExistingBoardsInput;
}>;


export type CreateInvitationMutation = { __typename?: 'Mutation', createPersonBoardInvitations: { __typename?: 'AddPersonToExistingTenantSuccessful', exists: boolean, added: boolean } };

export type RevokeUserInvitationMutationVariables = Exact<{
  input: RevokeInvitationForPersonAndTenantInput;
}>;


export type RevokeUserInvitationMutation = { __typename?: 'Mutation', revokePersonTenantInvitation: { __typename?: 'RevokeInvitationForPersonAndTenantSuccessResponse', revoked: boolean } };

export type BoardMembersQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardMembersQuery = { __typename?: 'Query', viewer?: { __typename?: 'Viewer', id?: string | null, account?: { __typename?: 'Account', id: string } | null } | null, board: { __typename?: 'Board', id: string, title: string, tenant: { __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, isCurrentMember: boolean, invitationStatus: string, person: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, isCurrentMember: boolean, invitationStatus: string, person: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, isCurrentMember: boolean, invitationStatus: string, person: { __typename?: 'Person', id: string, firstName?: string | null, lastName?: string | null, account: { __typename?: 'Account', id: string, emailAddress: string } } }> } } };

export type UpdatePersonTenantAssociationMutationVariables = Exact<{
  input: UpdatePersonTenantAssociationInput;
}>;


export type UpdatePersonTenantAssociationMutation = { __typename?: 'Mutation', updatePersonTenantAssociationMutation: { __typename?: 'PersonTenantAssociation', id: string, role: string } };

export type BoardSettingsModulesQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardSettingsModulesQuery = { __typename?: 'Query', board: { __typename?: 'Board', settings: Array<{ __typename: 'BoardSetting', key?: string | null, title: string, link: string, location?: string | null }> } };

export type FetchSettingsQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type FetchSettingsQuery = { __typename?: 'Query', board: { __typename?: 'Board', id: string, title: string, friendlyIdentifier: string, devices: Array<{ __typename?: 'Device', id: string }>, tenant: { __typename?: 'PersonTenant', members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string } }> } | { __typename?: 'EmptyTenant', members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string } }> } | { __typename?: 'GroupTenant', members: Array<{ __typename?: 'PersonTenantAssociation', id: string, role: string, person: { __typename?: 'Person', id: string } }> } }, tenants: Array<{ __typename?: 'PersonTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string }> } | { __typename?: 'EmptyTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string }> } | { __typename?: 'GroupTenant', id: string, members: Array<{ __typename?: 'PersonTenantAssociation', id: string, isCurrentMember: boolean, role: string, person: { __typename?: 'Person', id: string } }>, boards: Array<{ __typename?: 'Board', id: string }> }> };

export type MessageShareTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type MessageShareTokenQuery = { __typename?: 'Query', messageShareToken: { __typename?: 'GqlMessageShareToken', id: string, message: { __typename?: 'Message', id: string, formatted?: Array<Array<number>> | null, text?: string | null } } };


export const SingleBoardsSelectorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleBoardsSelectorQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<SingleBoardsSelectorQuery, SingleBoardsSelectorQueryVariables>;
export const ApplyProductMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyProductMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"board"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyRedemptionCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"board"},"value":{"kind":"Variable","name":{"kind":"Name","value":"board"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplyProductMutation, ApplyProductMutationVariables>;
export const ProductPricingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPricingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productPricings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chargeFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priceInCents"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerMonthInCents"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPriceInCents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cartLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductPricingQuery, ProductPricingQueryVariables>;
export const ValidateActivationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateActivationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activationCodeQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ValidateActivationCodeQuery, ValidateActivationCodeQueryVariables>;
export const ResendMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"characters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forced"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forcePinnedMessageOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"characters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"characters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"forced"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forced"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"forcePinnedMessageOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forcePinnedMessageOverride"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ResendMessageMutation, ResendMessageMutationVariables>;
export const GetMessageSetCreatorSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessageSetCreatorSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installableId"},"value":{"kind":"StringValue","value":"2c04580e-e5be-4661-b232-7ea1c9e90c44","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMessageSetCreatorSubscriptionsQuery, GetMessageSetCreatorSubscriptionsQueryVariables>;
export const AddMessageSetCreatorMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMessageSetCreatorMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddMessageSetCreatorMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMessageSetCreatorMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AddMessageSetCreatorMessageMutation, AddMessageSetCreatorMessageMutationVariables>;
export const AcceptInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personTenantAssociationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptPersonTenantInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personTenantAssociationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personTenantAssociationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]} as unknown as DocumentNode<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const GetBoardRoles2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoardRoles2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"invitationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoardRoles2Query, GetBoardRoles2QueryVariables>;
export const AddMessageSetToBlendedMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMessageSetToBlendedMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddMessageSetToBlendedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMessageSetToBlended"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageSetIds"}}]}}]}}]} as unknown as DocumentNode<AddMessageSetToBlendedMutation, AddMessageSetToBlendedMutationVariables>;
export const RemoveMessageSetFromBlendedMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMessageSetFromBlendedMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveMessageSetFromBlendedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMessageSetFromBlended"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageSetIds"}}]}}]}}]} as unknown as DocumentNode<RemoveMessageSetFromBlendedMutation, RemoveMessageSetFromBlendedMutationVariables>;
export const BlendedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BlendedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blended"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageSetIds"}}]}}]}}]}}]} as unknown as DocumentNode<BlendedQuery, BlendedQueryVariables>;
export const BoardQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"installation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardQuery, BoardQueryVariables>;
export const BoardsSelectorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardsSelectorQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}}]}}]}}]} as unknown as DocumentNode<BoardsSelectorQuery, BoardsSelectorQueryVariables>;
export const BroadcastMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BroadcastMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BroadcastMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]} as unknown as DocumentNode<BroadcastMessageMutation, BroadcastMessageMutationVariables>;
export const CreateBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBoardV2Mutation, CreateBoardV2MutationVariables>;
export const CreateDraftV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDraftV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDraftInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createDraft"},"name":{"kind":"Name","value":"createDraftV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DraftV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DraftErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDraftV2Mutation, CreateDraftV2MutationVariables>;
export const FavoriteV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FavoriteV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFavoriteInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createFavorite"},"name":{"kind":"Name","value":"createFavoriteV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<FavoriteV2Mutation, FavoriteV2MutationVariables>;
export const CreateFeedItemV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeedItemV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeedItemInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createFeedItem"},"name":{"kind":"Name","value":"createFeedItemV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItemV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}},{"kind":"Field","name":{"kind":"Name","value":"moderated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItemErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFeedItemV2Mutation, CreateFeedItemV2MutationVariables>;
export const CreateLikeV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLikeV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLikeInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createLike"},"name":{"kind":"Name","value":"createLikeV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LikeV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"feedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pick"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LikeErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateLikeV2Mutation, CreateLikeV2MutationVariables>;
export const CreateBoardMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBoardMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"characters"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"characters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"characters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBoardMessageMutation, CreateBoardMessageMutationVariables>;
export const CreateMessageAppearanceV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessageAppearanceV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessageAppearanceInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createMessageAppearance"},"name":{"kind":"Name","value":"createMessageAppearanceV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageAppearanceV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"boardId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageAppearanceErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageAppearanceV2Mutation, CreateMessageAppearanceV2MutationVariables>;
export const CreateMessageV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createMessage"},"name":{"kind":"Name","value":"createMessageV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageV2Mutation, CreateMessageV2MutationVariables>;
export const CreateScheduledMessageV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScheduledMessageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateScheduledMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createScheduledMessage"},"name":{"kind":"Name","value":"createScheduledMessageV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScheduledMessageV2Mutation, CreateScheduledMessageV2MutationVariables>;
export const CreateMessageShareTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessageShareToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessageShareTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessageShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rawToken"}},{"kind":"Field","name":{"kind":"Name","value":"messageShareToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageShareTokenMutation, CreateMessageShareTokenMutationVariables>;
export const DeleteBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteBoardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteBoardMutation, DeleteBoardMutationVariables>;
export const DeleteBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteBoardV2Mutation, DeleteBoardV2MutationVariables>;
export const DeleteDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteDraftMutation, DeleteDraftMutationVariables>;
export const DeleteDraftV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDraftV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveDraftInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"removeDraft"},"name":{"kind":"Name","value":"removeDraftV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DraftV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DraftErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteDraftV2Mutation, DeleteDraftV2MutationVariables>;
export const DeleteFeedItemV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeedItemV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFeedItemInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteFeedItem"},"name":{"kind":"Name","value":"deleteFeedItemV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItemV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItemErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFeedItemV2Mutation, DeleteFeedItemV2MutationVariables>;
export const DeleteMessageAppearanceV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMessageAppearanceV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMessageAppearanceInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteMessageAppearance"},"name":{"kind":"Name","value":"deleteMessageAppearanceV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageAppearanceV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageAppearanceErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteMessageAppearanceV2Mutation, DeleteMessageAppearanceV2MutationVariables>;
export const DeleteScheduledMessageV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScheduledMessageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteScheduledMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteScheduledMessage"},"name":{"kind":"Name","value":"deleteScheduledMessageV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageV2Mutation, DeleteScheduledMessageV2MutationVariables>;
export const DeleteSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const GetDiscoverCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscoverCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetDiscoverCategoriesQuery, GetDiscoverCategoriesQueryVariables>;
export const FlagFeedItemV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FlagFeedItemV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlaggedFeedItemInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flagFeedItem"},"name":{"kind":"Name","value":"flagFeedItemV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FlaggedFeedItemV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFlaggedByMe"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FlaggedFeedItemErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<FlagFeedItemV2Mutation, FlagFeedItemV2MutationVariables>;
export const BoardStyleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardStyleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<BoardStyleQuery, BoardStyleQueryVariables>;
export const GetBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"quietHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isQuietHours"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"listFlagshipDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagshipDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoardV2Query, GetBoardV2QueryVariables>;
export const GetBoardQuietHoursV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoardQuietHoursV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"quietHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isQuietHours"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}}]}}]}}]}}]} as unknown as DocumentNode<GetBoardQuietHoursV2Query, GetBoardQuietHoursV2QueryVariables>;
export const GetColorTemplateV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetColorTemplateV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"colorTemplate"},"name":{"kind":"Name","value":"colorTemplateV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ColorTemplateV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ColorTemplateErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<GetColorTemplateV2Query, GetColorTemplateV2QueryVariables>;
export const GetDraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftsCount"}},{"kind":"Field","name":{"kind":"Name","value":"drafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDraftsQuery, GetDraftsQueryVariables>;
export const GetLiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentMember"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"pausedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLiveQuery, GetLiveQueryVariables>;
export const GetLiveBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLiveBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"pausedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLiveBoardQuery, GetLiveBoardQueryVariables>;
export const BoardPinnedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardPinnedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pinnedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedUntil"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardPinnedQuery, BoardPinnedQueryVariables>;
export const GetBoardRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoardRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoardRolesQuery, GetBoardRolesQueryVariables>;
export const GetRolesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRolesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<GetRolesV2Query, GetRolesV2QueryVariables>;
export const GetMyRoleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyRoleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"myRoleForBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMyRoleV2Query, GetMyRoleV2QueryVariables>;
export const GetShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShareQuery, GetShareQueryVariables>;
export const HideHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HideHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HideHistoryMessageMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideHistoryMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}}]}}]} as unknown as DocumentNode<HideHistoryMutation, HideHistoryMutationVariables>;
export const InviteRoleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteRoleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<InviteRoleV2Mutation, InviteRoleV2MutationVariables>;
export const IgnoreInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IgnoreInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personTenantAssociationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ignorePersonTenantInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personTenantAssociationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personTenantAssociationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ignored"}}]}}]}}]} as unknown as DocumentNode<IgnoreInviteMutation, IgnoreInviteMutationVariables>;
export const LeaveBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeaveBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"board"},"name":{"kind":"Name","value":"leaveBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveBoardV2Mutation, LeaveBoardV2MutationVariables>;
export const ListColorTemplatesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListColorTemplatesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListColorTemplateInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listColorTemplates"},"name":{"kind":"Name","value":"listColorTemplatesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListColorTemplatesV2Query, ListColorTemplatesV2QueryVariables>;
export const ListMessageSourcesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListMessageSourcesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMessageSourcesByBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listMessageSources"},"name":{"kind":"Name","value":"listMessageSourcesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}}]}}]}}]} as unknown as DocumentNode<ListMessageSourcesV2Query, ListMessageSourcesV2QueryVariables>;
export const GetMarketplaceListingFeatureTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketplaceListingFeatureType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingFeatureType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFlagship"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMarketplaceListingFeatureTypeQuery, GetMarketplaceListingFeatureTypeQueryVariables>;
export const ListMarketplaceListingFeatureTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListMarketplaceListingFeatureTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingFeatureTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDynamic"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ListMarketplaceListingFeatureTypesQuery, ListMarketplaceListingFeatureTypesQueryVariables>;
export const BoardMessageAppearancesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardMessageAppearancesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sources"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"30"}},{"kind":"Argument","name":{"kind":"Name","value":"sources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sources"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appeared"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardMessageAppearancesQuery, BoardMessageAppearancesQueryVariables>;
export const BoardMessageAppearancesSearchQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardMessageAppearancesSearchQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"term"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"term"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appeared"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardMessageAppearancesSearchQuery, BoardMessageAppearancesSearchQueryVariables>;
export const MyBoardsV2QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyBoardsV2Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardsV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<MyBoardsV2Query, MyBoardsV2QueryVariables>;
export const MyAdminBoardsV2QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAdminBoardsV2Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permissionFilter"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"Admin","block":false},{"kind":"StringValue","value":"Owner","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<MyAdminBoardsV2Query, MyAdminBoardsV2QueryVariables>;
export const PaywallQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaywallQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isPlus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaywallQuery, PaywallQueryVariables>;
export const GetViewerRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewerRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"superadmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantAssociations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetViewerRoleQuery, GetViewerRoleQueryVariables>;
export const MessageFavoritesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageFavoritesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favoritesCount"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"authorFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MessageFavoritesQuery, MessageFavoritesQueryVariables>;
export const SetMessageFavoriteMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMessageFavoriteMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favorited"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMessageFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"favorited"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favorited"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageFavorite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favorited"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetMessageFavoriteMutation, SetMessageFavoriteMutationVariables>;
export const ListPicksCategoriesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListPicksCategoriesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPickCategoriesInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listPickCategories"},"name":{"kind":"Name","value":"listPickCategoriesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}}]}}]}}]} as unknown as DocumentNode<ListPicksCategoriesV2Query, ListPicksCategoriesV2QueryVariables>;
export const PicksCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PicksCategoriesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picksCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<PicksCategoriesQuery, PicksCategoriesQueryVariables>;
export const PicksQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PicksQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picksLength"}},{"kind":"Field","name":{"kind":"Name","value":"picks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PicksQuery, PicksQueryVariables>;
export const TodaysPicksQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TodaysPicksQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"todaysPicks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recommendBefore"}},{"kind":"Field","name":{"kind":"Name","value":"recommendAfter"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]} as unknown as DocumentNode<TodaysPicksQuery, TodaysPicksQueryVariables>;
export const PinMessageToBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PinMessageToBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePinnedMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pinMessageToBoard"},"name":{"kind":"Name","value":"pinMessageToBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinnedMessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinnedMessageErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<PinMessageToBoardV2Mutation, PinMessageToBoardV2MutationVariables>;
export const PinMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PinMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessage2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"withinQuietHours"}},{"kind":"Field","name":{"kind":"Name","value":"existingPinnedMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pinnedUntil"}}]}}]}}]}}]} as unknown as DocumentNode<PinMessageMutation, PinMessageMutationVariables>;
export const ReferralCodeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"referralCodeQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referralCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"discountForNewCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revenueShareForExistingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latestLocationCountryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReferralCodeQuery, ReferralCodeQueryVariables>;
export const UnFavoriteV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnFavoriteV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveFavoriteInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"removeFavorite"},"name":{"kind":"Name","value":"removeFavoriteV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<UnFavoriteV2Mutation, UnFavoriteV2MutationVariables>;
export const RemoveLikeV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveLikeV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveLikeInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"removeLike"},"name":{"kind":"Name","value":"removeLikeV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LikeV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pick"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LikeErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveLikeV2Mutation, RemoveLikeV2MutationVariables>;
export const RenameBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<RenameBoardMutation, RenameBoardMutationVariables>;
export const RenameBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<RenameBoardV2Mutation, RenameBoardV2MutationVariables>;
export const DeleteRoleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRoleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRoleInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRoleV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoleV2Mutation, DeleteRoleV2MutationVariables>;
export const ListSearchMessagesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSearchMessagesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listSearchMessages"},"name":{"kind":"Name","value":"listSearchMessagesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageSetMessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"messageSetId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PickV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedItemV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"likeCount"}},{"kind":"Field","name":{"kind":"Name","value":"isLikedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"isSharedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"isFlaggedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DraftV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MessageAppearanceV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"personId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}}]}}]}}]} as unknown as DocumentNode<ListSearchMessagesV2Query, ListSearchMessagesV2QueryVariables>;
export const TenantBoardsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantBoardsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<TenantBoardsQuery, TenantBoardsQueryVariables>;
export const ViewersAdminOwnerBoardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewersAdminOwnerBoards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roles"},"value":{"kind":"StringValue","value":"Owner,Admin","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewersAdminOwnerBoardsQuery, ViewersAdminOwnerBoardsQueryVariables>;
export const ShareMessageV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareMessageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shareMessage"},"name":{"kind":"Name","value":"shareMessageV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShareV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShareErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<ShareMessageV2Mutation, ShareMessageV2MutationVariables>;
export const TemplatesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplatesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorTemplateCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colorTemplatesLength"}},{"kind":"Field","name":{"kind":"Name","value":"colorTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TemplatesQuery, TemplatesQueryVariables>;
export const TenantQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TenantQuery, TenantQueryVariables>;
export const TransferOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferOwnershipMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}}]}}]}}]} as unknown as DocumentNode<TransferOwnershipMutation, TransferOwnershipMutationVariables>;
export const TransferOwnershipV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferOwnershipV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInputV2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"transferOwnershipTo"},"name":{"kind":"Name","value":"updateRoleV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transferOwnershipFrom"},"name":{"kind":"Name","value":"updateRoleV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingInvite"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<TransferOwnershipV2Mutation, TransferOwnershipV2MutationVariables>;
export const UnPinMessageFromBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnPinMessageFromBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovePinnedMessageInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unpinMessageFromBoard"},"name":{"kind":"Name","value":"unpinMessageFromBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinnedMessageV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardId"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PinnedMessageErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<UnPinMessageFromBoardV2Mutation, UnPinMessageFromBoardV2MutationVariables>;
export const UpdateBoardV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBoardV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"quietHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBoardV2Mutation, UpdateBoardV2MutationVariables>;
export const UpdatePersonV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePersonV2Mutation, UpdatePersonV2MutationVariables>;
export const UpdateRoleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRoleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRoleInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoleV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoleV2Mutation, UpdateRoleV2MutationVariables>;
export const AddSubscriptionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddSubscriptionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AddSubscriptionQuery, AddSubscriptionQueryVariables>;
export const CreateSubscriptionPageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubscriptionPageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketplaceListing"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"installableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"marketplaceListingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketplaceListing"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<CreateSubscriptionPageMutation, CreateSubscriptionPageMutationVariables>;
export const ApiKeySelectorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiKeySelectorQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode<ApiKeySelectorQuery, ApiKeySelectorQueryVariables>;
export const DeveloperInstallablesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeveloperInstallablesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"installations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"me"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeveloperInstallablesQuery, DeveloperInstallablesQueryVariables>;
export const CreateInstallableMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInstallableMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInstallable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"developerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateInstallableMutation, CreateInstallableMutationVariables>;
export const DeleteInstallableMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInstallableMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteInstallableInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInstallable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteInstallableMutation, DeleteInstallableMutationVariables>;
export const DeveloperInstallableQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeveloperInstallableQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdLong"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"installations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"me"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"principal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationPrincipal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeveloperInstallableQuery, DeveloperInstallableQueryVariables>;
export const CreateApiKeyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiKeyMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createApiCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"installableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateApiKeyBoardsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateApiKeyBoardsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyBoardsQuery, CreateApiKeyBoardsQueryVariables>;
export const DeleteApiCredentialMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteApiCredentialMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiCredentialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteApiCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiCredentialId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteApiCredentialMutation, DeleteApiCredentialMutationVariables>;
export const BoardsForTenantQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardsForTenantQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}}]}}]}}]} as unknown as DocumentNode<BoardsForTenantQuery, BoardsForTenantQueryVariables>;
export const BoardMessageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardMessageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardStyle"}},{"kind":"Field","name":{"kind":"Name","value":"sendLaterMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]} as unknown as DocumentNode<BoardMessageQuery, BoardMessageQueryVariables>;
export const UnscheduleMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnscheduleMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unscheduleMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unscheduled"}}]}}]}}]} as unknown as DocumentNode<UnscheduleMessageMutation, UnscheduleMessageMutationVariables>;
export const CreateMessageFromComposeViewMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessageFromComposeViewMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageFromComposeViewMutation, CreateMessageFromComposeViewMutationVariables>;
export const UpdateBoardFromComposeViewMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBoardFromComposeViewMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardTitleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTitle"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBoardFromComposeViewMutation, UpdateBoardFromComposeViewMutationVariables>;
export const CreateMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessage2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"sendAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageMutation, CreateMessageMutationVariables>;
export const SaveDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saved"}},{"kind":"Field","name":{"kind":"Name","value":"draftMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveDraftMutation, SaveDraftMutationVariables>;
export const ConfigureInstallableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigureInstallable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configurationUrl"}}]}}]}}]} as unknown as DocumentNode<ConfigureInstallableQuery, ConfigureInstallableQueryVariables>;
export const CreateBoardFromPageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBoardFromPageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBoardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boardSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateBoardFromPageMutation, CreateBoardFromPageMutationVariables>;
export const BoardSourcesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardSourcesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardSourcesQuery, BoardSourcesQueryVariables>;
export const MarketplaceCategroyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketplaceCategroyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingsCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MarketplaceCategroyQuery, MarketplaceCategroyQueryVariables>;
export const MarketplaceListingsByCategroyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketplaceListingsByCategroyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceListingSortBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceListingSortOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchMarketPlaceListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categories"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"categoryTitle"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFlagship"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stagingOnly"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}}]}}]}}]} as unknown as DocumentNode<MarketplaceListingsByCategroyQuery, MarketplaceListingsByCategroyQueryVariables>;
export const InstallableDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstallableDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"configurationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"requiresConfiguration"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"free"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCanBeRenamed"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedBody"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"setupCallToActionUrl"}},{"kind":"Field","name":{"kind":"Name","value":"setupMessage"}},{"kind":"Field","name":{"kind":"Name","value":"setupBody"}},{"kind":"Field","name":{"kind":"Name","value":"setupCallToActionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InstallableDetailQuery, InstallableDetailQueryVariables>;
export const MarketplaceListingDetailQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketplaceListingDetailQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"free"}}]}},{"kind":"Field","name":{"kind":"Name","value":"muted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"installations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"messageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"stagingOnly"}},{"kind":"Field","name":{"kind":"Name","value":"carouselMedia1"}},{"kind":"Field","name":{"kind":"Name","value":"carouselMedia2"}},{"kind":"Field","name":{"kind":"Name","value":"carouselMedia3"}}]}}]}}]} as unknown as DocumentNode<MarketplaceListingDetailQuery, MarketplaceListingDetailQueryVariables>;
export const MarketplaceListingSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketplaceListingSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"term"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"marketplaceListings"},"name":{"kind":"Name","value":"searchMarketPlaceListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"terms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"term"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFlagship"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"installations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}}]}}]}}]} as unknown as DocumentNode<MarketplaceListingSearchQuery, MarketplaceListingSearchQueryVariables>;
export const CreateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageSet"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketplaceListing"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"installableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installableId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"messageSetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageSet"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"marketplaceListingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketplaceListing"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const InstallablesAndSubscriptionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstallablesAndSubscriptionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"configurationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"configurationToken"}},{"kind":"Field","name":{"kind":"Name","value":"installation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InstallablesAndSubscriptionsQuery, InstallablesAndSubscriptionsQueryVariables>;
export const MarketplaceListingsCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketplaceListingsCategoriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pausedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configurationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"free"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MarketplaceListingsCategoriesQuery, MarketplaceListingsCategoriesQueryVariables>;
export const UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"muted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"muted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"muted"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"runOfShow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firstAppearance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const ExistingMarketplaceListingSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExistingMarketplaceListingSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExistingMarketplaceListingSubscriptionQuery, ExistingMarketplaceListingSubscriptionQueryVariables>;
export const GetDiscoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredMarketplaceListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredMarketplaceChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageVariantMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"muted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDiscoverQuery, GetDiscoverQueryVariables>;
export const GetDiscoverMarketPlaceListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscoverMarketPlaceListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceListingsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFlagship"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"messageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stagingOnly"}}]}}]}}]}}]} as unknown as DocumentNode<GetDiscoverMarketPlaceListingsQuery, GetDiscoverMarketPlaceListingsQueryVariables>;
export const GetInstalledInstallablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInstalledInstallables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pausedUntil"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"runOfShow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firstAppearance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenFromProduction"}},{"kind":"Field","name":{"kind":"Name","value":"free"}},{"kind":"Field","name":{"kind":"Name","value":"installable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"installationsAreSingleton"}},{"kind":"Field","name":{"kind":"Name","value":"hideFromInstallablesList"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInstalledInstallablesQuery, GetInstalledInstallablesQueryVariables>;
export const PauseInstallablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PauseInstallables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"board"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseInstallables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"board"},"value":{"kind":"Variable","name":{"kind":"Name","value":"board"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}}]}}]} as unknown as DocumentNode<PauseInstallablesMutation, PauseInstallablesMutationVariables>;
export const LiveV2QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveV2Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"BoardV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"listMessageAppearances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageAppearances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorited"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listFlagshipDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagshipDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heartbeat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<LiveV2Query, LiveV2QueryVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateEmailAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmailAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmailAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmailAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]} as unknown as DocumentNode<UpdateEmailAddressMutation, UpdateEmailAddressMutationVariables>;
export const CreateSimulatorTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSimulatorToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSimulatorTokenInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"createSimulatorToken"},"name":{"kind":"Name","value":"createSimulatorTokenV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"boardId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSimulatorTokenMutation, CreateSimulatorTokenMutationVariables>;
export const DeleteSimulatorTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSimulatorToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteSimulatorToken"},"name":{"kind":"Name","value":"deleteSimulatorTokenV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSimulatorTokenMutation, DeleteSimulatorTokenMutationVariables>;
export const GetPublicSimulatorTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicSimulatorToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicSimulatorTokenV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"boardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimulatorTokenErrorV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<GetPublicSimulatorTokenQuery, GetPublicSimulatorTokenQueryVariables>;
export const GetTenantBoardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantBoards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantBoardsQuery, GetTenantBoardsQueryVariables>;
export const FetchAllBoardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchAllBoards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentMember"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAllBoardsQuery, FetchAllBoardsQueryVariables>;
export const BoardPurchasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardPurchases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productApplications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"ends"}},{"kind":"Field","name":{"kind":"Name","value":"optOutOfAutoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"activationCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardPurchasesQuery, BoardPurchasesQueryVariables>;
export const UpdatePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productApplicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShopifyPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productApplicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productApplicationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const OptOutOfRenewalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OptOutOfRenewal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productApplicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optOutOfRenewal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productApplicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productApplicationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optOutOfAutoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"optOutReason"}},{"kind":"Field","name":{"kind":"Name","value":"optOutDate"}}]}}]}}]} as unknown as DocumentNode<OptOutOfRenewalMutation, OptOutOfRenewalMutationVariables>;
export const UpsertSingletonChannelForListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSingletonChannelForListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"board"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertSingletonChannelForListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"board"},"value":{"kind":"Variable","name":{"kind":"Name","value":"board"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configurationToken"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertSingletonChannelForListingMutation, UpsertSingletonChannelForListingMutationVariables>;
export const GetQuietHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQuietHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quietHoursBegin"}},{"kind":"Field","name":{"kind":"Name","value":"quietHoursEnd"}}]}}]}}]} as unknown as DocumentNode<GetQuietHoursQuery, GetQuietHoursQueryVariables>;
export const UpdateQuietHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuietHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quietHoursBegin"}},{"kind":"Field","name":{"kind":"Name","value":"quietHoursEnd"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateQuietHoursMutation, UpdateQuietHoursMutationVariables>;
export const BoardTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneCity"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneCity"}}]}}]}}]}}]} as unknown as DocumentNode<BoardTimezoneQuery, BoardTimezoneQueryVariables>;
export const UpdateBoardTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBoardTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBoardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBoard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneCity"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBoardTimezoneMutation, UpdateBoardTimezoneMutationVariables>;
export const CreateInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPersonToExistingBoardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPersonBoardInvitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exists"}},{"kind":"Field","name":{"kind":"Name","value":"added"}}]}}]}}]} as unknown as DocumentNode<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const RevokeUserInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeUserInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeInvitationForPersonAndTenantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokePersonTenantInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revoked"}}]}}]}}]} as unknown as DocumentNode<RevokeUserInvitationMutation, RevokeUserInvitationMutationVariables>;
export const BoardMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentMember"}},{"kind":"Field","name":{"kind":"Name","value":"invitationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BoardMembersQuery, BoardMembersQueryVariables>;
export const UpdatePersonTenantAssociationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonTenantAssociationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonTenantAssociationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonTenantAssociationMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<UpdatePersonTenantAssociationMutation, UpdatePersonTenantAssociationMutationVariables>;
export const BoardSettingsModulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardSettingsModules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<BoardSettingsModulesQuery, BoardSettingsModulesQueryVariables>;
export const FetchSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentMember"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FetchSettingsQuery, FetchSettingsQueryVariables>;
export const MessageShareTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageShareToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<MessageShareTokenQuery, MessageShareTokenQueryVariables>;